function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

import * as React from 'react';
import React__default, { useRef, useState, useEffect } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import moment from 'moment';
import * as FlexmonsterReact from 'react-flexmonster';
import axios from 'axios';
import 'flexmonster/flexmonster.min.css';

___$insertStyle("*,\n::after,\n::before {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  width: 100%;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-qdm-color: transparent;\n}\n\n@-ms-viewport {\n  width: device-width;\n}\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple qdm-Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  width: 100%;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  qdm-color: #212529;\n  text-align: left;\n  background-qdm-color: #fff;\n}\n\n.qdm-container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .qdm-container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .qdm-container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .qdm-container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .qdm-container {\n    max-width: 1140px;\n  }\n}\n.qdm-container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.qdm-col-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 0px !important;\n}\n\n.qdm-col,\n.qdm-col-1,\n.qdm-col-10,\n.qdm-col-11,\n.qdm-col-12,\n.qdm-col-2,\n.qdm-col-3,\n.qdm-col-4,\n.qdm-col-5,\n.qdm-col-6,\n.qdm-col-7,\n.qdm-col-8,\n.qdm-col-9,\n.qdm-col-auto,\n.qdm-col-lg,\n.qdm-col-lg-1,\n.qdm-col-lg-10,\n.qdm-col-lg-11,\n.qdm-col-lg-12,\n.qdm-col-lg-2,\n.qdm-col-lg-3,\n.qdm-col-lg-4,\n.qdm-col-lg-5,\n.qdm-col-lg-6,\n.qdm-col-lg-7,\n.qdm-col-lg-8,\n.qdm-col-lg-9,\n.qdm-col-lg-auto,\n.qdm-col-md,\n.qdm-col-md-1,\n.qdm-col-md-10,\n.qdm-col-md-11,\n.qdm-col-md-12,\n.qdm-col-md-2,\n.qdm-col-md-3,\n.qdm-col-md-4,\n.qdm-col-md-5,\n.qdm-col-md-6,\n.qdm-col-md-7,\n.qdm-col-md-8,\n.qdm-col-md-9,\n.qdm-col-md-auto,\n.qdm-col-sm,\n.qdm-col-sm-1,\n.qdm-col-sm-10,\n.qdm-col-sm-11,\n.qdm-col-sm-12,\n.qdm-col-sm-2,\n.qdm-col-sm-3,\n.qdm-col-sm-4,\n.qdm-col-sm-5,\n.qdm-col-sm-6,\n.qdm-col-sm-7,\n.qdm-col-sm-8,\n.qdm-col-sm-9,\n.qdm-col-sm-auto,\n.qdm-col-xl,\n.qdm-col-xl-1,\n.qdm-col-xl-10,\n.qdm-col-xl-11,\n.qdm-col-xl-12,\n.qdm-col-xl-2,\n.qdm-col-xl-3,\n.qdm-col-xl-4,\n.qdm-col-xl-5,\n.qdm-col-xl-6,\n.qdm-col-xl-7,\n.qdm-col-xl-8,\n.qdm-col-xl-9,\n.qdm-col-xl-auto {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.qdm-col {\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.qdm-col-auto {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n}\n\n.qdm-col-1 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 8.333333%;\n  flex: 0 0 8.333333%;\n  max-width: 8.333333%;\n}\n\n.qdm-col-2 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 16.666667%;\n  flex: 0 0 16.666667%;\n  max-width: 16.666667%;\n}\n\n.qdm-col-3 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 25%;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.qdm-col-4 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 33.333333%;\n  flex: 0 0 33.333333%;\n  max-width: 33.333333%;\n}\n\n.qdm-col-5 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 41.666667%;\n  flex: 0 0 41.666667%;\n  max-width: 41.666667%;\n}\n\n.qdm-col-6 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.qdm-col-7 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 58.333333%;\n  flex: 0 0 58.333333%;\n  max-width: 58.333333%;\n}\n\n.qdm-col-8 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 66.666667%;\n  flex: 0 0 66.666667%;\n  max-width: 66.666667%;\n}\n\n.qdm-col-9 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 75%;\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.qdm-col-10 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 83.333333%;\n  flex: 0 0 83.333333%;\n  max-width: 83.333333%;\n}\n\n.qdm-col-11 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 91.666667%;\n  flex: 0 0 91.666667%;\n  max-width: 91.666667%;\n}\n\n.qdm-col-12 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n@media (min-width: 576px) {\n  .qdm-col-sm {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .qdm-col-sm-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n\n  .qdm-col-sm-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  .qdm-col-sm-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  .qdm-col-sm-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .qdm-col-sm-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  .qdm-col-sm-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  .qdm-col-sm-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .qdm-col-sm-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  .qdm-col-sm-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  .qdm-col-sm-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .qdm-col-sm-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  .qdm-col-sm-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  .qdm-col-sm-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-sm-first {\n    -webkit-box-ordinal-group: 0;\n    -ms-flex-order: -1;\n    order: -1;\n  }\n\n  .order-sm-last {\n    -webkit-box-ordinal-group: 14;\n    -ms-flex-order: 13;\n    order: 13;\n  }\n\n  .order-sm-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .order-sm-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .order-sm-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .order-sm-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .order-sm-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .order-sm-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .order-sm-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .order-sm-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .order-sm-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .order-sm-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .order-sm-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .order-sm-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .order-sm-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.333333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.666667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.333333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.666667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.333333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.666667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.333333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media (min-width: 768px) {\n  .qdm-col-md {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .qdm-col-md-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n\n  .qdm-col-md-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  .qdm-col-md-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  .qdm-col-md-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .qdm-col-md-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  .qdm-col-md-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  .qdm-col-md-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .qdm-col-md-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  .qdm-col-md-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  .qdm-col-md-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .qdm-col-md-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  .qdm-col-md-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  .qdm-col-md-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-md-first {\n    -webkit-box-ordinal-group: 0;\n    -ms-flex-order: -1;\n    order: -1;\n  }\n\n  .order-md-last {\n    -webkit-box-ordinal-group: 14;\n    -ms-flex-order: 13;\n    order: 13;\n  }\n\n  .order-md-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .order-md-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .order-md-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .order-md-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .order-md-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .order-md-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .order-md-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .order-md-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .order-md-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .order-md-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .order-md-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .order-md-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .order-md-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.333333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.666667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.333333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.666667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.333333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.666667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.333333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media (min-width: 992px) {\n  .qdm-col-lg {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .qdm-col-lg-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n\n  .qdm-col-lg-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  .qdm-col-lg-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  .qdm-col-lg-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .qdm-col-lg-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  .qdm-col-lg-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  .qdm-col-lg-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .qdm-col-lg-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  .qdm-col-lg-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  .qdm-col-lg-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .qdm-col-lg-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  .qdm-col-lg-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  .qdm-col-lg-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-lg-first {\n    -webkit-box-ordinal-group: 0;\n    -ms-flex-order: -1;\n    order: -1;\n  }\n\n  .order-lg-last {\n    -webkit-box-ordinal-group: 14;\n    -ms-flex-order: 13;\n    order: 13;\n  }\n\n  .order-lg-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .order-lg-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .order-lg-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .order-lg-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .order-lg-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .order-lg-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .order-lg-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .order-lg-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .order-lg-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .order-lg-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .order-lg-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .order-lg-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .order-lg-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.333333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.666667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.333333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.666667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.333333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.666667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.333333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .qdm-col-xl {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .qdm-col-xl-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n\n  .qdm-col-xl-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n  }\n\n  .qdm-col-xl-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n  }\n\n  .qdm-col-xl-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .qdm-col-xl-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n  }\n\n  .qdm-col-xl-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n  }\n\n  .qdm-col-xl-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .qdm-col-xl-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n  }\n\n  .qdm-col-xl-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n  }\n\n  .qdm-col-xl-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .qdm-col-xl-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n  }\n\n  .qdm-col-xl-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n  }\n\n  .qdm-col-xl-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xl-first {\n    -webkit-box-ordinal-group: 0;\n    -ms-flex-order: -1;\n    order: -1;\n  }\n\n  .order-xl-last {\n    -webkit-box-ordinal-group: 14;\n    -ms-flex-order: 13;\n    order: 13;\n  }\n\n  .order-xl-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .order-xl-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .order-xl-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .order-xl-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .order-xl-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .order-xl-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .order-xl-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .order-xl-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .order-xl-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .order-xl-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .order-xl-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .order-xl-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .order-xl-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.333333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.666667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.333333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.666667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.333333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.666667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.333333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.666667%;\n  }\n}\n@media (min-width: 0px) {\n  .PrivateHiddenCss-xsUp {\n    display: none;\n  }\n}\n@media (max-width: 575.95px) {\n  .PrivateHiddenCss-xsDown {\n    display: none;\n  }\n}\n@media (max-width: 575.95px) and (min-width: 0px) {\n  .PrivateHiddenCss-onlyxs {\n    display: none;\n  }\n}\n@media (min-width: 576px) {\n  .PrivateHiddenCss-smUp {\n    display: none;\n  }\n}\n@media (max-width: 991.95px) {\n  .PrivateHiddenCss-smDown {\n    display: none;\n  }\n}\n@media (max-width: 991.95px) and (min-width: 576px) {\n  .PrivateHiddenCss-onlysm {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .PrivateHiddenCss-mdUp- {\n    display: none;\n  }\n}\n@media (max-width: 1199.95px) {\n  .PrivateHiddenCss-mdDown {\n    display: none;\n  }\n}\n@media (min-width: 1200px) {\n  .PrivateHiddenCss-lgUp {\n    display: none;\n  }\n}\n@media (max-width: 1919.95px) {\n  .PrivateHiddenCss-lgDown {\n    display: none;\n  }\n}\n@media (min-width: 1920px) {\n  .PrivateHiddenCss-xlUp {\n    display: none;\n  }\n}\n@media (min-width: 0px) {\n  .PrivateHiddenCss-xlDown {\n    display: none;\n  }\n}\n.circul-loader {\n  border: 6px solid #f3f3f3;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  -webkit-animation: spin 1s linear infinite;\n  animation: spin 1s linear infinite;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.qdm-checkbox-icon {\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n}\n\n.qdm-dialogtitle {\n  fill: currentColor;\n  height: 2em;\n  font-size: 1.5rem;\n  top: 8px;\n  color: #9e9e9e;\n  right: 8px;\n  position: absolute;\n  padding: 12px;\n  cursor: pointer;\n}\n\n.qdm-radiobutton-icon {\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n}\n\n.qdm-radiobutton-icon-filled {\n  position: absolute;\n  transform: scale(1);\n  transition: transform 150ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n}\n\n@keyframes increase {\n  from {\n    left: -5%;\n    width: 5%;\n  }\n  to {\n    left: 100%;\n    width: 100%;\n  }\n}\n\n@keyframes decrease {\n  from {\n    left: -80%;\n    width: 80%;\n  }\n  to {\n    left: 100%;\n    width: 10%;\n  }\n}\n\n.qdm-multiselect-isactive {\n  background-color: #eee !important;\n  font-weight: 600;\n}\n\n.qdm-select-div {\n  cursor: pointer;\n  padding: 6px;\n  position: absolute;\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 10000000 !important;\n  background: #fff;\n  box-shadow: 0px 1px 3px 2px #21252933;\n  margin-top: 0px;\n  max-height: 225px;\n  font-size: 14px;\n  max-width: 100%;\n}\n.qdm-select-div .actives {\n  z-index: 10000000 !important;\n  background: #fff !important;\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  line-height: 34px;\n  padding: 0 8px;\n}\n.qdm-select-div .qdm-select-options {\n  z-index: 10000000 !important;\n  background: #eee !important;\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  line-height: 34px;\n  padding: 0 8px;\n}\n.qdm-select-div .own-qdm-select-loader {\n  display: flex !important;\n  width: 50px !important;\n  height: 100% !important;\n  object-fit: scale-down !important;\n}\n.qdm-select-div .qdm-select-loader {\n  border-bottom: 3px solid #f3f3f3;\n  border-right: 3px solid #f3f3f3;\n  border-left: 3px solid #f3f3f3;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  -webkit-animation: spin 1s linear infinite;\n  animation: spin 1s linear infinite;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.qdm-select-div1 {\n  cursor: pointer;\n  padding: 6px;\n  position: absolute;\n  z-index: 10000000 !important;\n  background: #fff;\n  box-shadow: 0px 1px 3px 2px #21252933;\n  margin-top: 0px;\n  max-height: 225px;\n  font-size: 14px;\n  max-width: 100%;\n}\n.qdm-select-div1 .actives {\n  z-index: 10000000 !important;\n  background: #fff !important;\n  cursor: pointer;\n  width: max-content;\n  position: relative;\n  line-height: 33px;\n  padding: 0px 10px 0px 0px;\n}\n.qdm-select-div1 .qdm-select-options {\n  z-index: 10000000 !important;\n  background: #eee !important;\n  cursor: pointer;\n  width: max-content;\n  position: relative;\n  line-height: 37px;\n  padding: 0 10px 0px 0px;\n}\n.qdm-select-div1 .own-qdm-select-loader {\n  display: flex !important;\n  width: 50px !important;\n  height: 100% !important;\n  object-fit: scale-down !important;\n}\n.qdm-select-div1 .qdm-select-loader {\n  border-bottom: 3px solid #f3f3f3;\n  border-right: 3px solid #f3f3f3;\n  border-left: 3px solid #f3f3f3;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  -webkit-animation: spin 1s linear infinite;\n  animation: spin 1s linear infinite;\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media (min-width: 426px) {\n  .qdm-select-div {\n    min-width: auto;\n  }\n}\n@media (min-width: 426px) {\n  .qdm-select-div1 {\n    min-width: auto;\n  }\n}\n.hidden_drawer {\n  display: none;\n}\n\n.open_drawer {\n  display: block;\n}\n\n.sidebar #leftside-navigation ul,\n.sidebar #leftside-navigation ul ul {\n  margin: -2px 0 0;\n  padding: 0;\n}\n\n.sidebar #leftside-navigation ul li {\n  list-style-type: none;\n}\n\n.sidebar #leftside-navigation ul li a span {\n  display: inline-block;\n}\n\n.sidebar #leftside-navigation ul li a i,\n.sidebar #leftside-navigation ul li a img,\n.sidebar #leftside-navigation ul li a svg {\n  width: 20px;\n  font-size: 17px;\n  margin-right: 8px;\n}\n\n.sidebar #leftside-navigation ul li a i .fa-angle-left,\n.sidebar #leftside-navigation ul li a i .fa-angle-right {\n  padding-top: 3px;\n}\n\n.sidebar #leftside-navigation ul ul {\n  display: none;\n}\n\n.pull-right {\n  float: right;\n  right: 0;\n  position: absolute;\n}\n\n.sidebar-header {\n  padding: 20px;\n  overflow: hidden;\n}\n\n.sidebar-header .user-pic {\n  float: left;\n  width: 60px;\n  height: 60px;\n  padding: 2px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.sidebar-header .user-pic img {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  border-radius: 6px;\n}\n\n.sidebar-header .user-info {\n  float: left;\n}\n\n.sidebar-header .user-info > span {\n  display: block;\n}\n\n.sidebar-header .user-info .user-role {\n  font-size: 12px;\n}\n\n.sidebar-header .user-info .user-status {\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n@keyframes appear {\n  0% {\n    opacity: 0.01;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.dot_Carousel {\n  cursor: pointer;\n  height: 10px;\n  width: 10px;\n  margin: 0 8px;\n  background-color: #cfcfcf;\n  border-radius: 50%;\n  display: inline-block;\n  transition: background-color 0.6s ease;\n}\n\n.active_Carousel {\n  background-color: #3f51b5;\n  height: 12px;\n  width: 12px;\n}\n\n.dot_Carousel:hover {\n  background-color: #3f51b5c4;\n}\n\n.select-dropdown,\n.select-dropdown * {\n  margin: 0;\n  padding: 0;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.select-dropdown {\n  position: relative;\n  border-radius: 4px;\n}\n\n.select-dropdown select {\n  font-size: 14px;\n  max-width: auto;\n  border: 1px solid #E6E6E6;\n  background-color: transparent;\n}\n\n.select-dropdown select:active,\n.select-dropdown select:focus {\n  outline: none;\n  box-shadow: none;\n}");

const StyledButton = styled.button `
border-radius: 3px;
font-size: 16px;
outline: none;
cursor: pointer;
padding:8px;
&:focus {
  box-shadow: -1px 2px 4px -2px #8492a6;
  color: #fff;
}
${props => props && css `
${(props) => {
    if (props.color) {
        return `
        color: ${props.color};
          `;
    }
    else {
        return `
        color:#fff;
        `;
    }
}}
${(props) => {
    if (props.backgroundColor) {
        return `
        background-color: ${props === null || props === void 0 ? void 0 : props.backgroundColor};
        border: 1px solid ${props === null || props === void 0 ? void 0 : props.backgroundColor};
          `;
    }
    else {
        return `
        background-color:#3f51b5;
        border: 1px solid #3f51b5;
        `;
    }
}}

${(props) => {
    if (props.size) {
        return `
        font-size: ${props === null || props === void 0 ? void 0 : props.size}px;
          `;
    }
}}

${(props) => {
    if (props.variant === "outlined") {
        return `
&:focus {
  
  color: #fff;
}
`;
    }
    else if (props.variant === "text") {
        return `
background: transparent;
background-color: transparent;
color: #000;
border: 1px solid transparent;
&:focus {
  color: #000;
  box-shadow: none;
}
&:hover {
  background-color: #9b9b9b21;
}
  `;
    }
}}
${(props) => {
    if (props.disabled) {
        return `
background-color:gray;
background:gray;
border: 1px solid gray;
  `;
    }
}}

`}

${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Button component
const Button$4 = (props) => {
    /* this is a props variables */
    const { name, children } = props;
    return React.createElement(StyledButton, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + "_button" }, props), children ? children : name);
};
// this is a default Props of the component
Button$4.defaultProps = {
    type: "button",
    variant: "outlined",
    name: "Button",
};

const ButtonProps = {
  type: ['button', 'submit', 'reset'],
  variant: ['text', 'outlined'],
  name: '',
};

const Lable = styled.p `
font-size:14px;
font-weight: 500;
margin:0;
${props => props && css `
${props => props.labelStyle ? { ...props.labelStyle } : ''}
`}
`;
const Input$b = styled.input `
outline: none;
width: 100%;
font-size: 14px;
box-sizing: border-box;
cursor: revert;
padding: 10px;

::-webkit-inner-spin-button{
  -webkit-appearance: none; 
  margin: 0; 
}
::-webkit-outer-spin-button{
  -webkit-appearance: none; 
  margin: 0; 
} 

${props => props && css `

${(props) => {
    if (props.size === "small") {
        return `
        height: 32px;   & input {
          padding:0px 0px 0px 8px;
      }
     `;
    }
    else {
        return `
        height:40px;
      & input {
    padding:10.5px 14px;
      }
`;
    }
}}
${(props) => {
    var _a;
    if ((props === null || props === void 0 ? void 0 : props.dateIcon) && ((_a = props === null || props === void 0 ? void 0 : props.dateIcon) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return `
    &[type="date"] {
      background:transparent url(${props === null || props === void 0 ? void 0 : props.dateIcon})  97% 50% no-repeat ;
    }
    &[type="date"]::-webkit-inner-spin-button {
      display: none;
    }
    &[type="date"]::-webkit-calendar-picker-indicator {
      opacity: 0;
    }
    `;
    }
}}

${(props) => {
    if (props.elevation === '1') {
        return `
        box-shadow: 0 3px 3px rgba(0,0,0,0.2);
            `;
    }
    else if (props.elevation === '2') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.15), 
        0 2px 2px rgba(0,0,0,0.15), 
        0 4px 4px rgba(0,0,0,0.15), 
        0 8px 8px rgba(0,0,0,0.15);
        `;
    }
    else if (props.elevation === '3') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
              0 2px 2px rgba(0,0,0,0.12), 
              0 4px 4px rgba(0,0,0,0.12), 
              0 8px 8px rgba(0,0,0,0.12),
              0 16px 16px rgba(0,0,0,0.12);
        `;
    }
    else if (props.elevation === '4') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.11), 
              0 2px 2px rgba(0,0,0,0.11), 
              0 4px 4px rgba(0,0,0,0.11), 
              0 8px 8px rgba(0,0,0,0.11), 
              0 16px 16px rgba(0,0,0,0.11), 
              0 32px 32px rgba(0,0,0,0.11);
        `;
    }
    else {
        return `
        box-shadow:none;
        `;
    }
}}

    ${(props) => {
    if (!props.disabled && !props.error && props.variant === 'outlined') {
        return `
border-radius: 4px;
background-color:transparent;
border: 1px solid ${props.borderColor};
&:hover{
border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
}
&:focus{
  border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
}}
&::placeholder {
color: #9b9b9b;`;
    }
    else if (!props.disabled && props.error && props.variant === 'outlined') {
        return `
border-radius: 4px;
background-color:transparent;
border: 1px solid ${(props.helperTextType === "error" && 'red') ||
            (props.helperTextType === "warning" && '#FFCC00') ||
            (props.helperTextType === "success" && 'green')};
`;
    }
    else if (!props.disabled && !props.error && props.variant === 'standard') {
        return `
border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.borderColor};
border-right:unset;
border-radius: 0px; 
border-top: 0px;
border-left:unset;

&:hover{
border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
border-right:unset;
border-radius: 0px;
border-top: 0px; 
border-left:unset;
}
&:focus{
border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
border-right:unset;
border-radius: 0px;
border-top: 0px;
border-left:unset;
}

&::placeholder {
color: #9b9b9b;
}
`;
    }
    else if (!props.disabled && props.error && props.variant === 'standard') {
        return `
border-bottom: 1px solid red;
border-right:unset;
border-radius: 0px;
border-top: 0px;
border-left:unset;
border-bottom: 1px solid ${(props.helperTextType === "error" && 'red') ||
            (props.helperTextType === "warning" && '#FFCC00') ||
            (props.helperTextType === "success" && 'green')};
`;
    }
    else if (props.variant === "none") {
        return `
border:0;
&:focus{
border:0;
outline: none;
}
`;
    }
}}

 ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const HelperText$3 = styled.p `
margin: 0;
padding: 0px 4px;
font-size: 12px;
${props => props && css `
${props.helperTextStyle && { ...props.helperTextStyle }}
${(props) => {
    if (props.helperTextType === "error") {
        return `
color:red;
`;
    }
    else if (props.helperTextType === "warning") {
        return `
color:#FFCC00;
`;
    }
    else if (props.helperTextType === "success") {
        return `
color:green
`;
    }
    else {
        return `
color:gray;
`;
    }
}}
`}
`;
const TextField$1 = styled.div `
display: flex;
flex-flow: wrap;
cursor: revert;
position: relative;
width: 100%;
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
const Close$3 = styled.div `
top: 52%;
/* transform: translateY(-60%); */
margin-right: 12px;
position: absolute;
display: block;
right: 24px;
width: 16px;
height: 16px;
cursor: pointer;
& img {
height: 100%;
width: 100%;
object-fit: cover;
}
`;
const Search = styled.div `
top: 52%;
/* transform: translateY(-60%); */
margin-right: 12px;
position: absolute;
display: block;
right: 0px;
width: 16px;
height: 16px;
cursor: pointer;
& img {
height: 100%;
width: 100%;
object-fit: cover;
}
`;
const CloaseComponent = styled.div `
position: relative;
width: 100%;
`;
const Star$5 = styled.span `
color:red;
margin-left: 5px;
`;
const IconTextDiv = styled.div `
top: 52%;
/* transform: translateY(-60%); */
margin-right: 12px;
position: absolute;
display: block;
right: 0px;
/* width: 16px;
height: 16px; */
`;
const IconLabel = styled.p `
margin:0;
font-size: 12px;
color: #B6B6B6;
${props => props.iconTextStyle ? { ...props.iconTextStyle } : ''}
`;

// This is a Text Input component
const TextInput = (props) => {
    /* this is a props variables */
    const { allowClear, onChangeClear, size, search, value, Icon, onClick, labelWidth, label, isRequired, labelStyle, iconText, required } = props;
    // this is a state of handling variables
    const [inputfocus, setinputfocus] = React.useState(false);
    // end
    // this is a delet Value or clear value funcy
    const deletValue = () => {
        onChangeClear && onChangeClear('');
    };
    // end
    // this is a on focus input field funcy
    const focus = () => {
        setinputfocus && setinputfocus(!inputfocus);
    };
    const funcfocus = (e) => {
        !inputfocus && focus();
        onClick && onClick(e);
    };
    const handleChange = (e) => {
        var _a, _b, _c, _d;
        if ((props === null || props === void 0 ? void 0 : props.maxLength) && ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) <= (props === null || props === void 0 ? void 0 : props.maxLength) || (props === null || props === void 0 ? void 0 : props.minLength) && ((_d = (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) <= (props === null || props === void 0 ? void 0 : props.minLength)) {
            (props === null || props === void 0 ? void 0 : props.onChange) && props.onChange(e);
        }
    };
    // end
    return (React.createElement(TextField$1, { width: props === null || props === void 0 ? void 0 : props.width, inLineStyles: props.inLineStyles, id: props.id, className: props.className },
        React.createElement(CloaseComponent, { id: (props === null || props === void 0 ? void 0 : props.id) + '_parent_div' },
            search && React.createElement(Search, { size: props.size },
                " ",
                React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "search", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                    React.createElement("path", { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" }))),
            iconText &&
                React.createElement(IconTextDiv, null,
                    React.createElement(IconLabel, { iconTextStyle: props.iconTextStyle }, iconText)),
            ((allowClear) && (value)) && React.createElement(Close$3, { size: props.size, onClick: () => deletValue() }, Icon ? Icon :
                React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "close-circle", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                    React.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" }))),
            label && React.createElement(Lable, { id: (props === null || props === void 0 ? void 0 : props.id) + '_p', labelWidth: labelWidth && labelWidth, value: value && value, size: size && size, labelStyle: labelStyle && labelStyle, autoFocus: inputfocus ? inputfocus : props.autoFocus ? props.autoFocus : false },
                label,
                (required || isRequired) && React.createElement(Star$5, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' }, "*")),
            React.createElement(Input$b, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + '_input', className: '', onClick: (e) => funcfocus(e), autoFocus: inputfocus ? true : props.autoFocus ? props.autoFocus : false, onBlur: () => inputfocus && focus(), hoverColor: props === null || props === void 0 ? void 0 : props.hoverColor, onChange: (e) => handleChange(e), required: required || isRequired }, props))),
        "   ",
        (props.helperText && props.error) && (React.createElement(HelperText$3, { helperTextType: props.helperTextType, helperTextStyle: props.helperTextStyle, error: props === null || props === void 0 ? void 0 : props.error }, props.helperText && props.helperText))));
};
// this is a default Props of the component
TextInput.defaultProps = {
    type: "text",
    name: "text",
    variant: "outlined",
    helperTextType: "error",
    label: "",
    autoFocus: false,
    autoComplete: 'off',
    search: false,
    borderColor: '#9b9b9b',
    elevation: "0",
    placeholder: 'text field',
    size: 'medium',
    isRequired: false,
    required: false,
    hoverColor: '#000',
    dateIcon: '',
    maxLength: 100,
    iconText: '',
    minLength: 100
};

const TextInputProps = {
  type: '',
  name: '',
  variant: ['standard', 'outlined', 'none'],
  helperTextType: ['error', 'warning', 'success'],
  label: '',
  autoFocus: false,
  autoComplete: '',
  search: false,
  borderColor: '#000',
  elevation: ['0', '1', '2', '3', '4'],
  placeholder: '',
  size: ['small', 'medium'],
  isRequired: false,
  hoverColor: '#000',
  dateIcon: '',
  maxLength: 0,
  iconText: '',
  minLength: 0
};

const ColEle = styled.div `
    ${props => props && css `
    ${(props) => {
    if (props.justify) {
        return `
            justify-content: ${props.justify};
             `;
    }
}}
         ${(props) => {
    if (props.justify === "flex-end") {
        return `
           text-align: right !important;
             `;
    }
    else if (props.justify === "center") {
        return `
           text-align: center !important;
             `;
    }
}}
        ${(props) => {
    if (props.alignItems) {
        return `
                align-items: ${props.alignItems};
                 `;
    }
}}
            ${(props) => {
    if (props.textAlign) {
        return `
                    text-align: ${props.textAlign};
                     `;
    }
}}
                ${(props) => {
    if (props.direction) {
        return `
                        flex-direction: ${props.direction};
                         `;
    }
}}
    `} 
    ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Col component
const Col = (props) => {
    /* this is a props variables */
    const { row, lg, sm, xs, md, className } = props;
    // end
    return (React__default.createElement(ColEle, Object.assign({}, props, { className: `${`qdm-col-lg-${lg}`} ${`qdm-col-md-${md}`} ${`qdm-col-sm-${sm}`} ${`qdm-col-${xs}`} ${className ? className : ""}` }), props.children));
};
// this is a default Props of the component
Col.defaultProps = {
    name: "qdm-col-12",
    alignItems: 'stretch',
    direction: 'row',
    justify: 'flex-start',
    textAlign: 'left',
    lg: 12,
    xs: 12,
    md: 12,
    sm: 12,
};

const ColProps = {
  name: '',
  alignItems: ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'],
  direction: ['row', 'row-reverse', 'column', 'column-reverse'],
  justify: ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'],
  textAlign: ['center', 'right', 'left'],
  lg: 0,
  xs: 0,
  md: 0,
  sm: 0,
};

const LinkEle$1 = styled.a `
color: #3f51b5;
margin: 0 0.5em;
cursor:pointer;
&:hover{
text-decoration: underline;
}
 ${props => props && css `
  ${(props) => {
    if (props.color === "inherit") {
        return `
color:inherit;
`;
    }
    else if (props.color === "primary") {
        return `
color:#3f51b5;
`;
    }
    else if (props.color === "secondary") {
        return `
color:#f50057;
`;
    }
    else if (props.color === "textPrimary") {
        return `
color: rgba(0, 0, 0, 0.87);
`;
    }
    else if (props.color === "textSecondary") {
        return `
color: rgba(0, 0, 0, 0.54);
`;
    }
    else if (props.color === "error") {
        return `
color: #f44336;
`;
    }
}}
${(props) => {
    if (props.underline === "always") {
        return `
text-decoration: underline;
`;
    }
    else if (props.underline === "none") {
        return `
text-decoration: none;
`;
    }
}}
        ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;

// This is a Link component
const Link = (props) => {
    /* this is a props variables */
    const { children, name } = props;
    return (React__default.createElement(LinkEle$1, Object.assign({}, props), children ? children : name));
};
// this is a default Props of the component
Link.defaultProps = {
    underline: "always",
    color: "primary",
    name: "Link"
};

const LinkProps = {
  underline: ['none', 'hover', 'always'],
  color: ['inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error'],
  name: '',
};

const AlertEle = styled.div `
font-weight: 500;
display: flex;
padding: 12px 0px 12px;
font-size: 0.875rem;
line-height: 1.43;
border-radius: 4px;
letter-spacing: 0.01071em;
z-index: 100;
    ${props => props && css `
        ${(props) => {
    if (props.severity === "error" && props.variant === "standard") {
        return `
background-color: rgb(253, 236, 234); `;
    }
    else if (props.severity === "warning" && props.variant === "standard") {
        return `
background-color: rgb(255, 244, 229); `;
    }
    else if (props.severity === "info" && props.variant === "standard") {
        return `
background-color: rgb(232, 244, 253); `;
    }
    else if (props.severity === "success" && props.variant === "standard") {
        return `
background-color: rgb(237, 247, 237); `;
    }
}}
            ${(props) => {
    if (props.severity === "error") {
        return `
color:rgb(97, 26, 21); `;
    }
    else if (props.severity === "warning") {
        return `
color:rgb(102, 60, 0); `;
    }
    else if (props.severity === "info") {
        return `
color:rgb(13, 60, 97); `;
    }
    else if (props.severity === "success") {
        return `
color:rgb(30, 70, 32); `;
    }
    else {
        return `
color: #fff; `;
    }
}}
        ${(props) => {
    if (props.severity === "error" && props.variant === "filled") {
        return `
color:#fff;
background-color: #f44336; `;
    }
    else if (props.severity === "warning" && props.variant === "filled") {
        return `
color:#fff;
background-color: #ff9800; `;
    }
    else if (props.severity === "success" && props.variant === "filled") {
        return `
color:#fff;
background-color: #4caf50;  `;
    }
    else if (props.severity === "info" && props.variant === "filled") {
        return `
color:#fff;
background-color: #2196f3; `;
    }
}}
        ${(props) => {
    if (props.severity === "error" && props.variant === "outlined") {
        return `
color:rgb(97, 26, 21);
border: 1px solid #f44336; `;
    }
    else if (props.severity === "warning" && props.variant === "outlined") {
        return `
color:rgb(102, 60, 0);
border:1px solid  #ff9800;  `;
    }
    else if (props.severity === "success" && props.variant === "outlined") {
        return `
color:rgb(30, 70, 32);
border:1px solid #4caf50;   `;
    }
    else if (props.severity === "info" && props.variant === "outlined") {
        return `
color:rgb(13, 60, 97);
border:1px solid  #2196f3; `;
    }
}}
        ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
const AlertClose = styled.div `
display: flex;
align-items: center;
margin-left: auto;
padding-right: 16px;
cursor:pointer;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
${(props) => {
    if (props.severity === "success" || props.severity === "error" || props.severity === "info" || props.severity === "warning") {
        return `
color:#fff;
        `;
    }
    else {
        return `
color:#000;
        `;
    }
}}
`}
`;
const AlertText = styled.div `
padding:0px 12px;
${props => props && css `
${props.inLineAlertTextStyles && { ...props.inLineAlertTextStyles }}
${(props) => {
    `
color: ${props.color ? props.color : ""};
`;
}}
`}
`;
const Icon$1 = styled.div `
padding:0px 0px 0px  12px;
& svg{
margin-bottom:-3px;
}
${props => props && css `
${props.inLineAlertCloseStyles && { ...props.inLineAlertCloseStyles }}
${(props) => {
    if (props.variant === "filled") {
        return `
& svg{
fill:#fff;
}
`;
    }
    else {
        return `
& svg{
color:#000;
}
`;
    }
}}
${(props) => {
    if (props.variant === "standard") {
        return `
& svg{
fill:#4caf50;
}
`;
    }
    else {
        return `
& svg{
color:#000;
}
`;
    }
}}
`}
`;

// This a Alert component
const Alert = (props) => {
    /* this is a props variables */
    const { name, children, severity, color, variant, inLineAlertTextStyles, inLineAlertCloseStyles, onClose, icon } = props;
    // This is a SERVER type based on icons(image) funcy
    const severityTypeBasedIcons = () => {
        if (severity === "success") {
            return React__default.createElement("svg", { width: "21", height: "21", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                React__default.createElement("path", { d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" }));
        }
        else if (severity === "error") {
            return React__default.createElement("svg", { width: "21", height: "21", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                React__default.createElement("path", { d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }));
        }
        else if (severity === "warning") {
            return React__default.createElement("svg", { width: "21", height: "21", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                React__default.createElement("path", { d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" }));
        }
        else if (severity === "info") {
            return React__default.createElement("svg", { width: "21", height: "21", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                React__default.createElement("path", { d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z" }));
        }
    };
    return (React__default.createElement(AlertEle, Object.assign({}, props),
        React__default.createElement(Icon$1, { variant: variant, inLineAlertCloseStyles: inLineAlertCloseStyles },
            icon ? icon : severityTypeBasedIcons(),
            " "),
        React__default.createElement(AlertText, { inLineAlertTextStyles: inLineAlertTextStyles && inLineAlertTextStyles, color: color && color }, children ? children : name),
        onClose && React__default.createElement(AlertClose, { severity: severity, inLineAlertCloseStyles: inLineAlertCloseStyles && inLineAlertCloseStyles, onClick: (e) => onClose(e) }, "\u2613")));
};
// this is a default Props of the component
Alert.defaultProps = {
    severity: "success",
    variant: "filled",
    name: "This is an alert !"
};

const AlertProps = {
  severity: ['error', 'info', 'success', 'warning'],
  variant: ['filled', 'outlined', 'standard'],
  name: '',
};

const DividerEle = styled.hr `
border: none;
height: 1px;
width: -webkit-fill-available;
margin: 0;
flex-shrink: 0;
${props => props && css `
   ${(props) => {
    if (props.variant === "inset") {
        return `
                margin-left: 72px;
            `;
    }
    if (props.variant === "middle") {
        return `
                margin-left: 16px;
                margin-right: 16px;
            `;
    }
}}
    ${(props) => {
    if (props.absolute) {
        return `
                left: 0;
                width: 100%;
                bottom: 0;
                position: absolute;
            `;
    }
}}
    ${(props) => {
    if (props.light) {
        return `
                background-color: rgba(0, 0, 0, 0.12);
            `;
    }
    else {
        return `
                background-color: rgba(0, 0, 0, 0.12);
            `;
    }
}}
    ${(props) => {
    if (props.borderColor) {
        return `
                background-color: ${props.borderColor};
            `;
    }
}}
    ${(props) => {
    if (props.orientation === "vertical") {
        return `
            width: 1px; 
            height: 100%;
            margin-right: 14px;
            margin-left: 14px;
        `;
    }
}}
    ${(props) => {
    if (props.orientation === "horizontal") {
        return `
            margin-top: 14px;
            margin-bottom: 14px;
        `;
    }
}}
    ${(props) => {
    if (props.borderWidth) {
        return `
            height: ${props.borderWidth}px;
        `;
    }
}}
    ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
// all this below components for the divder with text
// row styled components
const Row$5 = styled.div `
    flex-direction: row;
    align-items: center;
    display: flex;
`;
// text styled components 
const LableText = styled.p `
    text-align: center;
    min-width: 30px;
    margin-right:20px;
    margin-left:20px;
    ${(props) => {
    if (props.textWidth) {
        return `
            width:${props.textWidth}px;
        `;
    }
}}
    ${(props) => {
    if (props.textColor) {
        return `
            color:${props.textColor};
        `;
    }
}}
    ${(props) => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
// line styled components
const Line = styled.div `
    flex: 1;
    height: 1px;
    ${(props) => {
    if (props.borderWidth) {
        return `
            height: ${props.borderWidth}px;
        `;
    }
}}
    ${(props) => {
    if (props.borderColor) {
        return `
            background-color: ${props.borderColor};
        `;
    }
}}
    ${(props) => {
    if (props.marginAll) {
        return `
            margin:${props.marginAll}px;
        `;
    }
}}
    ${(props) => {
    if (props.marginLR) {
        return `
            margin-left:${props.marginLR}px;
            margin-right:${props.marginLR}px;
        `;
    }
}}
    ${(props) => {
    if (props.marginTB) {
        return `
            margin-top:${props.marginTB}px;
            margin-bottom:${props.marginTB}px;
        `;
    }
}}
`;

// This a Divider component
const Divider$3 = (props) => {
    const { onClick } = props;
    const openProperties = (e) => onClick && onClick(e);
    return props.label && props.label.length > 0 ? (React__default.createElement(Row$5, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', onClick: openProperties },
        React__default.createElement(Line, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' }, props)),
        React__default.createElement(LableText, Object.assign({}, props), props.label),
        React__default.createElement(Line, Object.assign({}, props)))) : (React__default.createElement(DividerEle, Object.assign({}, props)));
};
// this is a default Props of the component
Divider$3.defaultProps = {
    textWidth: 50,
    textColor: '#000',
    borderColor: 'lightgray',
    borderWidth: 1,
    orientation: 'horizontal',
    variant: 'middle',
};

const DividerProps = {
  textWidth: 0,
  textColor: '#000',
  borderColor: '#000',
  borderWidth: 1,
  orientation: ['horizontal', 'vertical'],
  variant: ['fullWidth', 'inset', 'middle'],
};

const Div$g = styled.div ``;
const Span$e = styled.span `padding:0px 10px;`;
const SnackbarEle = styled.div `
left: 8px;
right: 8px;
display: flex;
z-index: 1400;
border-radius:4px;
align-items: center;
  ${props => props && css `
        ${(props) => {
    if (!props.onClose) {
        return `
justify-content: flex-start;
 `;
    }
}}
        ${(props) => {
    if (!props.action) {
        return `
 color:#fff;
 width:auto;
 background-color:rgb(49, 49, 49); box-shadow:0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12);
        `;
    }
}}
        ${(props) => {
    if (props.anchorOrigin.vertical === "bottom" && props.anchorOrigin.horizontal === "left") {
        return `
 bottom: 8px;
 position: fixed;
 left: 24px;
 right: auto;
 bottom: 24px;
          `;
    }
    else if (props.anchorOrigin.vertical === "bottom" && props.anchorOrigin.horizontal === "right") {
        return `
 bottom: 8px;
 position: fixed;
 left: auto;
 right: 24px;
 bottom: 24px;
        `;
    }
    else if (props.anchorOrigin.vertical === "bottom" && props.anchorOrigin.horizontal === "center") {
        return `
 bottom: 24px;
 left: 50%;
 position: fixed;
 right: auto;
 transform: translateX(-50%);
`;
    }
}}

  ${(props) => {
    if (props.anchorOrigin.vertical === "top" && props.anchorOrigin.horizontal === "left") {
        return `
top: 8px;
left: 24px;
position: fixed;
right: auto;
`;
    }
    else if (props.anchorOrigin.vertical === "top" && props.anchorOrigin.horizontal === "right") {
        return `
top: 8px;
left: auto;
position: fixed;
right: 24px;
`;
    }
    else if (props.anchorOrigin.vertical === "top" && props.anchorOrigin.horizontal === "center") {
        return `
 top: 24px;
 left: 50%;
 position: fixed;
 right: auto;
 transform: translateX(-50%);
`;
    }
}}
        ${props.inLineStyles && { ...props.inLineStyles }}
            `}
        `;
const SnackbarClose = styled.div `
display: flex;
align-items: center;
margin-left: auto;
padding: 11px;
cursor:pointer;
${props => props && css `
${props.inLineSnackbarCloseStyles && { ...props.inLineSnackbarCloseStyles }}
${(props) => {
    if (props.inLineSnackbarCloseColor) {
        return `
color:${props.inLineSnackbarCloseColor};
`;
    }
    else if (props.action) {
        return `
color:#000;
`;
    }
    else {
        return `
color:#fff;
`;
    }
}}
`}
`;

// This is a Snackbar component
const Snackbar = (props) => {
    /* this is a props variables */
    const { open, action, autoHideDuration, message, onClose, children, inLineSnackbarCloseColor, inLineSnackbarCloseStyles } = props;
    if (open) {
        // once open the slackbar component autoHideDuration within 5 seconds funcy
        setTimeout(onClose && onClose(""), autoHideDuration ? autoHideDuration : 5000);
    }
    return (React__default.createElement(Div$g, null, open && React__default.createElement(SnackbarEle, Object.assign({}, props),
        children ? children : action ? action : message ? React__default.createElement(Span$e, null, message) : React__default.createElement(Span$e, null, "Note archived"),
        onClose && React__default.createElement(SnackbarClose, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', inLineSnackbarCloseStyles: inLineSnackbarCloseStyles && inLineSnackbarCloseStyles, inLineSnackbarCloseColor: inLineSnackbarCloseColor && inLineSnackbarCloseColor, action: action && action, onClick: (e) => onClose(e) }, "\u2716"))));
};
// this is a default Props of the component
Snackbar.defaultProps = {
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
    }
};

const SnackbarProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
};

const SPAN = styled.span `
font-size: 0.875rem;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
font-weight: 400;
line-height: 1.43;
letter-spacing: 0.01071em;
text-align: left;
${props => props && css `
  ${(props) => {
    if (props.align) {
        return `
text-align : ${props.align}
`;
    }
    if (props.variant === "caption") {
        return `
text-transform: uppercase;
`;
    }
    if (props.noWrap) {
        return `
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
`;
    }
    if (props.ellipsisRow) {
        return `
overflow: hidden;
text-overflow: ellipsis;
-webkit-line-clamp: ${props.ellipsisRow};
display: -webkit-box;
-webkit-box-orient: vertical;
`;
    }
}}
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const H1elem = styled.h1 `
font-size: 6rem;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
font-weight: 300;
line-height: 1.167;
letter-spacing: -0.01562em;   
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const H2elem = styled.h2 `
font-size: 3.75rem;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
font-weight: 300;
line-height: 1.2;
letter-spacing: -0.00833em; 
${props => props && css `
${(props) => {
    if (props.align) {
        return `
text-align : ${props.align}
`;
    }
    if (props.variant === "caption") {
        return `
text-transform: uppercase;
`;
    }
    if (props.noWrap) {
        return `
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
`;
    }
    if (props.ellipsisRow) {
        return `
overflow: hidden;
text-overflow: ellipsis;
-webkit-line-clamp: ${props.ellipsisRow};
display: -webkit-box;
-webkit-box-orient: vertical;
`;
    }
}}
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const H6elem = styled.h6 `
font-size: 1.25rem;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
font-weight: 500;
line-height: 1.6;
letter-spacing: 0.0075em;
margin: auto;
${props => props && css `
${(props) => {
    if (props.align) {
        return `
text-align : ${props.align}
`;
    }
    if (props.variant === "caption") {
        return `
text-transform: uppercase;
`;
    }
    if (props.noWrap) {
        return `
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
`;
    }
    if (props.ellipsisRow) {
        return `
overflow: hidden;
text-overflow: ellipsis;
-webkit-line-clamp: ${props.ellipsisRow};
display: -webkit-box;
-webkit-box-orient: vertical;
`;
    }
}}
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This is a Text mean normal fontsize component
const Text$6 = (props) => {
    /* this is a props variables */
    const { children, name } = props;
    return (React.createElement(SPAN, Object.assign({}, props), children ? children : name));
};
// this is a default Props of the component
Text$6.defaultProps = {
    name: ""
};

// This is a H1 typography component
const H1 = (props) => {
    /* this is a props variables */
    const { children, name } = props;
    return React.createElement(H1elem, Object.assign({}, props), children ? children : name);
};
// this is a default Props of the component
H1.defaultProps = {
    name: ""
};

// This is a H2 typography component
const H2 = (props) => {
    /* this is a props variables */
    const { children, name } = props;
    return (React.createElement(H2elem, Object.assign({}, props), children ? children : name));
};
// this is a default Props of the component
H2.defaultProps = {
    name: ""
};

// This is a H6 typography component
const H6 = (props) => {
    /* this is a props variables */
    const { children, name } = props;
    return (React.createElement(H6elem, Object.assign({}, props), children ? children : name));
};
// this is a default Props of the component
H6.defaultProps = {
    name: ""
};

const H1Props = {
  name: '',
};

const H2Props = {
  name: '',
};

const H6Props = {
  name: '',
};

const TextProps = {
  name: '',
};

const ContainerEle = styled.div `
    ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Container component
const Container$1 = (props) => {
    /* this is a props variables */
    const { children, inLineStyles, fluid, className } = props;
    return (React__default.createElement(ContainerEle, Object.assign({}, props, { className: fluid ? "qdm-container-fluid" + ' ' + (className && className) : "qdm-container" + ' ' + (className && className), inLineStyles: inLineStyles && inLineStyles }), children));
};
// this is a default Props of the component
Container$1.defaultProps = {
    name: "container",
    fluid: false
};

const ContainerProps = {
  name: '',
  fluid: false,
};

const HiddenEle = styled.div `
    ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This is a Hidden component
const Hidden = (props) => {
    /* this is a props variables */
    const { children, xsUp, xsDown, smUp, smDown, mdUp, mdDown, lgUp, lgDown, xlUp, xlDown, only } = props;
    // customized and added(className) width of colums funcy
    const renderClass = () => {
        var className = `${xsUp ? ` PrivateHiddenCss-xsUp` : ''} ${xsDown ? ` PrivateHiddenCss-xsDown` : ''} ${smUp ? ` PrivateHiddenCss-smUp` : ''} ${smDown ? ` PrivateHiddenCss-smDown` : ''} ${mdUp ? ` PrivateHiddenCss-mdUp` : ''} ${mdDown ? ` PrivateHiddenCss-mdDown` : ''} ${lgUp ? ` PrivateHiddenCss-lgUp` : ''} ${lgDown ? ` PrivateHiddenCss-lgDown` : ''} ${xlUp ? ` PrivateHiddenCss-xlUp` : ''} ${xlDown ? ` PrivateHiddenCss-xlDown` : ''}
          ${only ? typeof (only) === 'string' ? ` PrivateHiddenCss-only${only}` : only.map((type) => ` PrivateHiddenCss-only${type}`).join(' ') : ''}
          `;
        className = (props === null || props === void 0 ? void 0 : props.className) ? (props === null || props === void 0 ? void 0 : props.className) + className : className;
        return className;
    };
    // end
    // added className in customized with of colums
    let classes = renderClass();
    // end
    return (React__default.createElement(HiddenEle, Object.assign({}, props, { className: classes.trim() }), children));
};
Hidden.defaultProps = {
    xsUp: false,
    xsDown: false,
    smUp: false,
    smDown: false,
    mdUp: false,
    mdDown: false,
    lgUp: false,
    lgDown: false,
    xlUp: false,
    xlDown: false
};

const HiddenProps = {
  xsUp: true,
  xsDown: true,
  smUp: true,
  smDown: true,
  mdUp: true,
  mdDown: true,
  lgUp: true,
  lgDown: true,
  xlUp: true,
  xlDown: true,
};

const Span$d = styled.span ``;
const CheckboxEle = styled.div `
display: flex;
margin:0 0.5em;
   ${props => props && css `
  ${(props) => {
    if (!props.disabled) {
        return `
cursor:pointer;`;
    }
    else {
        return `
color:#bdbdbd;`;
    }
}}
    ${(props) => {
    if (props.size === "small") {
        return `
margin-top: 2px;
& svg{
font-size:1.3rem;
}
`;
    }
    else {
        return `& svg{
 font-size:1.5rem; 
     }`;
    }
}}
    ${(props) => {
    if (props.color === "primary") {
        return `
& svg{
fill:#3f51b5;
}
`;
    }
    else if (props.color === "secondary") {
        return `& svg{
fill:#f50057;
     }`;
    }
    else if (props.color === "default") {
        return `& svg{
fill:rgba(0, 0, 0, 0.54);
     }`;
    }
    else {
        return `& svg{
fill:${props.color};
     }`;
    }
}}
  ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
 `}
  `;
const CheckboxText = styled.div `
color: #000;
padding-left: 4px;
font-size: 15px;
  ${props => props && css `
  ${props => props.inLineTextStyles ? { ...props.inLineTextStyles } : ''}
  ${(props) => {
    if (props.size === "small") {
        return `
margin-top: -2px;
`;
    }
}}
 `}
  `;

// This a Checkbox component
const Checkbox$2 = (props) => {
    /* this is a props variables */
    const { disabled, children, checked, onChange, onClick, defaultChecked, indeterminate, name, inLineTextStyles, size, } = props;
    return (React.createElement(CheckboxEle, Object.assign({}, props, { onClick: (e) => !defaultChecked && !disabled && ((onChange && onChange(e)) || (onClick && onClick(e))) }),
        React.createElement(React.Fragment, null, !checked && !defaultChecked ? (React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', className: "qdm-checkbox-icon", width: "21", height: "21", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
            React.createElement("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }))) : (React.createElement(Span$d, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' }, indeterminate && indeterminate ? (React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', className: "qdm-checkbox-icon", width: "21", height: "21", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
            React.createElement("path", { d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" }))) : (React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', className: "qdm-checkbox-icon", width: "21", height: "21", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
            React.createElement("path", { d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })))))),
        React.createElement(CheckboxText, { inLineTextStyles: inLineTextStyles && inLineTextStyles, size: size && size }, name ? name : children && children)));
};
// this is a default Props of the component
Checkbox$2.defaultProps = {
    size: 'medium',
    color: 'primary',
    name: 'Checkbox',
};

const CheckboxProps = {
  size: ['small', 'medium'],
  color: ['default', 'primary', 'secondary'],
  name: 'Checkbox',
};

const Div$f = styled.div ``;
const SwitchboxEle = styled.div `
display: inline-flex;
z-index: 0;
overflow: hidden;
position: relative;
box-sizing: border-box;
flex-shrink: 0;
vertical-align: middle;
  ${props => props && css `
  ${(props) => {
    if (!props.disabled) {
        return `
cursor:pointer;`;
    }
}}
  ${(props) => {
    if (!props.size) {
        return `
padding: 12px;
width: 58px;
height: 38px;
`;
    }
    else {
        return `
width: 40px;
height: 24px;
padding: 7px;
 `;
    }
}}
  ${(props) => {
    if (props.size === "small") {
        return `
margin-top: 6px;
  `;
    }
}}
 `}
 ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
  `;
const SwitchboxSpan = styled.span `
z-index: -1;
border-radius: 7px;
width: 100%;
height: 100%;
  ${props => props && css `
  ${(props) => {
    if (!props.disabled) {
        if (props.checked) {
            if (props.color === "primary") {
                return `
background-color: #3f51b58f;
 `;
            }
            else if (props.color === "secondary") {
                return `
background-color: #f5005775;`;
            }
            else if (props.color === "default") {
                return `
background-color: #00000075;`;
            }
        }
        else {
            return `
background-color: #00000075;
`;
        }
    }
    else {
        return `
background-color: #bdbdbdb5;
 `;
    }
}}
  `}
 `;
const SwitchSpanLeft = styled.span `
border-radius: 50%;
color: #fafafa;
margin-top:-3px;
z-index: 1;
position: absolute;
overflow: visible;
box-shadow:0px 1px 0px 1px rgb(0 0 0 / 20%);
left:7px;
 ${props => props && css `
 ${(props) => {
    if (!props.disabled) {
        return `
background-color: #fff;
  `;
    }
    else {
        return `
background-color: #bdbdbd;
`;
    }
}}
 ${(props) => {
    if (!props.size) {
        return `
padding: 10px;
font-size: 1.5rem;
  `;
    }
    else {
        return `
padding: 8px;
`;
    }
}}
 `}
  `;
const SwitchSpanRight = styled.span `
border-radius: 50%;
color: #fafafa;
margin-top:-3px;
right: 11px;
z-index: 1;
position: absolute;
overflow: visible;
box-shadow:0px 1px 0px 1px rgb(0 0 0 / 20%);
opacity: unset;
  ${props => props && css `
  ${(props) => {
    if (!props.size) {
        return `
padding: 10px;
font-size: 1.5rem;
  `;
    }
    else {
        return `
transform: translateX(4px);
padding: 8px;
 `;
    }
}}
 ${(props) => {
    if (!props.disabled) {
        if (props.color === "primary") {
            return `
background-color: #3f51b5;
 `;
        }
        else if (props.color === "secondary") {
            return `
background-color: #f50057;
 `;
        }
        else if (props.color === "default") {
            return `
background-color: #fff;
 `;
        }
    }
    else {
        return `
background-color: #bdbdbd;
`;
    }
}}
 `}
  `;
styled.p `
  margin: 0;
  padding: 0px 4px;
  font-size: 12px;
  ${props => props && css `
  ${props.helperTextStyle && { ...props.helperTextStyle }}
  ${(props) => {
    if (props.helperTextType === "error") {
        return `
  color:red;
  `;
    }
    else if (props.helperTextType === "warning") {
        return `
  color:#FFCC00;
  `;
    }
    else if (props.helperTextType === "success") {
        return `
  color:green
  `;
    }
    else {
        return `
  color:gray;
  `;
    }
}}
  `}
  `;
const SwitchText = styled.span `
color: #000;
padding-left: 4px;
font-size: 15px;
margin-top: 2px;
  ${props => props && css `
  ${props => props.inLineTextStyles ? { ...props.inLineTextStyles } : ''}
 `}
  `;

// This is a Switch component
const Switch = (props) => {
    /* this is a props variables */
    const { name, color, inLineTextStyles, size, disabled, children, checked, onChange, onClick, defaultChecked } = props;
    const [values, setvalues] = React.useState(false);
    return (React.createElement(Div$f, { id: props === null || props === void 0 ? void 0 : props.id, onClick: (e) => {
            !defaultChecked && !disabled && onChange && onChange(e) && onClick && onClick(e);
            if (!onClick && !onChange && !defaultChecked && !disabled) {
                return setvalues(!values);
            }
        } },
        React.createElement(SwitchboxEle
        // required={required}
        , Object.assign({}, props),
            React.createElement(SwitchboxSpan, { id: (props === null || props === void 0 ? void 0 : props.id) + '_span', color: color, checked: checked && checked, disabled: disabled && disabled }, (!onClick && !onChange && !defaultChecked && !disabled)
                ?
                    (!values ? (React.createElement(SwitchSpanLeft, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_span', size: size && size, disabled: disabled && disabled })) : (React.createElement(SwitchSpanRight, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sublevel_span', color: color, size: size && size, disabled: disabled && disabled })))
                : (((!checked && !defaultChecked)) ? (React.createElement(SwitchSpanLeft, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_span', size: size && size, disabled: disabled && disabled })) : (React.createElement(SwitchSpanRight, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sublevel_span', color: color, size: size && size, disabled: disabled && disabled }))))),
        React.createElement(SwitchText, { inLineTextStyles: inLineTextStyles && inLineTextStyles }, children ? children : name && name)));
};
// this is a default Props of the component
Switch.defaultProps = {
    color: 'primary',
    name: 'Switchbox',
    size: 'medium',
    defaultChecked: false,
    indeterminate: false,
};

const SwitchProps = {
  color: ['default', 'primary', 'secondary'],
  name: '',
  size: ['medium', 'small'],
  defaultChecked: false,
  indeterminate: false,
};

const RadiobuttonEle = styled.div `
  display: flex;
  margin:0 0.5em;
  ${props => props && css `
  ${(props) => {
    if (!props.disabled) {
        return `
                cursor:pointer;`;
    }
}}
        ${(props) => {
    if (props.size !== "medium") {
        return `
           margin-top: 2px;
           `;
    }
}}
 `}
 ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
 `;
const RadiobuttonText = styled.div `
  color: #000;
  padding-left: 4px;
  font-size: 15px;
  ${props => props && css `
  ${props => props.inLineTextStyles ? { ...props.inLineTextStyles } : ''}
  ${(props) => {
    if (props.size !== "medium") {
        return `
           margin-top: -2px;
           `;
    }
}}
 `}
  `;

const Radio = (props) => {
    const { color, size, value, id, name, disabled, className, children, inLineStyles, checked, onChange, defaultChecked, indeterminate, label, inLineTextStyles } = props;
    const Colorcodes = () => {
        if (disabled) {
            return "#bdbdbd";
        }
        else {
            if (color === "primary") {
                return "#3f51b5";
            }
            else if (color === "secondary") {
                return "#f50057";
            }
            else if (color === "default") {
                return "rgba(0, 0, 0, 0.54)";
            }
        }
    };
    return (React.createElement("div", null,
        React.createElement(RadiobuttonEle, Object.assign({}, props, { onClick: (e) => !defaultChecked && (!disabled && (onChange && onChange(e))) }),
            React.createElement(React.Fragment, null,
                " ",
                (!checked && !defaultChecked) ? React.createElement("svg", { style: { fontSize: size === "small" ? "1.3rem" : "1.5rem" }, className: "qdm-radiobutton-icon", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                    React.createElement("path", { fill: Colorcodes(), d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }))
                    : React.createElement(React.Fragment, null,
                        React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', style: { fontSize: size === "small" ? "1.3rem" : "1.5rem" }, className: "qdm-radiobutton-icon", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                            React.createElement("path", { fill: Colorcodes(), d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })),
                        React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', style: { fontSize: size === "small" ? "1.3rem" : "1.5rem" }, className: "qdm-radiobutton-icon-filled", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                            React.createElement("path", { fill: Colorcodes(), d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z" })))),
            React.createElement(RadiobuttonText, Object.assign({}, props), label ? label : children && children))));
};
Radio.defaultProps = {
    size: "medium",
    color: "primary",
    label: "Radio",
    defaultChecked: false,
    indeterminate: false
};

const RadioProps = {
  size: ['medium', 'small'],
  color: ['default', 'primary', 'secondary'],
  label: '',
  defaultChecked: false,
  indeterminate: false,
};

const CircularProgressEle = styled.div `
    display: flex;
    align-items: center;
    flex-direction: column;
    ${props => props && css `
    ${(props) => {
    if (props.color === "primary") {
        return `
        border-top: 6px solid #3498db;
          `;
    }
    else if (props.color === "secondary") {
        return `
        border-top: 6px solid #ff4949;
          `;
    }
    else if (props.color === "inherit") {
        return `
        border-top: 6px solid #2bb9bd;
          `;
    }
}}
      ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

const CircularProgress = (props) => {
    const { children } = props;
    return (React__default.createElement(CircularProgressEle, Object.assign({}, props, { className: "circul-loader" }), children && children));
};
CircularProgress.defaultProps = {
    variant: "indeterminate",
    color: "primary",
    value: 40
};

const CircularProgressProps = {
  variant: ['determinate', 'indeterminate', 'static'],
  color: ['inherit', 'primary', 'secondary'],
  value: 0,
};

const BorderLinearProgressEle = styled.div `
width: 100%;
background-color: #ddd;
border-radius: 14px;
`;
const BorderLinearProgressSpan = styled.div `
text-align: right;
border-radius: 14px;
color: #ff5252;
height:6px;
${props => props && css `
${(props) => {
    if (props.value) {
        return `
                width: ${props.value}%;
          `;
    }
}}
        ${(props) => {
    if (props.color === "primary") {
        return `
        background-color:#3498db;
        `;
    }
    else if (props.color === "secondary") {
        return `
        background-color:#ff4949;
        `;
    }
    else if (props.color === "inherit") {
        return `
        background-color:#2bb9bd;
        `;
    }
}}
`}
`;
const BorderLinearProgressAutoLoadEle = styled.div `
position:relative;
width:100%;
border-radius: 14px;
height:6px;
overflow: hidden;
`;
const BorderLinearProgressAutoLoadSpan = styled.div `
position:absolute;
opacity: 0.4;
border-radius: 14px;
overflow: hidden;
width:100%;
height:6px;
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
background-color:#3498db;
`;
    }
    else if (props.color === "secondary") {
        return `
background-color:#ff4949;
`;
    }
    else if (props.color === "inherit") {
        return `
background-color:#2bb9bd;
`;
    }
}}
`}

`;
const BorderLinearProgressAutoLoadSpantwo = styled.div `
position:absolute;
height:6px; 
animation: increase 2s infinite;
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
background:#3498db;
`;
    }
    else if (props.color === "secondary") {
        return `
background:#ff4949;
`;
    }
    else if (props.color === "inherit") {
        return `
background:#2bb9bd;
`;
    }
}}
`}
`;
const BorderLinearProgressAutoLoadSpanthree = styled.div `
position:absolute;
height:6px; 
animation: decrease 2s 0.5s infinite;
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
background:#3498db;
`;
    }
    else if (props.color === "secondary") {
        return `
background:#ff4949;
`;
    }
    else if (props.color === "inherit") {
        return `
background:#2bb9bd;
`;
    }
}}
  ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

const BorderLinearProgress = (props) => {
    return (React__default.createElement("div", null, !props.value ?
        React__default.createElement(BorderLinearProgressAutoLoadEle, Object.assign({}, props),
            React__default.createElement(BorderLinearProgressAutoLoadSpan, { color: props.color }),
            React__default.createElement(BorderLinearProgressAutoLoadSpantwo, { color: props.color, className: "qdm-auto-load-border-progress-increase" }),
            React__default.createElement(BorderLinearProgressAutoLoadSpanthree, { color: props.color, className: "qdm-auto-load-border-progress-decrease" })) :
        React__default.createElement(BorderLinearProgressEle, Object.assign({}, props),
            React__default.createElement(BorderLinearProgressSpan, { color: props.color, value: props.value && props.value }, props.value ? Math.round(props.value) + "%" : props.children))));
};
BorderLinearProgress.defaultProps = {
    variant: "indeterminate",
    color: "primary"
};

const BorderLinearProgressProps = {
  variant: ['determinate', 'indeterminate', 'static'],
  color: ['inherit', 'primary', 'secondary'],
};

const PaperEle = styled.div `
          border-radius: 4px;
          margin: 8px;
        ${props => props && css `
        ${(props) => {
    if (props.square) {
        return `
                width: 128px;
                height: 128px;
                  `;
    }
    else {
        return `
                width: 100%;
                `;
    }
}}
        ${(props) => {
    if (props.variant !== "outlined") {
        if (props.elevation === 0) {
            return `
                    box-shadow: none;
                            `;
        }
        else if (props.elevation === 1) {
            return `
                    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 2) {
            return `
                    box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 3) {
            return `
                    box-shadow:0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 4) {
            return `
                    box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 5) {
            return `
                    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 6) {
            return `
                    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 7) {
            return `
                    box-shadow: 0px 4px 5px -2px rgba(0,0,0,0.2), 0px 7px 10px 1px rgba(0,0,0,0.14), 0px 2px 16px 1px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 8) {
            return `
                    box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 9) {
            return `
                    box-shadow: 0px 5px 6px -3px rgba(0,0,0,0.2), 0px 9px 12px 1px rgba(0,0,0,0.14), 0px 3px 16px 2px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 10) {
            return `
                    box-shadow: 0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 11) {
            return `
                    box-shadow:0px 6px 7px -4px rgba(0,0,0,0.2), 0px 11px 15px 1px rgba(0,0,0,0.14), 0px 4px 20px 3px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 12) {
            return `
                    box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 13) {
            return `
                    box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 13px 19px 2px rgba(0,0,0,0.14), 0px 5px 24px 4px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 14) {
            return `
                    box-shadow: 0px 7px 9px -4px rgba(0,0,0,0.2), 0px 14px 21px 2px rgba(0,0,0,0.14), 0px 5px 26px 4px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 15) {
            return `
                    box-shadow: 0px 8px 9px -5px rgba(0,0,0,0.2), 0px 15px 22px 2px rgba(0,0,0,0.14), 0px 6px 28px 5px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 16) {
            return `
                    box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 17) {
            return `
                    box-shadow: 0px 8px 11px -5px rgba(0,0,0,0.2), 0px 17px 26px 2px rgba(0,0,0,0.14), 0px 6px 32px 5px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 18) {
            return `
                    box-shadow:0px 9px 11px -5px rgba(0,0,0,0.2), 0px 18px 28px 2px rgba(0,0,0,0.14), 0px 7px 34px 6px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 19) {
            return `
                    box-shadow: 0px 9px 12px -6px rgba(0,0,0,0.2), 0px 19px 29px 2px rgba(0,0,0,0.14), 0px 7px 36px 6px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 20) {
            return `
                    box-shadow:0px 10px 13px -6px rgba(0,0,0,0.2), 0px 20px 31px 3px rgba(0,0,0,0.14), 0px 8px 38px 7px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 21) {
            return `
                    box-shadow: 0px 10px 13px -6px rgba(0,0,0,0.2), 0px 21px 33px 3px rgba(0,0,0,0.14), 0px 8px 40px 7px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 22) {
            return `
                    box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.2), 0px 22px 35px 3px rgba(0,0,0,0.14), 0px 8px 42px 7px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 23) {
            return `
                    box-shadow: 0px 11px 14px -7px rgba(0,0,0,0.2), 0px 23px 36px 3px rgba(0,0,0,0.14), 0px 9px 44px 8px rgba(0,0,0,0.12);
                            `;
        }
        else if (props.elevation === 24) {
            return `
                    box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);
                            `;
        }
    }
    else {
        return `border: 1px solid rgba(0, 0, 0, 0.12);`;
    }
}}
        ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a Paper component
const Paper = (props) => {
    /* this is a props variables */
    const { children } = props;
    return (React__default.createElement(PaperEle, Object.assign({}, props), children && children));
};
// this is a default Props of the component
Paper.defaultProps = {
    children: "Paper",
    variant: "elevation",
    elevation: 1
};

const PaperProps = { children: '', variant: ['elevation', 'outlined'], elevation: 0 };

const Div$e = styled.div ``;
const DrawerEle = styled.div `
position: fixed;
z-index: 1300;
right: 0px;
bottom: 0px;
top: 0px;
left: 0px;
`;
const DrawerDiv = styled.div `
opacity: 1;
transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
top: 0;
left: 0;
right: 0;
bottom: 0;
display: flex;
z-index: -1;
position: fixed;
align-items: center;
justify-content: center;
-webkit-tap-highlight-color: transparent;
${props => props && css `
${(props) => {
    if (props.variant !== "persistent") {
        return `
background-color: rgba(0, 0, 0, 0.5);
  `;
    }
}}
`}
`;
const DrawerDivContent = styled.div `
transform: none;
transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
top: 0;
height:100%;
flex: 1 0 auto;
display: flex;
outline: 0;
z-index: 1200;
position: fixed;
overflow-y: auto;
flex-direction: column;
background-color: #fff;
color: rgba(0, 0, 0, 0.87);
box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12);
${props => props && css `
${(props) => {
    if (props.anchor === "left") {
        return `
left: 0;
right: auto;
  `;
    }
    else if (props.anchor === "right") {
        return `
left: auto;
right: 0;
  `;
    }
    else if (props.anchor === "top") {
        return `
bottom: auto;
top: 0;
width:100%;
height:auto;
min-width:100%;
`;
    }
    else if (props.anchor === "bottom") {
        return `
bottom: 0;
top: auto;
height:auto;
width:100%;
min-width:100%;
  `;
    }
}}
${(props) => {
    if (props.variant === "permanent") {
        return `
max-width:100%;
width:100%;
height:100%;
  `;
    }
    else if (props.variant === "persistent") {
        return `
border: 1px solid rgba(0, 0, 0, 0.12);
box-shadow:none;
  `;
    }
}}
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a Drawer component
const Drawer = (props) => {
    /* this is a props variables */
    const { open, onClose, children, anchor, variant, inLineStyles } = props;
    if (open) {
        // the condition is once open this component its hidden of body scroll
        document.body.style.overflow = 'hidden';
    }
    return (React__default.createElement(Div$e, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' },
        " ",
        (props.variant === "permanent" ? true : open) && React__default.createElement(DrawerEle, null,
            React__default.createElement(DrawerDiv, Object.assign({ className: "qdm-body-unscroll" }, props, { onClick: (e) => onClose && onClose(e) }),
                React__default.createElement(DrawerDivContent, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div', inLineStyles: inLineStyles && inLineStyles, anchor: anchor && anchor, variant: variant && variant },
                    " ",
                    children && children,
                    " ")))));
};
// this is a default Props of the component
Drawer.defaultProps = {
    anchor: "left",
    variant: "temporary",
    children: "Drawer"
};

const DrawerProps = {
  anchor: ['bottom', 'left', 'right', 'top'],
  variant: ['permanent', 'persistent', 'temporary'],
  children: '',
};

const Label$d = styled.label ``;
const Add$2 = styled.span `
padding:4px 16px;
border-radius:3px;
cursor:pointer;
border:1px solid #2bb9bd;
font-size:14px;
color:#fff;
background-color:#2bb9bd;
margin:0 1em;
display:flex;
margin:auto;
z-index: 100000;
width:max-content;
`;
const SelectEle$1 = styled.ul ``;
const MainDiv$1 = styled.div `
position: relative;
${props => props && css `
${(props) => {
    return `
width:${props.width ? props.width + "px" : "100%"};`;
}}
`}
`;
const Lableone$2 = styled.p `
font-size:14px;
font-weight: 500;
margin:0;
${props => props && css `
${props => props.labelStyle ? { ...props.labelStyle } : ''}
`}
`;
styled.span `
position: absolute;
margin-top: -20px;
background: #fff;
padding: 0px 4px;
letter-spacing: 0.4px;
color:#000;
font-size:14px;
${props => props && css `
${(props) => {
    return `
width:${props.labelWidth ? props.labelWidth + "px" : "max-content"};`;
}}
`}
`;
const SelectE$1 = styled.div `
width: 100%;
background-color: #fff;
border-radius: 4px;
padding: 1px;
overflow: hidden;
display: flex;
flex-wrap: wrap;
position: relative;

& input {
font-size: 14px;
box-sizing: border-box;
width: 0;
min-width: 30px;
flex-grow: 1;
border: 0;
margin: 0;
outline: 0;
font-weight: unset;
padding:9.5px 14px;
}
${props => props && css `
${(props) => {
    if (props.size === "small") {
        return `
height: 32px; & input {
padding: 0px 8px 0px 8px;
}
 `;
    }
    else {
        return `
height:40px;
& input {
padding:10.5px 14px;
}
`;
    }
}} 
${(props) => {
    if (!props.disabled && props.error) {
        if (props.variant === "outlined") {
            return `
        border: 1px solid red;
          
       `;
        }
        else if (props.variant === "standard") {
            return `
          border-bottom: 1px solid red;
            border-right:unset;
            border-radius: 0px;
            border-top: 0px;
            border-left:unset;
         `;
        }
        else if (props.variant === "none") {
            return `
            border:0;
            &:focus{
              border:0;
              outline: none;
            }
          `;
        }
    }
}}
    ${(props) => {
    if (!props.disabled && !props.error) {
        if (props.variant === "standard") {
            return `
        border-bottom: 1px solid #9b9b9b;
        border-radius: 0px;
        &:hover {
          border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
                 border-right:unset;
                 border-radius: 0px;
                 border-top: 0px; 
                 border-left:unset;
          }
          
          &.focus {
            border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor};
            border-right:unset;
            border-radius: 0px;
            border-top: 0px; 
            border-left:unset;
          }
          
             `;
        }
        else if (props.variant === "outlined") {
            return `
        border:1px solid #9b9b9b;
        &:hover {
          border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
          }
          
          &.focus {
            border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor};
          }
          
             `;
        }
    }
}}
  ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`}
`;
const Input$a = styled.input `
font-size: 14px;
color: #000;
font-weight: 400 !important;
`;
const HelperTextCom$1 = styled.p `
margin: 0;
padding: 0px 4px;
font-size: 12px;
${props => props && css `
${props.helperTextStyle && { ...props.helperTextStyle }}
${(props) => {
    if (props.helperTextType === "error") {
        return `
color:red;
`;
    }
    else if (props.helperTextType === "warning") {
        return `
color:#FFCC00;
`;
    }
    else if (props.helperTextType === "success") {
        return `
color:green;
`;
    }
    else {
        return `
color:gray;
`;
    }
}}
`}
`;
const SelectLoader$2 = styled.div `
display: flex;
align-items: center;
flex-direction: column;
overflow: hidden;
z-index: 10000;
margin-left: 33px;
border-top: 3px solid #3498db;
`;
const Div$d = styled.div `
& .nodata{
  display:flex;
  padding:10px 5px;
  font-size: 14px;
  align-items:center;
  justify-content:justify-content;
}`;
const Text$5 = styled.div `
display:flex;
align-items:center;
`;
const Span$c = styled.span `
padding: 0 12px;
letter-spacing: 0.5px;
line-height: 28px;
& svg {
width:30px;
height:30px;
object-fit:cover;
}
& .nodata{
  display:flex;
  align-items:center;
  justify-content:justify-content;
}
`;
const Close$2 = styled.div `
${props => props && css `
${(props) => {
    if (props.size === "medium") {
        return `
margin-top: -28px;
`;
    }
    else {
        return `
margin-top: -24px;
`;
    }
}}
`}
display: flex;
align-items: center;
flex-direction: column;
overflow: hidden;
color: black;
position: relative;
font-weight: 500;
cursor: pointer;
float:right;
margin-right: 12px;
right: 24px;
width: 16px;
height: 16px;
& img {
height: 100%;
width: 100%;
object-fit:cover; 
}
`;
const SelectComponent$2 = styled.div `
font-size: 14px;
width:100%;
white-space: nowrap;
overflow: hidden;
font-weight: 400;
text-overflow: ellipsis;
${props => props && css `
${(props) => {
    if (props.size === "small") {
        return `
padding: 4px 8px;
 `;
    }
    else {
        return `
padding: 7.5px 14px;
`;
    }
}}
${(props) => {
    if (props.value) {
        return `
color: rgba(0,0,0,0.87);
`;
    }
    else {
        return `
color: #aba9a9;
`;
    }
}}
${(props) => {
    if (props.disabled) {
        return `
background:#fafafa;
`;
    }
}}
`}
 `;
const SearchCom$2 = styled.div `
${props => props && css `
${(props) => {
    if (props.size !== "small") {
        return `
top: 52%;
`;
    }
    else {
        return `
top: 52%;
`;
    }
}}
`}
margin-right: 12px;
position: absolute;
display: block;
right: 0px;
width: 16px;
height: 16px;
cursor: pointer;
& img {
height: 100%;
width: 100%;
object-fit: cover;
}
`;
const DownArrow$2 = styled.div `
width:23px;
height:23px;
position: absolute;
right:5px;
top: 50%;
transform: translateY(-50%);
cursor: pointer;
& svg{
  fill:rgb(136 132 132 / 74%);
}
`;
const Star$4 = styled.span `
color:red;
margin-left: 5px;
`;
const Li$4 = styled.li `
list-style-type:none;
&:hover {
background:#eee;
}
& svg{
right:0;
float:right;
margin-top: 10px;
fill:#1890ff;
}
${props => props && css `
 ${props => props.dropdownStyle ? { ...props.dropdownStyle } : ''}
 background:${props => props.active ? '#eee !important' : ''};
 font-weight:${props => props.active ? '500' : ''};
 `}
 `;

const inputListen$3 = (e, addFun, masterSearch) => {
    e.target;
    // eslint-disable-next-line 
    // let splitvalue = value.split(' ');
    if ((e.keyCode === 51 && e.key === '#') || e.keyCode === 16 || e.target) {
        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
            e.preventDefault();
            listView$3(e, addFun, masterSearch);
        } else {
            cursorGet$3(e);
        }
    } else {
        if (masterSearch === undefined) {
            document.getElementsByClassName('listDiv')[0].setAttribute('style', `display : none`);
        }
    }
};
const classnameadd$3 = (index) => {
    // document.getElementById("search_check_filter").children[index].className += " start";
    document.getElementById("search_check_filter").getElementsByTagName('li')[index].className += ' qdm-select-options';
};
function listView$3(e, addFun, masterSearch) {
    let scrollHeight = 0;
    let listCount = 0;
    let setHeight = 0;
    let currentHeight = 0;
    // try{
        if (document.getElementsByClassName("listDiv") && document.getElementsByClassName("listDiv")[0]) {
            scrollHeight = document.getElementsByClassName("listDiv")[0].scrollHeight - document.getElementsByClassName("listDiv")[0].clientHeight;
            listCount = document.getElementsByClassName("listDiv")[0].children[0].childElementCount;
            setHeight = scrollHeight / listCount;
            currentHeight = document.getElementsByClassName("listDiv")[0].scrollTop;
        }
    // }catch(e){
    // }
    // eslint-disable-next-line 
    switch (e.keyCode) {
        case 38: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            if (start && start.previousElementSibling !== null) {
                if (start.previousElementSibling.tagName === 'LI') {
                    start.classList.remove('qdm-select-options');
                    start.classList.add('actives');
                    start.previousElementSibling.classList.remove('actives');
                    start.previousElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.previousElementSibling.previousElementSibling !== null) {
                        start.classList.remove('qdm-select-options');
                        start.classList.add('actives');
                        start.previousElementSibling.previousElementSibling.classList.remove('actives');
                        start.previousElementSibling.previousElementSibling.classList.add('qdm-select-options');
                    }
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow$3(ul, false);
            }
            let heightList = currentHeight - setHeight;
            document.getElementsByClassName("listDiv")[0].scrollTop = heightList <= 0 ? 0 : heightList;
            break;
        }
        case 40: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            var startList = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options');
            if (start && start.nextElementSibling !== null) {
                start.classList.remove('qdm-select-options');
                start.classList.add('actives');
                if (start.nextElementSibling.tagName === 'LI') {
                    start.nextElementSibling.classList.remove('actives');
                    start.nextElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.nextElementSibling.nextElementSibling !== null) {
                        start.nextElementSibling.nextElementSibling.classList.remove('actives');
                        start.nextElementSibling.nextElementSibling.classList.add('qdm-select-options');
                    }
                }
            } else {
                // if(startList.length > 0){
                //     startList[startList.length-1].classList.remove('qdm-select-options');
                // }
                if (startList.length === 0) {
                    classnameadd$3(0);
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow$3(ul, true);
            }
            document.getElementsByClassName("listDiv")[0].scrollTop = currentHeight + setHeight;
            break;
        }
        // case 13: {
        //     addFun(e);
        //     break;
        // }
    }
}
function cursorGet$3(e, isreturn) {
    const input = e.target;
    // eslint-disable-next-line 
    const { offsetHeight, offsetLeft, offsetTop, offsetWidth, scrollLeft, scrollTop, selectionStart, value } = input;
    const { paddingRight, lineHeight } = getComputedStyle(input);
    const { x, y } = getCursorXY$3(input, selectionStart);
    const newLeft = Math.min(
        x - scrollLeft,
        (offsetLeft + offsetWidth) - parseInt(paddingRight, 10)
    );
    let valuecheck = parseInt(lineHeight, 10);
    const newTop = Math.min(
        y - scrollTop,
        (offsetTop + offsetHeight) - (isNaN(valuecheck) !== true ? parseInt(lineHeight, 10) : 0)
    );
    if (isreturn) {
        return {
            left: newLeft - 5,
            top: newTop + 10
        }
    }
    document.getElementsByClassName('listDiv')[0].setAttribute('style', `left: ${newLeft}px; top: ${newTop + 10}px;`);
}
const getCursorXY$3 = (input, selectionPoint) => {
    const {
        offsetLeft: inputX,
        offsetTop: inputY,
    } = input;
    const div = document.createElement('div');
    const copyStyle = getComputedStyle(input);
    for (const prop of copyStyle) {
        div.style[prop] = copyStyle[prop];
    }
    const swap = '.';
    const inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
    const textContent = inputValue.substr(0, selectionPoint);
    div.textContent = textContent;
    if (input.tagName === 'TEXTAREA') div.style.height = 'auto';
    if (input.tagName === 'INPUT') div.style.width = 'auto';
    const span = document.createElement('span');
    span.textContent = inputValue.substr(selectionPoint) || '.';
    div.appendChild(span);
    document.body.appendChild(div);
    // eslint-disable-next-line 
    const { offsetLeft: spanX, offsetTop: spanY } = span;
    document.body.removeChild(div);
    return {
        // x: inputX + spanX,
        x: inputX,
        //   x: inputX + Math.abs(spanX - input.offsetWidth),
        // y: inputY + spanY,
        y: inputY + Math.abs(spanY - input.offsetHeight),
    }
};
const scrollOverFlow$3 = (ul, top) => {
    let start = document.getElementsByClassName('qdm-select-options')[0];
    if (!start) {
        return false;
    }
    let bounding = start.getBoundingClientRect();
    if (top) {
        if (ul.clientHeight < bounding.bottom) {
            ul.scrollTop = ul.scrollTop + start.clientHeight;
        }
    } else {
        let ulBounding = ul.getBoundingClientRect();
        if (ulBounding.top > (bounding.top - 30)) {
            ul.scrollTop = ul.scrollTop - start.clientHeight;
        }
    }
};

// This is a Select component
const OldSelect = (props) => {
    /* this is a props variables */
    const { className, id, options, value, error, inLineStyles, variant, onChange, onChangeValue, onChangeClaer, label, disabled, allowClear = true, width, labelWidth, helperText, size, search, defaultValue, placeholder, isloader, Icon, isloaderIcon, added, onAdd, showArrow, isRequired, labelStyle, hoverColor, getOptionLabel } = props;
    //  end
    // this is a state of handling variables
    const [isactive, setisactive] = React.useState(false);
    const [isfocus, setFocus] = React.useState(false);
    const [inputfocus, setinputfocus] = React.useState(false);
    const [values, setvalues] = React.useState('');
    const [position, setposition] = React.useState({});
    const [getValue, setValue] = React.useState(value);
    //  end
    //  handle clear Value field funcy
    const clearValue = () => {
        onChangeClaer && onChangeClaer('');
        onChangeValue && onChangeValue({});
    };
    // end
    //  handle onFocus field funcy
    const onFocus = (e) => {
        setFocus(true);
        let pos = cursorGet$3(e, true);
        setposition(Object.assign({}, pos));
    };
    // end
    //  handle onchage field funcy
    const onchageFun = (e) => {
        setvalues(e.target.value);
        setValue(e.target.value);
        onChange && onChange(e);
    };
    // end
    //  handle onBlur field funcy
    const onBlur = () => {
        setFocus(false);
        setinputfocus(false);
    };
    // end
    // the filter of the data 
    const dataoptions = () => {
        let data = options.filter((val) => (val.value && val.value.toLowerCase().includes(values.toLowerCase())));
        return data;
    };
    // end
    // option data declare
    const optionsData = values && values ? dataoptions() && dataoptions() : options;
    // end
    //  handle added new data funcy
    const onAdded = (v) => {
        onAdd && onAdd(v);
        setisactive(!isactive);
        setvalues("");
    };
    // end
    const val = (getClass) => {
        var _a;
        let data = options.filter((val) => { var _a; return (val.value && val.value.toLowerCase() === ((_a = getClass === null || getClass === void 0 ? void 0 : getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText.toLowerCase())); });
        if ((_a = getClass === null || getClass === void 0 ? void 0 : getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText) {
            return data === null || data === void 0 ? void 0 : data[0];
        }
    };
    const selectedOption = (e) => {
        var _a;
        let getClass = document.getElementsByClassName('qdm-select-options');
        if (getClass.length > 0) {
            // if (document.getElementsByTagName('input')) {
            //   document.getElementsByTagName('input')[0].blur()
            // }
            if (e.keyCode === 13) {
                // if (val(getClass) && getClass) {
                onChangeValue && onChangeValue(val(getClass));
                // } else {
                //   onChangeValue && onChangeValue({});
                // }
                setisactive(false);
                setinputfocus(false);
                setValue((_a = val(getClass)) === null || _a === void 0 ? void 0 : _a.value);
                setvalues("");
            }
            else {
                onChangeValue && onChangeValue({});
            }
            // setoptionValue(value)
            // setValue('');
            // document.getElementsByClassName('inputSearchField')[0].blur();
        }
        else {
            onChangeValue && onChangeValue({});
        }
    };
    const onkeydown = (e) => {
        inputListen$3(e, selectedOption(e), 1);
    };
    return React.createElement(MainDiv$1, { id: id, className: className, width: width && width },
        label &&
            React.createElement(Lableone$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_p', autoFocus: inputfocus ? inputfocus : props.autoFocus ? props.autoFocus : false, labelWidth: labelWidth && labelWidth, size: size, labelStyle: labelStyle && labelStyle },
                label,
                isRequired && React.createElement(Star$4, null, "*")),
        React.createElement(SelectE$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div', size: size, disabled: disabled, variant: variant, hoverColor: hoverColor, error: error, inLineStyles: inLineStyles, style: {
                borderColor: inputfocus ? hoverColor : ''
            } },
            " ",
            !inputfocus && React.createElement(React.Fragment, null,
                React.createElement(SelectComponent$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', helperTextType: props.helperTextType && props.helperTextType, value: props.value && props.value, disabled: props.disabled && props.disabled, size: size && size, onClick: () => {
                        !disabled && setinputfocus(true);
                        !disabled && setisactive(true);
                    } }, (!inputfocus) && (value ? value : defaultValue ? defaultValue : placeholder))),
            inputfocus && React.createElement(Input$a, Object.assign({}, props, { onChange: e => onchageFun(e), autoFocus: true, onFocus: (e) => onFocus(e), onBlur: onBlur, value: defaultValue ? defaultValue : getValue, id: (props === null || props === void 0 ? void 0 : props.id) + '_input', className: "", onKeyDown: e => onkeydown(e), autoComplete: "off" })),
            showArrow &&
                React.createElement(DownArrow$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_arrow_div', onClick: () => {
                        !disabled && setinputfocus(true);
                        !disabled && setisactive(true);
                    } },
                    React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_arrow_svg', className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                        React.createElement("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" })))),
        React.createElement(Label$d, { id: (props === null || props === void 0 ? void 0 : props.id) + '_label' },
            search && React.createElement(SearchCom$2, { helperTextType: props.helperTextType && props.helperTextType, size: props.size && props.size },
                "     ",
                React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "search", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                    React.createElement("path", { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" }))),
            ((allowClear) && (value)) && React.createElement(Close$2, { size: size && size, helperTextType: props.helperTextType && props.helperTextType, onClick: () => clearValue(), className: "qdm-select-loader" }, Icon ? Icon : React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "close-circle", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                React.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" }))),
            ((helperText) && (props === null || props === void 0 ? void 0 : props.error)) && (React.createElement(HelperTextCom$1, { error: props.error && props.error, size: props.size && props.size, helperTextStyle: props.helperTextStyle && props.helperTextStyle, helperTextType: props.helperTextType && props.helperTextType }, helperText && helperText))),
        !isloader && !optionsData ? isactive && React.createElement(React.Fragment, null, (inputfocus) ? React.createElement(Div$d, { className: "qdm-select-div nodata" },
            " ",
            added && React.createElement(Add$2, { onMouseDown: () => onAdded(values) }, "Add"),
            " ",
            React.createElement(Span$c, null,
                React.createElement("svg", { width: "184", height: "152", viewBox: "0 0 184 152", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
                        React.createElement("g", { transform: "translate(24 31.67)" },
                            React.createElement("ellipse", { "fill-opacity": ".8", fill: "#F5F5F7", cx: "67.797", cy: "106.89", rx: "67.797", ry: "12.668" }),
                            React.createElement("path", { d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z", fill: "#AEB8C2" }),
                            React.createElement("path", { d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z", fill: "url(#linearGradient-1)", transform: "translate(13.56)" }),
                            React.createElement("path", { d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#F5F5F7" }),
                            React.createElement("path", { d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z", fill: "#DCE0E6" })),
                        React.createElement("path", { d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z", fill: "#DCE0E6" }),
                        React.createElement("g", { transform: "translate(149.65 15.383)", fill: "#FFF" },
                            React.createElement("ellipse", { cx: "20.654", cy: "3.167", rx: "2.849", ry: "2.815" }),
                            React.createElement("path", { d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" })))),
                " No data found ")) : "") : React.createElement(Div$d, { id: (props === null || props === void 0 ? void 0 : props.id) + '_label_div' },
            React.createElement(Div$d, { className: 'listDiv' }, (isfocus && isactive) && React.createElement(SelectEle$1, { className: "qdm-select-div", id: 'search_check_filter' }, isloader ? React.createElement(Text$5, null,
                React.createElement(SelectLoader$2, { className: isloaderIcon ? "" : "qdm-select-loader" }),
                React.createElement(Span$c, null,
                    React.createElement(Span$c, { className: isloaderIcon ? "own-qdm-select-loader" : "" },
                        isloaderIcon,
                        "Loading..."))) : React.createElement(React.Fragment, null,
                optionsData.map((opt_) => {
                    return (opt_ && opt_.value) &&
                        React.createElement(Li$4, { key: opt_.value, active: value === opt_.value ? true : false, dropdownStyle: props.dropdownStyle && props.dropdownStyle, className: "actives", onMouseDown: () => {
                                onChangeValue && onChangeValue(opt_);
                                setisactive(!isactive);
                                setValue(opt_ === null || opt_ === void 0 ? void 0 : opt_.value);
                                setvalues("");
                            } }, getOptionLabel ? opt_[getOptionLabel] : opt_.value);
                    /* end */
                }),
                ((optionsData.length === 0) && (inputfocus)) ? React.createElement(Span$c, { className: "nodata" },
                    " ",
                    added && React.createElement(Add$2, { onMouseDown: () => onAdded(values) }, "Add"),
                    " ",
                    React.createElement("svg", { width: "184", height: "152", viewBox: "0 0 184 152", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
                            React.createElement("g", { transform: "translate(24 31.67)" },
                                React.createElement("ellipse", { "fill-opacity": ".8", fill: "#F5F5F7", cx: "67.797", cy: "106.89", rx: "67.797", ry: "12.668" }),
                                React.createElement("path", { d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z", fill: "#AEB8C2" }),
                                React.createElement("path", { d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z", fill: "url(#linearGradient-1)", transform: "translate(13.56)" }),
                                React.createElement("path", { d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#F5F5F7" }),
                                React.createElement("path", { d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z", fill: "#DCE0E6" })),
                            React.createElement("path", { d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z", fill: "#DCE0E6" }),
                            React.createElement("g", { transform: "translate(149.65 15.383)", fill: "#FFF" },
                                React.createElement("ellipse", { cx: "20.654", cy: "3.167", rx: "2.849", ry: "2.815" }),
                                React.createElement("path", { d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" })))),
                    " No data found ") : "")))));
};
// this is a default Props of the component
OldSelect.defaultProps = {
    disabled: false,
    size: "medium",
    helperTextType: "error",
    label: "",
    variant: "outlined",
    placeholder: 'select field',
    isRequired: false,
    showArrow: false,
    hoverColor: '#000'
};

const SelectProps = {
  disabled: false,
  size: ['small', 'medium'],
  helperTextType: ['error', 'warning', 'success'],
  label: '',
  variant: ['standard', 'outlined', 'none'],
  placeholder: '',
  isRequired: false,
  showArrow: false,
  hoverColor: '#000',
};

const DivEle$1 = styled.div `
    ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This is a Row component
const Div$c = (props) => {
    /* this is a props variables */
    const { className } = props;
    return (React__default.createElement(DivEle$1, Object.assign({}, props, { className: `${className}` }), props.children));
};
// this is a default Props of the component
Div$c.defaultProps = {
    className: "qdm",
};

const DivProps = {
  className: '',
};

const Theme = (props) => {
    /* this is a props variables */
    const { theme, children } = props;
    return (React__default.createElement(ThemeProvider, { theme: theme && theme }, children && children));
};
// this is a default Props of the component
Theme.defaultProps = {
    theme: {
        palette: {
            common: {
                black: '#000',
                white: '#fff'
            },
            background: {
                paper: '#fff',
                default: '#fafafa'
            },
            primary: {
                light: '#7986cb',
                main: '#3f51b5',
                dark: '#303f9f',
                contrastText: '#fff'
            },
            secondary: {
                light: '#ff4081',
                main: '#f50057',
                dark: '#c51162',
                contrastText: '#fff'
            },
            error: {
                light: '#e57373',
                main: '#f44336',
                dark: '#d32f2f',
                contrastText: '#fff'
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)'
            }
        }
    }
};

const ModalEle = styled.div `
   position: fixed;
   z-index: 1300;
   ${props => props && css `
    `}
`;
const ModalDiv = styled.div `
    z-index: -1;
    position: fixed;
    right: 0px;
    bottom: 0px;
    top: 0px;
    left: 0px;
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
`;
const ModalDivContent = styled.div `
    background: #fff;
    display: flex;
    /* max-width: 600px; */
    max-height: calc(100% - 64px);
    flex-direction: column;
    margin: auto;
    height: auto;
    position: absolute;
    border-radius: 4px;

    ${props => props && css `
    ${(props) => {
    return `
              max-width:${props.width}px;`;
}}
     ${props.inLineStyles && { ...props.inLineStyles }}
`}
    
`;
const CloseButton$1 = styled.div `
position: absolute;
    right: -13px;
    right: -35px;
    border-radius: 15px;
    top: -35px;
    background-color: #fff;
    cursor: pointer;
    /* border: 1px solid; */
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    & svg{
      width: 16px;
      height: 16px;
      fill: #555252;
    }
    width: 30px;
    height: 30px;
    ${props => props && css `

`}
  `;

const Modal = (props) => {
    const { open, children, inLineStyles } = props;
    // let bodyOverflowstyle = document.body.style?.overflow ?? 'auto';
    // console.log(bodyOverflowstyle)
    if (open) {
        document.body.style.overflow = 'hidden';
    }
    else {
        document.body.style.overflow = 'auto';
        // console.log(bodyOverflowstyle)
    }
    return (React__default.createElement("div", null, open &&
        React__default.createElement(ModalEle, Object.assign({}, props),
            React__default.createElement(ModalDiv, { id: props.id + '_div' },
                React__default.createElement(ModalDivContent, { width: props.width, inLineStyles: inLineStyles && inLineStyles },
                    React__default.createElement(CloseButton$1, { width: props.width, onClick: (e) => (props === null || props === void 0 ? void 0 : props.onClose) && (props === null || props === void 0 ? void 0 : props.onClose(e)) },
                        React__default.createElement("svg", { id: props.id + '_svg', className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                            React__default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }))),
                    children && children)))));
};
Modal.defaultProps = {
    width: 600,
};

const ModalProps = {
  width: 0,
};

const DialogActionsEle = styled.div `
    margin: 0;
    padding: 8px;
    align-items: center;
    display: flex;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    justify-content: flex-end;
${props => props && css `
        ${props.inLineStyles && { ...props.inLineStyles }}
        `}
`;

// This a DialogActions component
const DialogActions = (props) => {
    /* this is a props variables */
    const { children } = props;
    return (React__default.createElement(DialogActionsEle, Object.assign({}, props), children && children));
};
// this is a default Props of the component
DialogActions.defaultProps = {
    children: "Dialog Actions",
};

const DialogActionsProps = {
  children: '',
};

const DialogTitleEle = styled.div `
margin: 0;
border-bottom: 1px solid rgba(0, 0, 0, 0.12);
padding: 16px;
font-size: 1.25rem;
font-weight: 500;
line-height: 1.6;
letter-spacing: 0.0075em;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
        `}
`;

// This a DialogContent component
const DialogTitle = (props) => {
    /* this is a props variables */
    const { onClose, children } = props;
    return (React__default.createElement(DialogTitleEle, Object.assign({}, props), children && children));
};
// this is a default Props of the component
DialogTitle.defaultProps = {
    children: "Dialog Title",
};

const DialogTitleProps = {
  children: '',
};

const DialogContentEle = styled.div `
overflow-y: auto;
padding: 16px;
${props => props && css `
        ${props.inLineStyles && { ...props.inLineStyles }}
        `}
`;

// This a DialogContent component
const DialogContent = (props) => {
    /* this is a props variables */
    const { children } = props;
    return (React__default.createElement(DialogContentEle, Object.assign({}, props), children && children));
};
// this is a default Props of the component
DialogContent.defaultProps = {
    children: "Dialog Content",
};

const DialogContentProps = {
  children: '',
};

const inputListen$2 = (e, addFun, masterSearch) => {
    e.target;
    // eslint-disable-next-line 
    // let splitvalue = value.split(' ');
    if ((e.keyCode === 51 && e.key === '#') || e.keyCode === 16 || e.target) {
        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
            e.preventDefault();
            listView$2(e, addFun, masterSearch);
        } else {
            cursorGet$2(e);
        }
    } else {
        if (masterSearch === undefined) {
            document.getElementsByClassName('listDiv')[0].setAttribute('style', `display : none`);
        }
    }
};
const classnameadd$2 = (index) => {
    // document.getElementById("search_check_filter").children[index].className += " start";
    document.getElementById("search_check_filter").getElementsByTagName('li')[index].className += ' qdm-select-options';
};
function listView$2(e, addFun, masterSearch) {
    let scrollHeight = 0;
    let listCount = 0;
    let setHeight = 0;
    let currentHeight = 0;
    // try{
        if (document.getElementsByClassName("listDiv") && document.getElementsByClassName("listDiv")[0]) {
            scrollHeight = document.getElementsByClassName("listDiv")[0].scrollHeight - document.getElementsByClassName("listDiv")[0].clientHeight;
            listCount = document.getElementsByClassName("listDiv")[0].children[0].childElementCount;
            setHeight = scrollHeight / listCount;
            currentHeight = document.getElementsByClassName("listDiv")[0].scrollTop;
        }
    // }catch(e){
    // }
    // eslint-disable-next-line 
    switch (e.keyCode) {
        case 38: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            if (start && start.previousElementSibling !== null) {
                if (start.previousElementSibling.tagName === 'LI') {
                    start.classList.remove('qdm-select-options');
                    start.classList.add('actives');
                    start.previousElementSibling.classList.remove('actives');
                    start.previousElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.previousElementSibling.previousElementSibling !== null) {
                        start.classList.remove('qdm-select-options');
                        start.classList.add('actives');
                        start.previousElementSibling.previousElementSibling.classList.remove('actives');
                        start.previousElementSibling.previousElementSibling.classList.add('qdm-select-options');
                    }
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow$2(ul, false);
            }
            let heightList = currentHeight - setHeight;
            document.getElementsByClassName("listDiv")[0].scrollTop = heightList <= 0 ? 0 : heightList;
            break;
        }
        case 40: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            var startList = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options');
            if (start && start.nextElementSibling !== null) {
                start.classList.remove('qdm-select-options');
                start.classList.add('actives');
                if (start.nextElementSibling.tagName === 'LI') {
                    start.nextElementSibling.classList.remove('actives');
                    start.nextElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.nextElementSibling.nextElementSibling !== null) {
                        start.nextElementSibling.nextElementSibling.classList.remove('actives');
                        start.nextElementSibling.nextElementSibling.classList.add('qdm-select-options');
                    }
                }
            } else {
                // if(startList.length > 0){
                //     startList[startList.length-1].classList.remove('qdm-select-options');
                // }
                if (startList.length === 0) {
                    classnameadd$2(0);
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow$2(ul, true);
            }
            document.getElementsByClassName("listDiv")[0].scrollTop = currentHeight + setHeight;
            break;
        }
        // case 13: {
        //     addFun(e);
        //     break;
        // }
    }
}
function cursorGet$2(e, isreturn) {
    const input = e.target;
    // eslint-disable-next-line 
    const { offsetHeight, offsetLeft, offsetTop, offsetWidth, scrollLeft, scrollTop, selectionStart, value } = input;
    const { paddingRight, lineHeight } = getComputedStyle(input);
    const { x, y } = getCursorXY$2(input, selectionStart);
    const newLeft = Math.min(
        x - scrollLeft,
        (offsetLeft + offsetWidth) - parseInt(paddingRight, 10)
    );
    let valuecheck = parseInt(lineHeight, 10);
    const newTop = Math.min(
        y - scrollTop,
        (offsetTop + offsetHeight) - (isNaN(valuecheck) !== true ? parseInt(lineHeight, 10) : 0)
    );
    if (isreturn) {
        return {
            left: newLeft - 5,
            top: newTop + 10
        }
    }
    document.getElementsByClassName('listDiv')[0].setAttribute('style', `left: ${newLeft}px; top: ${newTop + 10}px;`);
}
const getCursorXY$2 = (input, selectionPoint) => {
    const {
        offsetLeft: inputX,
        offsetTop: inputY,
    } = input;
    const div = document.createElement('div');
    const copyStyle = getComputedStyle(input);
    for (const prop of copyStyle) {
        div.style[prop] = copyStyle[prop];
    }
    const swap = '.';
    const inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
    const textContent = inputValue.substr(0, selectionPoint);
    div.textContent = textContent;
    if (input.tagName === 'TEXTAREA') div.style.height = 'auto';
    if (input.tagName === 'INPUT') div.style.width = 'auto';
    const span = document.createElement('span');
    span.textContent = inputValue.substr(selectionPoint) || '.';
    div.appendChild(span);
    document.body.appendChild(div);
    // eslint-disable-next-line 
    const { offsetLeft: spanX, offsetTop: spanY } = span;
    document.body.removeChild(div);
    return {
        // x: inputX + spanX,
        x: inputX,
        //   x: inputX + Math.abs(spanX - input.offsetWidth),
        // y: inputY + spanY,
        y: inputY + Math.abs(spanY - input.offsetHeight),
    }
};
const scrollOverFlow$2 = (ul, top) => {
    let start = document.getElementsByClassName('qdm-select-options')[0];
    if (!start) {
        return false;
    }
    let bounding = start.getBoundingClientRect();
    if (top) {
        if (ul.clientHeight < bounding.bottom) {
            ul.scrollTop = ul.scrollTop + start.clientHeight;
        }
    } else {
        let ulBounding = ul.getBoundingClientRect();
        if (ulBounding.top > (bounding.top - 30)) {
            ul.scrollTop = ul.scrollTop - start.clientHeight;
        }
    }
};

const Label$c = styled.label ``;
const Select$4 = styled.ul `margin-top: 4px;`;
const DivComp = styled.div `
position: relative;
& .nodata{
  display:flex;
  align-items:center;
  justify-content:justify-content;
}
${props => props && css `
${(props) => {
    return `
width:${props.width ? props.width + "px" : "100%"};`;
}}
`}
`;
const Add$1 = styled.span `
padding:4px 16px;
border-radius:3px;
cursor:pointer;
border:1px solid #2bb9bd;
font-size:14px;
color:#fff;
background-color:#2bb9bd;
margin:0 1em;
display:flex;
margin:auto;
z-index: 100000;
width:max-content;
`;
const Li$3 = styled.li `list-style-type:none;
&:hover {
background:#eee;
}
& svg{
  right:0;
  float:right;
  margin-top: 10px;
  fill:#1890ff;
}
`;
const Lableone$1 = styled.p `
font-size:14px;
font-weight: 500;
margin:0;
${props => props && css `
${props => props.labelStyle ? { ...props.labelStyle } : ''}
`}
`;
const MultiSelectEle = styled.div `
width: 100%;
background-color: #fff;
border-radius: 4px;
padding: 1px;
overflow: hidden;
display: flex;
flex-wrap: wrap;
position: relative;

& input {
  font-size: 14px;
  box-sizing: border-box;
  width: 0px;
  min-width: 30px;
  flex-grow: 1;
  border: 0;
  margin: 0;
  outline: 0;
}
${props => props && css `

${(props) => {
    var _a;
    if (((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) < 1) {
        if (props.size === "small") {
            return `
        height: 32px;   & input {
          padding:0px 0px 0px 8px;
      }
     `;
        }
        else {
            return `
        height:40px;
      & input {
    padding:10.5px 14px;
      }
`;
        }
    }
    else {
        return `
      height:auto;
      `;
    }
}} 
border: 1px solid ${props.borderColor};
    ${(props) => {
    if (!props.disabled && !props.error && props.variant === 'outlined') {
        return `
border-radius: 4px;
background-color:transparent;
border: 1px solid ${props.borderColor};
&:hover{
  border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
}
&:focus{
border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor};
}}
&::placeholder {
color: #9b9b9b;`;
    }
    else if (!props.disabled && props.error && props.variant === 'outlined') {
        return `
border-radius: 4px;
background-color:transparent;
border: 1px solid ${(props.helperTextType === "error" && 'red') ||
            (props.helperTextType === "warning" && '#FFCC00') ||
            (props.helperTextType === "success" && 'green')};
`;
    }
    else if (!props.disabled && !props.error && props.variant === 'standard') {
        return `
border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.borderColor};
border-right:unset;
border-radius: 0px; 
border-top: 0px;
border-left:unset;

&:hover{
border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
border-right:unset;
border-radius: 0px;
border-top: 0px; 
border-left:unset;
}
&:focus{
border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor};
border-right:unset;
border-radius: 0px;
border-top: 0px;
border-left:unset;
}

&::placeholder {
color: #9b9b9b;
}
`;
    }
    else if (!props.disabled && props.error && props.variant === 'standard') {
        return `
border-bottom: 1px solid red;
border-right:unset;
border-radius: 0px;
border-top: 0px;
border-left:unset;
border-bottom: 1px solid ${(props.helperTextType === "error" && 'red') ||
            (props.helperTextType === "warning" && '#FFCC00') ||
            (props.helperTextType === "success" && 'green')};
`;
    }
    else if (props.variant === "none") {
        return `
border:0;
&:focus{
border:0;
outline: none;
}
`;
    }
}}
    }
    ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const Chips = styled.div `
    z-index:1;
    box-shadow: 0 1px 2px rgba(0,0,0,.16);
    font-size: 13px;
    max-width: calc(100% - 6px);
    color: rgba(0, 0, 0, 0.87);
    cursor: default;
    display: inline-flex;
    outline: 0;
    align-items: center;
    white-space: nowrap;
    vertical-align: middle;
    justify-content: center;
    text-decoration: none;
    background-color: #e0e0e0;
    & svg {
      color: rgba(0, 0, 0, 0.26);
        width: 16px;
        cursor: pointer;
        height: 16px; 
      }
${props => props && css `
${(props) => {
    if (props.chipsType === "square") {
        return `
border-radius: 6px;
& svg {
border-radius: 6px;
}
`;
    }
    else if (props.chipsType === "circle") {
        return `
        border-radius: 16px;
        & svg { 
      border-radius: 16px;
    }
  `;
    }
}}
${(props) => {
    if (props.size === "medium") {
        return `
    margin: 6.5px;
    padding:2px 1px 2px 8px;
    & svg {
      margin-top: 1.5px;
    }
`;
    }
    else {
        return `
    margin: 3.5px;
    padding:0px 1px 0px 2px;
  `;
    }
}}

`}
`;
const Input$9 = styled.input `
width:auto;
`;
const HelperText$2 = styled.p `
margin: 0;
padding: 0px 4px;
font-size: 12px;
color: gray;
${props => props && css `
${props.helperTextStyle && { ...props.helperTextStyle }}
${(props) => {
    if (props.helperTextType === "error") {
        return `
      color:red;
    `;
    }
    else if (props.helperTextType === "warning") {
        return `
      color:#FFCC00;
    `;
    }
    else if (props.helperTextType === "success") {
        return `
      color:green;
    `;
    }
}}
`}
`;
const SelectLoader$1 = styled.div `
display: flex;
align-items: center;
flex-direction: column;
overflow: hidden;
margin-left: 33px;
border-top: 3px solid #3498db;
`;
const Div$b = styled.div `
position: relative;
& .nodata{
  display:flex;
  align-items:center;
  justify-content:justify-content;
}
`;
const Text$4 = styled.div `
display:flex;
`;
const Span$b = styled.span `
padding: 0 12px;
letter-spacing: 0.5px;
line-height: 28px;
& svg {
  width:30px;
  height:30px;
  object-fit:cover;
  margin-bottom:-8px;
}
& .nodata{
  display:flex;
  align-items:center;
  justify-content:justify-content;
}
    `;
const Close$1 = styled.div `
    ${props => props && css `
${(props) => {
    if (props.size === "medium") {
        return `
margin-top: -28px;
`;
    }
    else {
        return `
margin-top: -24px;
        `;
    }
}}
`}
display: flex;
align-items: center;
flex-direction: column;
overflow: hidden;
color: black;
position: relative;
font-weight: 500;
cursor: pointer;
float:right;
margin-right: 12px;
right: 24px;
width: 16px;
height: 16px;
& img {
  height: 100%;
  width: 100%;
  object-fit:cover; 
  }
`;
const SelectComponent$1 = styled.div `
font-size: 14px;
width:fit-content;
// white-space: nowrap;
overflow: hidden;
font-weight: 400;
text-overflow: ellipsis;
${props => props && css `

${(props) => {
    var _a, _b;
    if (props.size === "small" && ((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return `
padding: 4px 8px;
 `;
    }
    else if (props.size !== 'small' && ((_b = props.data) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        return `
padding: 6.5px 12px;
`;
    }
}}
${(props) => {
    if (props.value) {
        return `
color: rgba(0,0,0,0.87);
`;
    }
    else {
        return `
color: #aba9a9;
`;
    }
}}
${(props) => {
    if (props.disabled) {
        return `
background:#fafafa;
`;
    }
}}
`}
     `;
const SearchCom$1 = styled.div `
${props => props && css `
${(props) => {
    if (props.size !== "small") {
        return `
    top: 52%;
    `;
    }
    else {
        return `
        top: 52%;
    `;
    }
}}
`}
margin-right: 12px;
position: absolute;
display: block;
right: 0px;
width: 16px;
height: 16px;
cursor: pointer;
& img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
`;
const DownArrow$1 = styled.div `
width:23px;
height:23px;
position: absolute;
right:5px;
top: 50%;
transform: translateY(-50%);
cursor: pointer;
& svg{
  fill:rgb(136 132 132 / 74%);
}
`;
const Star$3 = styled.span `
color:red;
margin-left: 5px;
`;

const MultiSelect = (props) => {
    const { size, id, disabled, placeholder, helperTextType, helperTextStyle, defaultValue, variant, error, options, onChangeClaer, onChangeValue, onChange, OnAddNew, Ondelete, helperText, Icon, added, isloaderIcon, label, chipsType, search = true, data, isloader, labelWidth, borderColor, inLineStyles, className, isRequired, showArrow, labelStyle, hoverColor, getOptionLabel } = props;
    const [isfocus, setFocus] = React.useState(false);
    const [inputfocus, setinputfocus] = React.useState(false);
    const [isactive, setisactive] = React.useState(false);
    const [value, setvalue] = React.useState('');
    const [values, setvalues] = React.useState('');
    const [getValue, setValue] = React.useState(value);
    const [position, setposition] = React.useState({});
    const clearValue = () => {
        onChangeClaer && onChangeClaer('');
        onChangeValue && onChangeValue({});
    };
    const dataoptions = () => {
        let data = options.filter((val) => (val.value && val.value.toLowerCase().includes(value.toLowerCase())));
        return data;
    };
    const onFocus = (e) => {
        setFocus(true);
        let pos = cursorGet$2(e, true);
        setposition(Object.assign({}, pos));
    };
    const onchageFun = (e) => {
        setvalue(e.target.value);
        setValue(e.target.value);
        setvalues(e.target.value);
        onChange && onChange(e);
    };
    const onBlur = () => {
        setFocus(false);
        setinputfocus(false);
    };
    //  handle added new data funcy
    const onAdded = (v) => {
        OnAddNew && OnAddNew(v);
        setisactive(!isactive);
        setvalue("");
    };
    const val = (getClass) => {
        var _a;
        let data = options.filter((val) => { var _a; return (val.value && val.value.toLowerCase() === ((_a = getClass === null || getClass === void 0 ? void 0 : getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText.toLowerCase())); });
        if ((_a = getClass === null || getClass === void 0 ? void 0 : getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText) {
            return data === null || data === void 0 ? void 0 : data[0];
        }
    };
    const selectedOption = (e) => {
        var _a;
        debugger;
        let getClass = document.getElementsByClassName('qdm-select-options');
        if (getClass.length > 0) {
            // if (document.getElementsByTagName('input')) {
            //   document.getElementsByTagName('input')[0].blur()
            // }
            if (e.keyCode === 13) {
                // if (val(getClass) && getClass) {
                onChangeValue && onChangeValue(val(getClass));
                // } else {
                //   onChangeValue && onChangeValue({});
                // }
                setisactive(false);
                setinputfocus(false);
                setValue((_a = val(getClass)) === null || _a === void 0 ? void 0 : _a.value);
                setvalues("");
                setvalue("");
            }
            // setoptionValue(value)
            // setValue('');
            // document.getElementsByClassName('inputSearchField')[0].blur();
        }
    };
    const onkeydown = (e) => {
        inputListen$2(e, selectedOption(e), 1);
    };
    // end
    const optionsData = search ? value && value ? dataoptions() && dataoptions() : options : options;
    const selectData = data && data ? data : [];
    // const isclassName = (data: any) => {
    //     const a = selectData?.map((v: any) => {
    //         if ((v?.value || v) === data?.value) { true }
    //     })
    //     return a?.length > 0 ? true : false
    // }
    return React.createElement(DivComp, { id: id, className: className },
        label && React.createElement(Lableone$1, { size: size, autoFocus: inputfocus ? inputfocus : props.autoFocus ? props.autoFocus : (selectData && selectData.length > 0) ? true : false, labelWidth: labelWidth && labelWidth, labelStyle: labelStyle && labelStyle },
            label,
            isRequired && React.createElement(Star$3, null, "*")),
        React.createElement(MultiSelectEle, { data: data, size: size, borderColor: borderColor, value: props.value && props.value, disabled: disabled, variant: variant, hoverColor: hoverColor, error: error, helperTextType: helperTextType, inLineStyles: inLineStyles, onClick: () => {
                !inputfocus && setinputfocus(true);
                !inputfocus && setisactive(true);
            }, style: {
                borderColor: inputfocus ? hoverColor : borderColor
            } },
            (selectData === null || selectData === void 0 ? void 0 : selectData.length) > 0 && React.createElement(SelectComponent$1, { size: size, data: data }, selectData === null || selectData === void 0 ? void 0 : selectData.map((val_) => {
                return React.createElement(Chips, { key: val_.value, onClick: () => Ondelete && Ondelete(val_), size: size, chipsType: chipsType && chipsType },
                    ((val_ === null || val_ === void 0 ? void 0 : val_.value) || val_),
                    React.createElement("svg", { focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                        React.createElement("path", { fill: "currentColor", d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" })));
            })),
            ((selectData === null || selectData === void 0 ? void 0 : selectData.length) === 0 && !inputfocus) && React.createElement(SelectComponent$1, { size: size, data: data }, selectData.length === 0 && placeholder),
            inputfocus &&
                React.createElement(Input$9, Object.assign({}, props, { onChange: e => onchageFun(e), autoFocus: true, onFocus: (e) => onFocus(e), onBlur: onBlur, id: "", className: "", onKeyDown: e => onkeydown(e), value: defaultValue })),
            showArrow &&
                React.createElement(DownArrow$1, { onClick: () => {
                        !inputfocus && setinputfocus(true);
                        !inputfocus && setisactive(true);
                    } },
                    React.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                        React.createElement("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" })))),
        React.createElement(Label$c, null,
            search && React.createElement(SearchCom$1, { size: props.size && props.size },
                "     ",
                React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "search", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                    React.createElement("path", { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" }))),
            ((value && value) || (data && data.length > 0)) && React.createElement(Close$1, { size: size, onClick: () => clearValue(), className: "qdm-select-loader" }, Icon ? Icon : React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "close-circle", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                React.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" }))),
            (helperText && helperText && error) && (React.createElement(HelperText$2, { helperTextStyle: helperTextStyle, helperTextType: helperTextType }, helperText && helperText))),
        React.createElement(Div$b, { className: 'listDiv' }, isfocus && !isloader && !optionsData ? isactive ? React.createElement(Div$b, { className: "qdm-select-div nodata " }, (isfocus && isactive) && React.createElement(React.Fragment, null,
            (added && value) && React.createElement(Add$1, { id: 'search_check_filter', onMouseDown: () => onAdded(value) }, "Add"),
            React.createElement(Span$b, null,
                " ",
                React.createElement("svg", { width: "184", height: "152", viewBox: "0 0 184 152", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
                        React.createElement("g", { transform: "translate(24 31.67)" },
                            React.createElement("ellipse", { "fill-opacity": ".8", fill: "#F5F5F7", cx: "67.797", cy: "106.89", rx: "67.797", ry: "12.668" }),
                            React.createElement("path", { d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z", fill: "#AEB8C2" }),
                            React.createElement("path", { d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z", fill: "url(#linearGradient-1)", transform: "translate(13.56)" }),
                            React.createElement("path", { d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#F5F5F7" }),
                            React.createElement("path", { d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z", fill: "#DCE0E6" })),
                        React.createElement("path", { d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z", fill: "#DCE0E6" }),
                        React.createElement("g", { transform: "translate(149.65 15.383)", fill: "#FFF" },
                            React.createElement("ellipse", { cx: "20.654", cy: "3.167", rx: "2.849", ry: "2.815" }),
                            React.createElement("path", { d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" })))),
                " No data found "))) : "" : React.createElement(Div$b, null, (isfocus && isactive) && React.createElement(Select$4, { className: "qdm-select-div", id: 'search_check_filter' }, isloader ? React.createElement(Text$4, null,
            React.createElement(SelectLoader$1, { className: isloaderIcon ? "" : "qdm-select-loader" }),
            React.createElement(Span$b, null,
                React.createElement(Span$b, { className: isloaderIcon ? "own-qdm-select-loader" : "" },
                    isloaderIcon,
                    "Loading..."))) : React.createElement(React.Fragment, null,
            optionsData.map((opt_) => {
                return (opt_ && opt_.value) && React.createElement(Li$3, { key: opt_.value, className: selectData && selectData.length > 0 ? selectData.map((act_) => {
                        if ((act_.value || act_) === opt_.value) {
                            return "qdm-select-options qdm-multiselect-isactive";
                        }
                        else {
                            return "actives";
                        }
                    }) : "actives", 
                    // className={'actives'}
                    onMouseDown: () => {
                        onChangeValue && onChangeValue(opt_);
                        setisactive(!isactive);
                        setValue(opt_ === null || opt_ === void 0 ? void 0 : opt_.value);
                        setvalue("");
                    } },
                    getOptionLabel ? opt_[getOptionLabel] : opt_.value,
                    " ",
                    (selectData === null || selectData === void 0 ? void 0 : selectData.map((v) => {
                        if (opt_.value === (v.value || v)) {
                            return;
                            //  <svg key={v.value} viewBox="64 64 896 896" focusable="false" data-icon="check" width="1em" height="1em" aria-hidden="true"><path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg>
                        }
                    })));
            }),
            (isactive && isfocus && optionsData.length === 0) ? React.createElement(Span$b, { className: "nodata" },
                React.createElement("svg", { width: "184", height: "152", viewBox: "0 0 184 152", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
                        React.createElement("g", { transform: "translate(24 31.67)" },
                            React.createElement("ellipse", { "fill-opacity": ".8", fill: "#F5F5F7", cx: "67.797", cy: "106.89", rx: "67.797", ry: "12.668" }),
                            React.createElement("path", { d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z", fill: "#AEB8C2" }),
                            React.createElement("path", { d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z", fill: "url(#linearGradient-1)", transform: "translate(13.56)" }),
                            React.createElement("path", { d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#F5F5F7" }),
                            React.createElement("path", { d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z", fill: "#DCE0E6" })),
                        React.createElement("path", { d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z", fill: "#DCE0E6" }),
                        React.createElement("g", { transform: "translate(149.65 15.383)", fill: "#FFF" },
                            React.createElement("ellipse", { cx: "20.654", cy: "3.167", rx: "2.849", ry: "2.815" }),
                            React.createElement("path", { d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" })))),
                " No data found ") : "")))));
};
MultiSelect.defaultProps = {
    disabled: false,
    size: "medium",
    helperTextType: "error",
    label: "",
    chipsType: "square",
    variant: "outlined",
    placeholder: 'Multi Select',
    data: [],
    borderColor: '#9b9b9b',
    isRequired: false,
    hoverColor: '#000',
};

const MultiSelectProps = {
  disabled: false,
  size: ['small', 'medium'],
  helperTextType: ['error', 'warning', 'success'],
  label: '',
  chipsType: ['square', 'circle'],
  variant: ['outlined', 'standard', 'none'],
  placeholder: '',
  data: [],
  borderColor: '#000',
  isRequired: false,
  hoverColor: '#000',
};

const Input$8 = styled.input `
border: 1px solid #9b9b9b;
border-radius: 5px;
background-color: #fff;
padding: 6px 6px;
box-shadow: inset 0 3px 6px rgba(0,0,0,0.1);
width: 100%;
:hover {
border-color: #40a9ff;
}
.focused {
border-color: #40a9ff;
box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

  ${props => props && css `
  ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a DateTimepicker component
const DateTimepicker = (props) => {
    const handleChange = (e) => {
        var _a, _b, _c, _d;
        if ((props === null || props === void 0 ? void 0 : props.maxDate) && ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) <= (props === null || props === void 0 ? void 0 : props.maxDate) || (props === null || props === void 0 ? void 0 : props.minDate) && ((_d = (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) <= (props === null || props === void 0 ? void 0 : props.minDate)) {
            (props === null || props === void 0 ? void 0 : props.onChange) && (props === null || props === void 0 ? void 0 : props.onChange(e));
        }
    };
    /* this is a props variables */
    const { type, onChange, Required } = props;
    return React.createElement(Input$8, Object.assign({ onChange: (e) => handleChange(e), type: type }, props, { required: Required }));
};
// this is a default Props of the component
DateTimepicker.defaultProps = {
    type: "date",
    placeholder: "Date picker",
};

const DateTimepickerProps = {
  type: ['date', 'time'],
  placeholder: '',
  maxDate:0,
  minDate:0
};

const Div$a = styled.div ``;
const Divs$1 = styled.div `
display:flex;`;
const End = styled.input `
-webkit-appearance: none !important;
width: 100%; 
height: 1px;
border: none;
border-radius: 10px;
margin: auto;
transition: all 400ms;
outline:none;
padding: 0;
margin: 0;
${props => props && css `
background-color: ${props.disabled ? "#cbcbcb" : props.color};
&::-moz-range-track { 
width: 100%;
height: 1px;
background-color: ${props.disabled ? "#cbcbcb" : props.color};
border: none;
border-radius: 10px;
margin: auto;
transition: all 400ms;
outline:none;
padding: 0;
margin: 0;
}

&::-webkit-slider-thumb {
-webkit-appearance: none !important;
transform:scale(0.75);
width: 20px;
height: 30px;
border: none;
background-color: ${props.disabled ? "#cbcbcb" : props.color};
border-radius: 40px; 
box-shadow: 0px 0px 0px green;
transition: all 400ms;
outline:none
}
&::-moz-range-thumb {
-webkit-appearance: none !important;
transform:scale(0.75);
width: 20px;
height: 30px;
border: none;
background-color: ${props.disabled ? "#cbcbcb" : props.color};
border-radius: 30px;
box-shadow: 0px 0px 0px green;
transition: all 400ms;
outline:none
}

&::-webkit-slider-thumb:hover {  
transform:scale(0.85);
}
&::-moz-range-thumb:hover{
transform:scale(0.85);
}

&::-webkit-slider-thumb:active {
transform:scale(1);
}
&::-moz-range-thumb:active{
transform:scale(1);
}
${props.inLineStyles && { ...props.inLineStyles }} 
`}

`;
const Pro = styled.div `
text-align: center;
font-family: "Quantico", sans-serif;
font-size: 18px;
display: block;
margin: auto;
padding: 10px 0px;
width: 100%;
${props => props && css `
color: ${props.disabled ? "#cbcbcb" : props.color};
`}
`;
const Start = styled.input `
position: relative;
top: 23px;
-webkit-appearance: none !important;
width: 100%;
height: 1px;
border: none;
border-radius: 10px;
margin: auto;
transition: all 400ms;
outline:none;
padding: 0;
margin: 0;
${props => props && css `
background-color: ${props.disabled ? "#cbcbcb" : props.color};
&::-moz-range-track { 
width: 100%;
height: 1px;
background-color: ${props.disabled ? "#cbcbcb" : props.color};
border: none;
border-radius: 10px;
margin: auto;
transition: all 400ms;
outline:none;
padding: 0;
margin: 0;
}

&::-webkit-slider-thumb {
-webkit-appearance: none !important;
transform:scale(0.75);
width: 20px;
height: 30px;
border: none;
background-color: ${props.disabled ? "#cbcbcb" : props.color};
border-radius: 40px; 
box-shadow: 0px 0px 0px green;
transition: all 400ms;
outline:none
}
&::-moz-range-thumb {
-webkit-appearance: none !important;
transform:scale(0.75);
width: 20px;
height: 30px;
border: none;
background-color: ${props.disabled ? "#cbcbcb" : props.color};
border-radius: 30px;
box-shadow: 0px 0px 0px green;
transition: all 400ms;
outline:none
}

&::-webkit-slider-thumb:hover {  
transform:scale(0.85);
}
&::-moz-range-thumb:hover{
transform:scale(0.85);
}

&::-webkit-slider-thumb:active {
transform:scale(1);
}
&::-moz-range-thumb:active{
transform:scale(1);
}
${props.inLineStyles && { ...props.inLineStyles }} 

`}
`;
const Slider = styled.div `
width: 100%;
`;
const RangeTooltip = styled.label `
${props => props && css `
background: ${props.disabled ? "#cbcbcb" : props.color};
color: #fff;
border-radius: 2px;
padding: 3px 7px;
margin:-10px 0px 0px 4px;
text-align: center;
position: relative;

&::before {
    content: '';
    position: absolute;
    left: -12px;
    top: 50%;
    -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
    height: 0;
    width: 0;
    border: solid 6px ${props.disabled ? "#cbcbcb" : props.color};
    z-index: -1;
    border-top-color: white;
    border-bottom-color: white;
    border-left-color: white;
  }
`}
`;
const Wrapper$5 = styled.div `
width:100%;
position:relative;
`;
const Range = styled.input `
height: 6px;
width: 90%;
border-radius: 5px;
-webkit-appearance: none;
outline: none;
${props => props && css `
background: ${props.disabled ? "#cbcbcb" : props.color};
&::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: ${props.disabled ? "#cbcbcb" : props.color};
      }
      &::-moz-range-thumb {
        border: none;
        height: 14px;
        width: 14px;
        border-radius: 50%;
        background: ${props.disabled ? "#cbcbcb" : props.color};
        cursor: pointer;
      }
      &::-moz-range-track {
        width: 100%;
        height: 3px;
        cursor: pointer;
        background: ${props.disabled ? "#cbcbcb" : props.color};
        border-radius: 5px;
      }
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const Horizontal = styled.div `
`;
const Prolabel = styled.label `
`;
const HorizontalInput = styled.input `
width: 8px;
height: 100%;
border-radius: 5px;
outline: none;
writing-mode: bt-lr;
-webkit-appearance: slider-vertical;
${props => props && css `
background: ${props.disabled ? "#cbcbcb" : props.color};
&::-moz-range-track {
        background: ${props.disabled ? "#cbcbcb" : props.color};
      }
      &::-webkit-slider-thumb {
        background: ${props.disabled ? "#cbcbcb" : props.color};
      }
      &::-moz-range-thumb {
        background: ${props.disabled ? "#cbcbcb" : props.color};
      }
${props.inLineStyles && { ...props.inLineStyles }}
`}

`;

const RangePicker = (props) => {
    const { RangeType, start, value, inLineStyles, orientation, showPercentage, end } = props;
    return React.createElement(Wrapper$5, null, orientation === "vertical" ?
        React.createElement(Div$a, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' },
            React.createElement(Horizontal, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' },
                React.createElement(HorizontalInput, Object.assign({}, props)),
                showPercentage && React.createElement(Prolabel, null, value))) :
        React.createElement(Div$a, null, RangeType === "single" ? React.createElement(Divs$1, null,
            showPercentage && React.createElement(Range, Object.assign({ value: value }, props)),
            React.createElement(RangeTooltip, Object.assign({}, props), props.value))
            :
                React.createElement(Div$a, null,
                    React.createElement(Slider, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' },
                        React.createElement(Start, Object.assign({ value: end }, props)),
                        " ",
                        React.createElement(End, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + '_input', inLineStyles: inLineStyles, value: start }, props)),
                        showPercentage && React.createElement(Pro, Object.assign({}, props), start + "-" + end)))));
};
RangePicker.defaultProps = {
    type: "range",
    min: "0",
    max: "100",
    RangeType: "single",
    color: "#2c3e50",
    orientation: "horizontal"
};

const RangePickerProps = {
  type: ['range'],
  min: 0,
  max: 0,
  RangeType: ['single', 'multiple'],
  color: '#000',
  orientation: ['horizontal', 'vertical'],
};

const Header$5 = styled.header `
box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
width: 100%;
display: flex;
z-index: 100;
box-sizing: border-box;
flex-shrink: 0;
flex-direction: column;
transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
${props => props && css `
position: ${props.position && props.position};
${(props) => {
    if (props.color === "secondary") {
        return `
background-color: #f50057;
color:#fff;
`;
    }
    else if (props.color === "transparent") {
        return `
background-color: transparent;
color:#000;
`;
    }
    else if (props.color === "default") {
        return `
color:rgba(0, 0, 0, 0.87);
background-color: #f5f5f5;
`;
    }
    else if (props.color === "inherit") {
        return `
color:inherit;
`;
    }
    else if (props.color === "primary") {
        return `
color:inherit;
background-color:#3f51b5;
`;
    }
}}
${props.inLineStyles && { ...props.inLineStyles }} 
`}
`;
const Toolbar = styled.div `
padding-left: 16px;
padding-right: 16px;
display: flex;
position: relative;
align-items: center;
min-height: 56px;
color: #fff;
`;

// This a Top of the Header component
const TopHeader$1 = (props) => {
    /* this is a props variables */
    const { children } = props;
    return React.createElement(Header$5, Object.assign({}, props),
        React.createElement(Toolbar, null, children));
};
// this is a default Props of the component
TopHeader$1.defaultProps = {
    position: "static",
    color: "primary",
    children: "Header"
};

const TopHeaderProps = {
  position: ['absolute', 'fixed', 'relative', 'static', 'sticky'],
  color: ['default', 'inherit', 'primary', 'secondary', 'transparent'],
  children: '',
};

const CardEle = styled.div `
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: #fff;
  border-radius: 6px;
  width: 100%;
  ${(props) => props &&
    css `
      ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
styled.div ``;

// This a Card component
const Card$1 = (props) => {
    /* this is a props variables */
    const { children } = props;
    return (React__default.createElement(CardEle, Object.assign({}, props), children && children));
};
// this is a default Props of the component
Card$1.defaultProps = {
    children: "Card"
};

const CardProps = {
  children: '',
};

const CardActionsEle = styled.div `
margin: 0;
padding: 8px;
align-items: block;
height:auto;
border-top: 1px solid rgba(0, 0, 0, 0.12);
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a CardActions component
const CardActions = (props) => {
    /* this is a props variables */
    const { children } = props;
    return (React__default.createElement(CardActionsEle, Object.assign({}, props), children));
};
// this is a default Props of the component
CardActions.defaultProps = {
    children: "CardActions"
};

const CardActionsProps= {
  children: '',
};

const CardHeaderEle = styled.div `
border-bottom: 1px solid rgba(0, 0, 0, 0.12);
display: flex;
padding: 16px;
align-items: center;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const Avatar$3 = styled.div `
flex: 0 0 auto;
margin-right: 16px;
display: flex;
& img{
border-radius: 50%;
overflow: hidden;
width: 3em;
height: 3em;
}
& svg{
border-radius: 50%;
overflow: hidden;
width: 3em;
height: 3em;
}
`;
const Action$1 = styled.div `
justify-content:flex-end;
display: flex;
height:auto;
word-break: break-all;
`;
const Title$2 = styled.div `
margin-right: 16px;
`;
const Label$b = styled.h4 `
width:auto;
margin:0;
`;
const Span$a = styled.h5 `
font-size: 0.875rem;
color: rgba(0, 0, 0, 0.54);
margin:0;
font-weight:400;
`;
const Div$9 = styled.div `
display: flex;
align-items: center;
`;

// This a CardHeader component
const CardHeader = (props) => {
    /* this is a props variables */
    const { children, avatar, action, title, subheader } = props;
    return (React__default.createElement(CardHeaderEle, Object.assign({}, props), (avatar || action || title || subheader) ?
        /* end */
        React__default.createElement(Div$9, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' },
            avatar && React__default.createElement(Avatar$3, { id: (props === null || props === void 0 ? void 0 : props.id) + '_avatar' },
                " ",
                avatar,
                " "),
            title && React__default.createElement(Title$2, null,
                " ",
                React__default.createElement(Label$b, { id: (props === null || props === void 0 ? void 0 : props.id) + '_h4' }, title),
                React__default.createElement(Span$a, { id: (props === null || props === void 0 ? void 0 : props.id) + '_h5' }, subheader),
                " "),
            action && React__default.createElement(Action$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' },
                action,
                " ")) : children));
};
// this is a default Props of the component
CardHeader.defaultProps = {
    children: "CardHeader",
    avatar: "A",
    title: "card title",
    subheader: "card subtitle"
};

const CardHeaderProps = { children: '', avatar: '', title: '', subheader: '' };

const CardContentEle = styled.div `
padding: 16px;
font-size:0.875rem;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a CardContent component
const CardContent = (props) => {
    /* this is a props variables */
    const { children } = props;
    return (React__default.createElement(CardContentEle, Object.assign({}, props),
        " ",
        children,
        " "));
};
// this is a default Props of the component
CardContent.defaultProps = {
    children: "CardContent"
};

const CardContentProps = {
  children: '',
};

const CardMediaEle = styled.div `
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a CardMedia component
const CardMedia = (props) => {
    /* this is a props variables */
    const { children, image } = props;
    return (React__default.createElement(CardMediaEle, Object.assign({}, props),
        " ",
        image ? image : children,
        " "));
};
// this is a default Props of the component
CardMedia.defaultProps = {
    children: "CardMedia"
};

const CardMediaProps = {
  children: '',
};

const Divs = styled.div ``;
const Ul = styled.ul ``;
const Div$8 = styled.div `
${props => props && css `
${(props) => {
    if (props.open) {
        return `
                background-color: rgba(0,0,0,0.5);
                -webkit-tap-highlight-color: transparent;
                z-index: 1;
                position: fixed;
                right: 0px;
                bottom: 0px;
                top: 0px;
                left: 0px;
                
@media (max-width: 768px) { 
background: rgba(0,0,0,.45) !important;
position: fixed !important;
width: 100vw !important; 
height: 100vh !important;
z-index:1000 !important;
top:0;
bottom:0;
right:0;
left:0;
}
`;
    }
}}

`}
`;
const Footer$1 = styled.div `
bottom:0px;
position:absolute;
width: 100%;
justify-content: center;
text-align: center;
height: 60px;
align-items: center;
display: flex;
font-size:0.925rem;
font-weight:500;
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
color:#fff;
 border-top:1px solid #d9d9d93d;
`;
    }
    else if (props.color === "default") {
        return `
color:rgba(61,68,101,.7);
border-top: 1px solid #d9d9d9;
`;
    }
    else if (props.color === "secondary") {
        return `
color:#fff;
border-top:1px solid #d9d9d93d;
`;
    }
}}
`}
`;
const Span$9 = styled.span ``;
const Li$2 = styled.li `
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
border-bottom:1px solid #d9d9d93d;
`;
    }
    else if (props.color === "default") {
        return `
border-bottom: 1px solid #d9d9d9;
`;
    }
    else if (props.color === "secondary") {
        return `
color:#fff;
border-bottom:1px solid #d9d9d93d;
`;
    }
}}

`}
`;
const TopHeader = styled.div `
padding: 10px 20px;
display: flex;
align-items: center;
& a,.close-sidebar ,i{
  text-transform: capitalize;
  text-decoration: none;
  font-weight: bold;
  flex-grow: 1;
}
&.close-sidebar,i{
cursor: pointer;
  font-size: 20px;
}
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
color: #fff;
& a,.close-sidebar ,i{
color: #fff;
}
border-bottom:1px solid #d9d9d93d;
`;
    }
    else if (props.color === "default") {
        return `
color: rgba(61, 68, 101, .7);
& a,.close-sidebar ,i{
color: rgba(61, 68, 101, .7);
}
border-bottom: 1px solid #d9d9d9;
`;
    }
    else if (props.color === "secondary") {
        return `
color: #fff;
& a,.close-sidebar ,i{
color: #fff;
}
border-bottom:1px solid #d9d9d93d;
`;
    }
}}
`}
`;
const Header$4 = styled.div `
display: flex;
overflow: hidden;
& span{
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
width: 90%;
}
& i{
font-size: 8px;
  margin-right: 4px;
}
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
& span{
color: #fff;
}
& i{
color: #5cb85c;
}
`;
    }
    else if (props.color === "default") {
        return `
& span{
color: rgba(61, 68, 101, .7);
}
& i{
color: #5cb85c;
}
`;
    }
    else if (props.color === "secondary") {
        return `
& span{
color: #fff;
}
& i{
color: #5cb85c;
}
`;
    }
}}
`}
`;
const SubLi = styled.li ` 
margin-bottom: 0;
margin-left: 0;
padding-left: 14px;
margin-right: 0;
overflow: hidden;
& a{
text-decoration: none;
align-items: center;
width: 100%;
height: 45px;
line-height: 45px;
padding: 0 1.5rem;
font-size: .8rem;
letter-spacing: 0;
font-weight: 600;
cursor: pointer;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
overflow: hidden;
}

${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
border-top: 1px solid #d9d9d93d;
& a,li{
color: #fff;
}
background: #3f51b5;
&:hover{
cursor:pointer;
a{
color:#000;
}
  background: #fff;
}
`;
    }
    else if (props.color === "default") {
        return `
border-top: 1px solid #d9d9d9;
  & a{
color: rgba(61, 68, 101, .7);
}
&:hover{
cursor:pointer;
a{
color:#3c4250;
}
  background: #fff;
}
`;
    }
    else if (props.color === "secondary") {
        return `
border-top: 1px solid #d9d9d93d;
& a,li{
color: #fff;
}
background: #f50057;
&:hover{
cursor:pointer;
a{
color:#000;
}
  background: #fff;
}
`;
    }
}}
`}
`;
const A$2 = styled.a `
text-decoration: none;
align-items: center;
width: 100%;
height: 45px;
line-height: 45px;
padding: 0 1.5rem;
font-size: 0.925rem;
letter-spacing: 0;
font-weight: 600;
outline: 0;
display: flex;
cursor: pointer;

${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
color: #fff;
&:hover{
color:#000;
  background: #fff;
}
`;
    }
    else if (props.color === "default") {
        return `
color: rgba(61, 68, 101, .7);
&:hover{
color:#3c4250;
  background: #f5f5f9;
}
`;
    }
    else if (props.color === "secondary") {
        return `
color: #fff;
&:hover{
color:#000;
  background: #fff;
}
`;
    }
}}
`}
`;
const Aside = styled.aside `
box-shadow:0 6px 18px 0 rgba(0, 0, 0, 0.18);
  height: 100vh;
  position: absolute;
  transition: all 0.3s ease-in-out;
  z-index: 1000;
  position: fixed;
  overflow: auto;
${props => props && css `
${(props) => {
    if (props.direction === "left") {
        return `
left: 0px;
top: 0px;
`;
    }
    else if (props.direction === "right") {
        return `
right: 0px;
  top: 0px;
`;
    }
}}
${(props) => {
    return `
width:${props.width && props.width + "px"};`;
}}
${(props) => {
    if (props.color === "primary") {
        return `
background: #3f51b5;
color:#fff,
`;
    }
    else if (props.color === "default") {
        return `
background: #fff;
`;
    }
    else if (props.color === "secondary") {
        return `
background: #f50057;
color:#fff,

`;
    }
}}
`}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
const CloseButton = styled.div `
    position: fixed;
    top: 10px;
    border-radius: 8px;
    background-color: #fff;
    cursor: pointer;
    /* border: 1px solid; */
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    & svg{
      width: 20px;
      height: 20px;
    }
    width: 40px;
    height: 40px;
    ${props => props && css `
${(props) => {
    if (props.width) {
        if (props.direction === "left") {
            return `
              left:${props.width + 10}px;`;
        }
        else if (props.direction === "right") {
            return `
              right:${props.width + 10}px;`;
        }
    }
}}
`}
  `;

// This is a Sidebar Menu component
const SideMenu = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    // this is a state of handling variables
    const { open, onClose, data, color } = props;
    const [Isactive, setIsactive] = React.useState("");
    // end
    // handle open sub menu drapdown lists funcy
    const onOpen = (v) => {
        let u = Isactive === v ? "" : v;
        setIsactive(u);
    };
    // end
    // the menu link navigate location path funcy
    const pushPath = (url) => {
        window.history.pushState({ urlPath: url }, "", url);
    };
    // end
    // colors of active menu list
    const colors = () => {
        if (color === "default") {
            return {
                background: "#f5f5f9",
                color: "#3c4250"
            };
        }
        else if (color === "secondary") {
            return {
                background: "#fff",
                color: "#000"
            };
        }
        else if (color === "primary") {
            return {
                background: "#fff",
                color: "#000"
            };
        }
    };
    // if (open) {
    //     // once open the sidebar menu component body of the scroll hidden
    //     document.body.style.overflow = 'hidden';
    // }
    // else{
    //     document.body.style.overflow = 'auto';
    // }
    React.useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    });
    return React.createElement(Div$8, Object.assign({}, props), open &&
        React.createElement(Aside, Object.assign({}, props, { className: `sidebar sidebar-toggle  ${open ? "open_drawer" : "hidden_drawer"}` }),
            React.createElement(CloseButton, { id: (props === null || props === void 0 ? void 0 : props.id) + '_close_div', width: props.width, direction: props.direction, onClick: (e) => onClose && onClose(e) },
                React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_close_svg', className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                    React.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }))),
            React.createElement(React.Fragment, null, props.children ? props.children :
                React.createElement(React.Fragment, null,
                    React.createElement(TopHeader, Object.assign({}, props, { className: "sidebar-brand" }), (data === null || data === void 0 ? void 0 : data.header) && React.createElement("a", null, data === null || data === void 0 ? void 0 : data.header)),
                    (data === null || data === void 0 ? void 0 : data.profile) && React.createElement(Header$4, Object.assign({}, props, { className: "sidebar-header" }),
                        ((_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.image) && React.createElement(Divs, { className: "user-pic" },
                            React.createElement("img", { className: "img-responsive img-rounded", src: (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.image, alt: (_c = data === null || data === void 0 ? void 0 : data.profile) === null || _c === void 0 ? void 0 : _c.alt })),
                        "\u00A0",
                        React.createElement(Divs, { className: "user-info" },
                            ((_d = data === null || data === void 0 ? void 0 : data.profile) === null || _d === void 0 ? void 0 : _d.name) && React.createElement(Span$9, { className: "user-name" },
                                React.createElement("strong", null, (_e = data === null || data === void 0 ? void 0 : data.profile) === null || _e === void 0 ? void 0 : _e.name)),
                            ((_f = data === null || data === void 0 ? void 0 : data.profile) === null || _f === void 0 ? void 0 : _f.dis) && React.createElement(Span$9, { className: "user-role" }, (_g = data === null || data === void 0 ? void 0 : data.profile) === null || _g === void 0 ? void 0 : _g.dis),
                            ((_h = data === null || data === void 0 ? void 0 : data.profile) === null || _h === void 0 ? void 0 : _h.status) && React.createElement(Span$9, { className: "user-status" },
                                React.createElement("i", { className: "fa fa-circle" }),
                                React.createElement(Span$9, null, (_j = data === null || data === void 0 ? void 0 : data.profile) === null || _j === void 0 ? void 0 : _j.status)))),
                    (data === null || data === void 0 ? void 0 : data.footer) && React.createElement(Footer$1, Object.assign({}, props), (_k = data === null || data === void 0 ? void 0 : data.footer) === null || _k === void 0 ? void 0 : _k.data),
                    React.createElement(Divs, { id: "leftside-navigation", className: "nano" },
                        React.createElement(Ul, { id: (props === null || props === void 0 ? void 0 : props.id) + '_ul', className: "nano-content" }, (_l = data === null || data === void 0 ? void 0 : data.menu) === null || _l === void 0 ? void 0 : _l.map((v) => {
                            var _a, _b, _c, _d;
                            if (((_a = v === null || v === void 0 ? void 0 : v.childrens) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                // sebmenu item looping
                                return React.createElement(Li$2, Object.assign({}, props),
                                    React.createElement(A$2, Object.assign({}, props, { style: {
                                            background: (Isactive === (v === null || v === void 0 ? void 0 : v.title)) ? (_b = colors()) === null || _b === void 0 ? void 0 : _b.background : "",
                                            color: (Isactive === (v === null || v === void 0 ? void 0 : v.title)) ? (_c = colors()) === null || _c === void 0 ? void 0 : _c.color : ""
                                        }, onClick: () => onOpen(v === null || v === void 0 ? void 0 : v.title) }), v === null || v === void 0 ? void 0 :
                                        v.icon,
                                        React.createElement(Span$9, null, v === null || v === void 0 ? void 0 : v.title),
                                        Isactive !== (v === null || v === void 0 ? void 0 : v.title) ? React.createElement("i", { className: "arrow fa fa-caret-down pull-right" }) :
                                            React.createElement("i", { className: "arrow fa fa-caret-up pull-right" })), (_d = v === null || v === void 0 ? void 0 : v.childrens) === null || _d === void 0 ? void 0 :
                                    _d.map((l) => {
                                        // sebmenu item of the list 
                                        return React.createElement(Ul, { style: { display: Isactive === (v === null || v === void 0 ? void 0 : v.title) ? "block" : "" } },
                                            React.createElement(SubLi, Object.assign({}, props, { onClick: () => pushPath(v === null || v === void 0 ? void 0 : v.url) }),
                                                React.createElement("a", null, l === null || l === void 0 ? void 0 :
                                                    l.icon, l === null || l === void 0 ? void 0 :
                                                    l.name)));
                                    }));
                            }
                            else {
                                // single item of the list 
                                return React.createElement(Li$2, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + '_li' }, props, { onClick: () => pushPath(v === null || v === void 0 ? void 0 : v.url) }),
                                    React.createElement(A$2, Object.assign({}, props), v === null || v === void 0 ? void 0 :
                                        v.icon,
                                        React.createElement(Span$9, null, v === null || v === void 0 ? void 0 : v.title)));
                            }
                        })))))));
};
// this is a default Props of the component
SideMenu.defaultProps = {
    color: "default",
    direction: "left",
    width: 260,
};

const SidebarProps = { color: ['primary', 'default', 'secondary'], direction: ['left', 'right'], width: 260 };

const RowlEle = styled.div `
overflow: unset;
${props => props && css `
& .qdm-col-12{
    ${props.spacing ? props.spacing * 4 + 'px' : "0px"};
    }
${(props) => {
    if (props.justify)
        return `
justify-content:${props.justify && props.justify};
`;
}}${(props) => {
    if (props.alignItems)
        return `
    align-items:${props.alignItems && props.alignItems};
`;
}}${(props) => {
    if (props.direction)
        return `
    flex-direction:${props.direction && props.direction};
`;
}}
`}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This is a Row component
const Row$4 = (props) => {
    /* this is a props variables */
    const { className } = props;
    return (React__default.createElement(RowlEle, Object.assign({}, props, { className: `${className} qdm-col-row` }), props.children));
};
// this is a default Props of the component
Row$4.defaultProps = {
    alignItems: 'stretch',
    direction: 'row',
    justify: 'flex-start',
    spacing: 2,
};

const RowProps = {
  direction: ['row', 'row-reverse', 'column', 'column-reverse'],
  alignItems: ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'],
  justify: ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'],
  spacing: 0,
};

const Img$6 = styled.img `
width:100%;
`;
const StyledAvatar = styled.div `
background:rgb(204, 204, 204);
display: flex;
justify-content: center;
align-items: center;
text-align: center;
font-size: xx-large;
overflow: hidden;
margin:8px;
text-transform: capitalize;
width: 56px;
height: 56px;
& svg,img,i{
height:100%;
margin:auto;
object-fit: cover;
}

${props => props && css `
    ${(props) => {
    if (props.variant === "circle") {
        return `
border-radius:50%;
  `;
    }
    else if (props.variant === "square") {
        return `
border-radius:0px;
  `;
    }
    else if (props.variant === "rounded") {
        return `
border-radius:8px;
  `;
    }
}}
        ${(props) => {
    if (props.src) {
        return `
width:'100%';
`;
    }
}}
${props => props.inLineStyles && { ...props.inLineStyles }}

    `}
`;

// This a Avatar component
const Avatar$2 = (props) => {
    /* this is a props variables */
    const { src, alt, children, letter } = props;
    return React.createElement(StyledAvatar, Object.assign({}, props), children ? children : src ? React.createElement(Img$6, { id: (props === null || props === void 0 ? void 0 : props.id) + "_image", src: src, alt: alt }) : letter[0]);
};
// this is a default Props of the component
Avatar$2.defaultProps = {
    variant: "circle",
    letter: "Avatar",
    src: "",
    alt: "Image"
};

const AvatarProps = {
  variant: ['circle', 'circular', 'rounded', 'square'],
  letter: 'Avatar',
  src: '',
  alt: 'Image',
};

const Label$a = styled.label ``;
const Spandiv = styled.span `
display: inline-grid;
width: 20px;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;

`;
const StyledBadge = styled.div `
display: flex;
justify-content: center;
align-items: center;
text-align: center;
font-size: 1.25rem;
margin:8px;
text-transform: capitalize;
position:relative;
height:max-content
${props => props.inLineStyles && { ...props.inLineStyles }}
`;
const BadgeCount = styled.span `
position:absolute;
padding: 2px;
font-size: 12px;
transform: scale(1) translate(50%, -50%);
transform-origin: 100% 0%;
width:max-content;
${props => props && css `
${(props) => {
    var _a, _b, _c;
    if (((_a = props === null || props === void 0 ? void 0 : props.anchorOrigin) === null || _a === void 0 ? void 0 : _a.horizontal) === "left") {
        if (((_b = JSON.stringify(props.badgeContent)) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            return `
left:-20px;
            `;
        }
        else {
            return `
left:2%;
            `;
        }
    }
    else if (((_c = props === null || props === void 0 ? void 0 : props.anchorOrigin) === null || _c === void 0 ? void 0 : _c.horizontal) === "right") {
        return `
right:14%;
`;
    }
}}
        ${(props) => {
    var _a, _b, _c, _d;
    if (((_a = props === null || props === void 0 ? void 0 : props.anchorOrigin) === null || _a === void 0 ? void 0 : _a.vertical) === "top") {
        if (((_b = JSON.stringify(props.badgeContent)) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            return `
top:2px;
            `;
        }
        else {
            return `
top:2%;
            `;
        }
    }
    else if (((_c = props === null || props === void 0 ? void 0 : props.anchorOrigin) === null || _c === void 0 ? void 0 : _c.vertical) === "bottom") {
        if (((_d = JSON.stringify(props.badgeContent)) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            return `
bottom:-16px;
            `;
        }
        else {
            return `
bottom:0%;
            `;
        }
    }
}}
        ${(props) => {
    if ((props === null || props === void 0 ? void 0 : props.color) === "secondary") {
        return `
color: #fff;
background-color: #f50057;
    `;
    }
    else if ((props === null || props === void 0 ? void 0 : props.color) === "error") {
        return `
color: #fff;
background-color: #f44336;
    `;
    }
    else if ((props === null || props === void 0 ? void 0 : props.color) === "primary") {
        return `
color: #fff;
background-color: #3f51b5;
    `;
    }
}}
        ${(props) => {
    if ((props === null || props === void 0 ? void 0 : props.overlap) === "circle") {
        return `
border-radius: 12px;
    `;
    }
    else if ((props === null || props === void 0 ? void 0 : props.overlap) === "rectangle") {
        return `
border-radius: 6px;
    `;
    }
}}
        ${(props) => {
    if (!props.badgeContent || props.variant === "dot") {
        return `
min-width: 8px;
min-height: 8px;
    `;
    }
}}
    `}
`;

// This a Badge component
const Badge = (props) => {
    var _a;
    /* this is a props variables */
    const { anchorOrigin, overlap, color, badgeContent, children } = props;
    // This is a count Modify to Stringify funcy
    const countModifyToStringify = (c) => {
        return JSON.stringify(c);
    };
    return React.createElement(StyledBadge, Object.assign({}, props),
        children,
        React.createElement(BadgeCount, { id: (props === null || props === void 0 ? void 0 : props.id) + '_span', badgeContent: badgeContent && badgeContent, overlap: overlap, color: color, anchorOrigin: anchorOrigin && anchorOrigin }, (((_a = JSON.stringify(badgeContent)) === null || _a === void 0 ? void 0 : _a.length) > 1) ? React.createElement(Label$a, null,
            React.createElement(Spandiv, null, countModifyToStringify(badgeContent)),
            "+") : badgeContent));
};
// this is a default Props of the component
Badge.defaultProps = {
    variant: "standard",
    color: "primary",
    overlap: "rectangle",
    anchorOrigin: {
        horizontal: 'right',
        vertical: 'top'
    },
    children: "B"
};

const BadgeProps = {
  variant: ['standard', 'dot'],
  color: ['default', 'error', 'primary', 'secondary'],
  overlap: ['rectangle', 'circle'],
  anchorOrigin: {
    horizontal: ['right', 'left'],
    vertical: ['top', 'bottom'],
  },
  children: '',
};

const Label$9 = styled.label `
align-items: center;
display: flex;
`;
const Div$7 = styled.div `
width: max-content;
align-items: center;
display: flex;
`;
const Span$8 = styled.span `
cursor: pointer;
float: right;
font-size: 16px;
padding-left: 8px;
`;
const StyledChip = styled.div `
border:1px solid #d3d2d2;
display: inline-block;
font-size: 13px;
font-weight: 500;
width: max-content;
height: fit-content;
color: rgba(0,0,0,0.6);
cursor: pointer;
padding:0px 12px;
margin-right: 6px;
margin-bottom: 6px;
background-color: #fff;
& img,svg{
float: left;
margin: 0 8px 0 -12px;
height: 32px;
width: 32px;
border-radius: 50%;
}
& span{
cursor: pointer;
float: right;
font-size: 16px;
padding-left: 8px;
}
}
${props => props && css `
${(props) => {
    if (props.variant === "circle") {
        return `
border-radius:30px;
  `;
    }
    else if (props.variant === "square") {
        return `
border-radius:6px;
  `;
    }
}}
${props => props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a Chip component
const Chip = (props) => {
    /* this is a props variables */
    const { UserIcon, closeIcon, name } = props;
    return React.createElement(StyledChip, Object.assign({}, props), props.children ? props.children
        // end
        :
            React.createElement(Div$7, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' },
                (UserIcon || name) && React.createElement(Label$9, null,
                    UserIcon && UserIcon,
                    " ",
                    name && name),
                React.createElement(Span$8, null, closeIcon ? closeIcon : React.createElement("i", { className: "fa fa-times" }))));
};
// this is a default Props of the component
Chip.defaultProps = {
    variant: "circle",
    name: "Chip"
};

const ChipProps = { variant: ['circle', 'square'], name: '' };

const StyledList = styled.ul `
width: 100%;
background-color: #fff;

${(props) => {
    return `
            margin-top:${props.marginVertical}px;
            margin-bottom:${props.marginVertical}px;
          `;
}}

      ${(props) => {
    return `
            margin-left:${props.marginHorizontal}px;
            margin-right:${props.marginHorizontal}px;
          `;
}}

      ${(props) => {
    return `
            padding-top:${props.paddingVertical}px;
            padding-bottom:${props.paddingVertical}px;
          `;
}}

      ${(props) => {
    return `
            padding-left:${props.paddingHorizontal}px;
            padding-right:${props.paddingHorizontal}px;
          `;
}}
      
${(props) => {
    if (props.orientation === "horizontal") {
        return `
            display: flex;
          `;
    }
}}

${(props) => {
    if (props.listItemWidth === '100%') {
        return `
            & li{
                min-width:${props.listItemWidth};
            }
          `;
    }
    else {
        return `
            & li{
                min-width:${props.listItemWidth}px;
            }
          `;
    }
}}

${props => props.inLineStyles && { ...props.inLineStyles }}
`;
const Wrapper$4 = styled.div `
width:100%;
height:100%;
overflow: auto;
&::-webkit-scrollbar{
    width: 5px;
    height: 8px;
    background: #F6F6F6;
}
&::-webkit-scrollbar-thumb {
   background-color: #A8A8A8;
   border-radius: 3px;
}
${(props) => {
    if (props.width) {
        return `
            width:${props.width}px;
          `;
    }
}}
${(props) => {
    if (props.height) {
        return `
            height:${props.height}px;
          `;
    }
}}
      
`;

// This is a List component
const List$1 = (props) => {
    return React.createElement(Wrapper$4, Object.assign({}, props),
        React.createElement(StyledList, Object.assign({}, props, { id: (props === null || props === void 0 ? void 0 : props.id) + '_ul' }),
            props.children,
            " "));
};
// this is a default Props of the component
List$1.defaultProps = {
    children: "List",
    orientation: "vertical",
    listItemWidth: '100%',
    marginVertical: 0,
    marginHorizontal: 0,
    paddingVertical: 8,
    paddingHorizontal: 8,
};

const ListProps = {
  children: '',
  orientation: ['vertical', 'horizontal'],
  listItemWidth: '',
  marginVertical: 0,
  marginHorizontal: 0,
  paddingVertical: 0,
  paddingHorizontal: 0,
};

const StyledListItem = styled.li `
align-items: flex-start;
width: 100%;
display: flex;
position: relative;
box-sizing: border-box;
text-align: left;
align-items: center;
justify-content: flex-start;
text-decoration: none;

${(props) => {
    return `
            margin-top:${props.marginVertical}px;
            margin-bottom:${props.marginVertical}px;
          `;
}}

      ${(props) => {
    return `
            margin-left:${props.marginHorizontal}px;
            margin-right:${props.marginHorizontal}px;
          `;
}}

      ${(props) => {
    return `
            padding-top:${props.paddingVertical}px;
            padding-bottom:${props.paddingVertical}px;
          `;
}}

      ${(props) => {
    return `
            padding-left:${props.paddingHorizontal}px;
            padding-right:${props.paddingHorizontal}px;
          `;
}}

${props => props.inLineStyles && { ...props.inLineStyles }}
`;
const Avatar$1 = styled.div `
margin-top: 8px;
min-width: 56px;
flex-shrink: 0;
& img,svg,i{
width: 40px;
height: 40px;
display: flex;
overflow: hidden;
position: relative;
font-size: 1.25rem;
align-items: center;
flex-shrink: 0;
line-height: 1;
user-select: none;
border-radius: 50%;
justify-content: center;
}
`;
const Title$1 = styled.span `
font-size: 1rem;
font-weight: 500;
line-height: 1.5;
letter-spacing: 0.00938em;
color:rgba(0,0,0,.85);
width: 66%;
`;
const Dis = styled.p `
color: rgba(0, 0, 0, 0.54);
font-size: 0.875rem;
font-weight: 400;
line-height: 1.43;
letter-spacing: 0.01071em;
padding: 0;
margin: 0;
`;
const Action = styled.div `
top: 50%;
right: 16px;
position: absolute;
transform: translateY(-50%);
`;

// This is a ListItem component
const ListItem = (props) => {
    /* this is a props variables */
    const { profile, title, description, action, children } = props;
    return React.createElement(StyledListItem, Object.assign({}, props), children ? children :
        React.createElement(React.Fragment, null,
            profile && React.createElement(Avatar$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_avatar_div' }, profile),
            React.createElement(Title$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_title_span' },
                title,
                " ",
                React.createElement(Dis, { id: (props === null || props === void 0 ? void 0 : props.id) + '_title_p' }, description),
                " "),
            action && React.createElement(Action, { id: (props === null || props === void 0 ? void 0 : props.id) + '_action_div' }, action)));
};
// this is a default Props of the component
ListItem.defaultProps = {
    title: "List Item",
    description: "List Item Descaription",
    profile: "L",
    action: "Click",
    marginVertical: 0,
    marginHorizontal: 0,
    paddingVertical: 8,
    paddingHorizontal: 16,
};

const ListItemProps = {
  title: '',
  description: '',
  profile: '',
  action: '',
  marginVertical: 0,
  marginHorizontal: 0,
  paddingVertical: 0,
  paddingHorizontal: 0,
};

const Styledcarousel = styled.div `
display: flex;
justify-content: center;
align-content: center;
height: 100%;
width: 100%;
overflow: auto;
`;
const CarouselCom = styled.div `
width: 100%;
display: flex;
align-content: center;
height: auto;
background-color: #ffffff;
border-radius: 10px;
overflow: auto;
`;
const Dots = styled.div `
text-align:center;
`;
const Span$7 = styled.span ``;
const Div$6 = styled.div ``;
const Left = styled.div `
align-self: center;
height:0;
width: 2em;
padding:0;
margin: 0.5em;
border-top: 1em solid transparent;
border-bottom: 1em solid transparent;
cursor: pointer;
${props => props && css `
${(props) => {
    if (props.Fadedleft) {
        return `border-left:1em solid #3f51b570;`;
    }
    else {
        return `border-left:1em solid #3f51b5;`;
    }
}}
    `}
`;
const Right = styled.div `
align-self: center;
height:0;
width: 2em;
padding:0;
margin: 0.5em;
border-top: 1em solid transparent;
border-bottom: 1em solid transparent;
cursor: pointer;
${props => props && css `
${(props) => {
    if (props.Fadedright) {
        return `border-right:1em solid #3f51b570;`;
    }
    else {
        return `border-right:1em solid #3f51b5;`;
    }
}}
    `}
`;
const Img$5 = styled.img `
width: 190px;
height: 130px;
object-fit: cover;
margin: auto 0.1em;
border-radius: 5px;
animation: appear 1.5s ease-in;
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Carousel component
const Carousel = (props) => {
    var _a;
    /* this is a props variables */
    const { itemsToShow, itemsToScroll, dots, arrow, inLineStyles } = props;
    // this is a state of handling variable
    const data = (_a = props === null || props === void 0 ? void 0 : props.data) !== null && _a !== void 0 ? _a : props === null || props === void 0 ? void 0 : props.children;
    const [left, setleft] = React.useState(true);
    const [right, setright] = React.useState(false);
    const [start, setstart] = React.useState(0);
    const [finish, setfinish] = React.useState(itemsToShow);
    // end
    // handle left Click
    const leftClick = () => {
        if (start > 0 && finish > 0) {
            setfinish(finish - itemsToScroll);
            setstart(start - itemsToScroll);
            setleft(false);
            setright(false);
        }
        else {
            setleft(true);
        }
    };
    // end
    // handle right Click
    const rightClick = () => {
        if (finish < data.length) {
            setfinish(finish + itemsToScroll);
            setstart(start + itemsToScroll);
            setright(false);
            setleft(false);
        }
        else {
            setleft(false);
            setright(true);
        }
    };
    // end
    // the start and finish slice limit show data
    const startindex = start;
    const finishindex = finish;
    // end
    return (React.createElement(React.Fragment, null,
        React.createElement(Styledcarousel, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + '_div' }, props),
            arrow && React.createElement(Right, { Fadedright: left, onClick: () => leftClick() }),
            React.createElement(CarouselCom, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' }, props), (props === null || props === void 0 ? void 0 : props.children) ? props === null || props === void 0 ? void 0 : props.children : data === null || data === void 0 ? void 0 : data.slice(startindex, finishindex).map((image, imageindex) => {
                return (React.createElement(Div$6, { key: imageindex },
                    React.createElement(Img$5, { inLineStyles: inLineStyles && inLineStyles, src: image, alt: imageindex })));
            })),
            arrow && React.createElement(Left, { Fadedleft: right, onClick: () => rightClick() })),
        dots && React.createElement(Dots, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' }, data.map((dot, i) => {
            return React.createElement(Span$7, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div', key: i, className: (start === i || dot === i) ? "dot_Carousel active_Carousel" : "dot_Carousel", onClick: () => {
                    setstart(i);
                    setfinish(i + itemsToScroll);
                } });
        }))));
};
// this is a default Props of the component
Carousel.defaultProps = {
    itemsToShow: 1,
    itemsToScroll: 1,
    arrow: true,
    data: ["https://fmlainsights.lexblogplatformthree.com/wp-content/uploads/sites/311/2011/04/catpaw.jpg",
        "https://i.ytimg.com/vi/W-PBFMECvTE/maxresdefault.jpg"]
};

const CarouselProps = {
  itemsToShow: '',
  itemsToScroll: '',
  arrow: true,
  data: '',
};

const Button$3 = styled.button `
outline: none;
margin:4px;
padding:6px;
border-radius: 4px;
border:none;
font-weight: 500;   
opacity: 0.9; 
font-size: 12px;
cursor: pointer;
box-shadow:0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
${props => props && css `
${(props.value) && props.activeStyles && { ...props.activeStyles }}
${(!props.value) && props.nonactiveStyles && { ...props.nonactiveStyles }}
${(props) => {
    if (props.value) {
        return `
background: #2185D0;
color: #fff;

`;
    }
    else {
        return `
color: #728691;
background: #F4F5F8;
`;
    }
}}
`}
`;
const Label$8 = styled.div `
font-size: 16px;
font-weight: 600;
margin-bottom: 6px;
${props => props && css `
${(props) => {
    if (props.disabled) {
        return `
rgb(190 190 190)`;
    }
    else {
        return `
color: rgba(0, 0, 0, 0.87);
`;
    }
}}
`}
`;
const TopSelectEle = styled.div `
width:100%;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a TopSelect component
const TopSelect = (props) => {
    /* this is a props variables */
    const { label, options, disabled, onChange, activeStyles, nonactiveStyles, multiple } = props;
    // end
    // state
    const [selected, setSelected] = React__default.useState((props === null || props === void 0 ? void 0 : props.value) ? props === null || props === void 0 ? void 0 : props.value : props.multiple ? [] : {});
    // end
    const getSelected = (item) => {
        props.options && props.options.map((data) => {
            if ((data === null || data === void 0 ? void 0 : data.value) === (item === null || item === void 0 ? void 0 : item.value)) {
                //multile selection statement
                if (multiple) {
                    if (selected.find((l) => l.value === (item === null || item === void 0 ? void 0 : item.value)) === undefined) {
                        onChange && onChange([...selected, Object.assign({}, data)]);
                        setSelected([...selected, Object.assign({}, data)]);
                    }
                    else {
                        const filteredData = selected.filter((l) => (l === null || l === void 0 ? void 0 : l.value) != (item === null || item === void 0 ? void 0 : item.value));
                        props.onChange && props.onChange(filteredData);
                        setSelected(filteredData);
                    }
                }
                else {
                    //single selection statement
                    if ((selected === null || selected === void 0 ? void 0 : selected.value) === (data === null || data === void 0 ? void 0 : data.value)) {
                        props.onChange && props.onChange({});
                        setSelected({});
                    }
                    else {
                        props.onChange && props.onChange(data);
                        setSelected(data);
                    }
                }
            }
        });
    };
    const isActive = (val) => {
        if (selected.filter((l) => l.value === val.value).length > 0) {
            return true;
        }
        else {
            return false;
        }
    };
    // end
    return (React__default.createElement(TopSelectEle, Object.assign({}, props),
        React__default.createElement(Label$8, { disabled: disabled }, label), options === null || options === void 0 ? void 0 :
        options.map((val) => {
            return React__default.createElement(Button$3, { disabled: disabled, onClick: () => getSelected(val), value: multiple ? isActive(val) : (selected === null || selected === void 0 ? void 0 : selected.label) === val.label ? true : false, activeStyles: activeStyles && activeStyles, nonactiveStyles: nonactiveStyles && nonactiveStyles }, val.label);
        })));
};
// this is a default Props of the component
TopSelect.defaultProps = {
    label: "Top Select",
    options: [{ label: 'Top Select', value: 'Top Select' }],
    disabled: false,
};

const TopSelectProps = {
  label: '',
  options: [],
  disabled: false,
};

const StyledImage$1 = styled.img `
width:100%;
height:100%;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This a Image component
const Image = (props) => {
    /* this is a props variables */
    const { src, alt } = props;
    // this is a state of handling variables
    // const [imagecheck, seterr] = React.useState(src);
    // // end
    // // the images not found or image url wrong to identify funcy
    // const errorHandler = () => {
    //     seterr("https://cdn.dribbble.com/users/1408464/screenshots/6377404/404_illustration.png");
    // }
    // end
    return React.createElement(StyledImage$1, Object.assign({ id: props === null || props === void 0 ? void 0 : props.id }, props, { src: src }));
};
// this is a default Props of the component
Image.defaultProps = {
    alt: "Image",
    disabled: false,
    src: "https://cdn.dribbble.com/users/1408464/screenshots/6377404/404_illustration.png"
};

const ImageProps = {
  alt: '',
  disabled: false,
  src: '',
};

const A$1 = styled.a `
/* color: rgba(0,0,0,.85); */
text-decoration: none;
display: block;
cursor: pointer;
/* border-bottom: 1px solid #f0f0f0; */
background-color: #fff;
&:hover {background-color: #dddddd63;}

${props => props && css `

${(props) => {
    if (props.dropDownTextSize) {
        return `
          font-size:${props.dropDownTextSize}px;
        `;
    }
}}

${(props) => {
    return `
            margin:${props.dropdownListMargin}px;
          `;
}}

      ${(props) => {
    return `
            padding:${props.dropdownListPadding}px;
          `;
}}

`}
`;
const HelperText$1 = styled.p `
margin: 0;
padding: 0px 4px;
font-size: 12px;
${props => props && css `
${props.helperTextStyle && { ...props.helperTextStyle }}
${(props) => {
    if (props.helperTextType === "error") {
        return `
color:red;
`;
    }
    else if (props.helperTextType === "warning") {
        return `
color:#FFCC00;
`;
    }
    else if (props.helperTextType === "success") {
        return `
color:green
`;
    }
    else {
        return `
color:gray;
`;
    }
}}
`}
`;
const DropdownCom = styled.div `
position: relative;
display: inline-block;
width:100%;
`;
const Button$2 = styled.div `
background-color: #fff;
color: rgba(0,0,0,.85);
border-radius: 4px;
padding:4px 8px;
font-size: 16px;
border: 1px solid #d9d9d9;
white-space: nowrap;
cursor: pointer;
outline:none;
display: flex;
align-items: center;
&:hover,:focus {
background-color: #dddddd63;
}
/* &::after {
  content: "";
  float: right;
  margin:9px 4px 0px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #CCC;
} */
  ${props => props && css `

${props.inLineStyles && { ...props.inLineStyles }}

`}
  `;
const Text$3 = styled.span `
flex:1;
`;
const SVG = styled.div `
width:20px;
height:20px;
`;
const Div$5 = styled.div `
position: absolute;
background-color: #fff;
width: 100%;
padding:0px;
z-index: 1;
margin-top: 10px;
display: block;
max-height: 150px;
overflow: auto;

  ${props => props && css `

  ${(props) => {
    if (props.elevation === '1') {
        return `
        box-shadow: 0 3px 3px rgba(0,0,0,0.2);
            `;
    }
    else if (props.elevation === '2') {
        return `
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        `;
    }
    else if (props.elevation === '3') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.15), 
        0 2px 2px rgba(0,0,0,0.15), 
        0 4px 4px rgba(0,0,0,0.15), 
        0 8px 8px rgba(0,0,0,0.15);
        `;
    }
    else if (props.elevation === '4') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
              0 2px 2px rgba(0,0,0,0.12), 
              0 4px 4px rgba(0,0,0,0.12), 
              0 8px 8px rgba(0,0,0,0.12),
              0 16px 16px rgba(0,0,0,0.12);
        `;
    }
    else if (props.elevation === '5') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.11), 
              0 2px 2px rgba(0,0,0,0.11), 
              0 4px 4px rgba(0,0,0,0.11), 
              0 8px 8px rgba(0,0,0,0.11), 
              0 16px 16px rgba(0,0,0,0.11), 
              0 32px 32px rgba(0,0,0,0.11);
        `;
    }
    else {
        return `
          box-shadow:none;
        `;
    }
}}

  `}
`;
const Label$7 = styled.p `
margin: auto;
font-size:14px;
font-weight: 500;
${props => props && css `
${props => props.labelStyle ? { ...props.labelStyle } : ''}
`}
`;
const Star$2 = styled.span `
color:red;
margin-left: 5px;
`;

// This a Dropdown component
const Dropdown$1 = (props) => {
    var _a, _b, _c;
    /* this is a props variables */
    const { onChange, onClick, inLineStyles, elevation, dropdownListPadding, dropdownListMargin, dropDownTextSize, className, id, name, options, placeholder, label, 
    // isApi,
    isRequired, labelStyle } = props;
    const node = React.useRef(null);
    const activeColor = props.activeTextColor ? props.activeTextColor : (_a = Dropdown$1.defaultProps) === null || _a === void 0 ? void 0 : _a.activeTextColor;
    const dropDownColor = props.dropDownTextColor ? props.dropDownTextColor : (_b = Dropdown$1.defaultProps) === null || _b === void 0 ? void 0 : _b.dropDownTextColor;
    const [dropdown, setdropdown] = React.useState(false);
    const [activeSelect, setActiveSelect] = React.useState((_c = props === null || props === void 0 ? void 0 : props.value) !== null && _c !== void 0 ? _c : {});
    const [Apivalues, setApivalues] = React.useState(options);
    const Handleopen = () => {
        setdropdown(!dropdown);
    };
    const HandleChange = (value, e) => {
        // debugger
        setActiveSelect(value);
        Handleopen();
        onChange && onChange(value);
        onClick && onClick(e);
    };
    function isValidHttpUrl(string) {
        let url;
        try {
            url = new URL(string);
        }
        catch (_) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }
    function apiResponseModifier(data) {
        let validatedData = Array.isArray(data) ? data : [data];
        let result = validatedData.reduce((allData, eachData) => {
            let resultData = { label: eachData[props === null || props === void 0 ? void 0 : props.keyName], value: eachData[props === null || props === void 0 ? void 0 : props.valueName] };
            return [...allData, resultData];
        }, []);
        setApivalues([...result]);
        // setActiveSelect(result[0] ?? props?.value)
    }
    React.useEffect(() => {
        let check = isValidHttpUrl(props.Url);
        if (check) {
            fetch(props.Url, {
                method: "GET"
            })
                .then(result => result.json())
                .then(data => {
                console.log('data', data);
                apiResponseModifier(data);
                // const res_api = data;
                // setApivalues(res_api);
            });
        }
    }, []);
    const activeData = (activeSelect) => {
        return (activeSelect === null || activeSelect === void 0 ? void 0 : activeSelect.label) ? activeSelect.label : props.defaultValue ? props.defaultValue : props.placeholder;
    };
    const selectClassName = (activeSelect) => {
        return (activeSelect === null || activeSelect === void 0 ? void 0 : activeSelect.label) ? 'selectHolder' : 'placeHolder';
    };
    const isactiveData = (activeSelect) => {
        var _a;
        return (_a = activeSelect === null || activeSelect === void 0 ? void 0 : activeSelect.label) !== null && _a !== void 0 ? _a : '';
    };
    React.useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
    function handleClick(e) {
        var _a;
        // debugger
        if ((_a = node === null || node === void 0 ? void 0 : node.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            // inside click
            return;
        }
        // outside click
        setdropdown(false);
    }
    React.useEffect(() => {
        setApivalues(options);
    }, [options]);
    React.useEffect(() => {
        setActiveSelect(props === null || props === void 0 ? void 0 : props.value);
    }, [props === null || props === void 0 ? void 0 : props.value]);
    return (React.createElement(DropdownCom, { labelStyle: labelStyle && labelStyle, ref: node, id: id, className: className, name: name },
        label && (React.createElement(Label$7, { labelStyle: labelStyle && labelStyle },
            label,
            isRequired && React.createElement(Star$2, null, "*"))),
        React.createElement(Button$2, { inLineStyles: inLineStyles, className: "dropDownButton", onClick: () => Handleopen && Handleopen() },
            React.createElement(Text$3, Object.assign({}, props, { id: (props === null || props === void 0 ? void 0 : props.id) + '_span', 
                // labelStyle={labelStyle && labelStyle}
                className: selectClassName(activeSelect) }), JSON.stringify(activeSelect) !== '{}' ? (activeData(activeSelect)) : (React.createElement("span", { id: (props === null || props === void 0 ? void 0 : props.id) + '_span', style: { color: 'B6B6B6' } }, activeData(activeSelect)))),
            React.createElement(SVG, { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', className: "svgIcon" },
                React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                    React.createElement("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" })))),
        dropdown && (React.createElement(Div$5, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', elevation: elevation },
            Apivalues.map((v) => {
                return (React.createElement(A$1, { dropDownTextSize: dropDownTextSize, dropdownListMargin: dropdownListMargin, dropdownListPadding: dropdownListPadding, onClick: (e) => HandleChange && HandleChange(v, e), 
                    // href={v?.url??""}
                    style: {
                        opacity: v.label !== isactiveData(activeSelect) ? 0.7 : 1,
                        color: v.label === isactiveData(activeSelect) ? activeColor : dropDownColor,
                    } }, v.label));
            }),
            ((Apivalues.length === 0) ? React.createElement("span", null,
                React.createElement("svg", { width: "50px", height: "23px", viewBox: "0 0 184 152", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
                        React.createElement("g", { transform: "translate(24 31.67)" },
                            React.createElement("ellipse", { "fill-opacity": ".8", fill: "#F5F5F7", cx: "67.797", cy: "106.89", rx: "67.797", ry: "12.668" }),
                            React.createElement("path", { d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z", fill: "#AEB8C2" }),
                            React.createElement("path", { d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z", fill: "url(#linearGradient-1)", transform: "translate(13.56)" }),
                            React.createElement("path", { d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#F5F5F7" }),
                            React.createElement("path", { d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z", fill: "#DCE0E6" })),
                        React.createElement("path", { d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z", fill: "#DCE0E6" }),
                        React.createElement("g", { transform: "translate(149.65 15.383)", fill: "#FFF" },
                            React.createElement("ellipse", { cx: "20.654", cy: "3.167", rx: "2.849", ry: "2.815" }),
                            React.createElement("path", { d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" })))),
                "No data found ") : ''))),
        (props.helperText && props.error) && (React.createElement(HelperText$1, { helperTextType: props.helperTextType, helperTextStyle: props.helperTextStyle, error: props === null || props === void 0 ? void 0 : props.error }, props.helperText && props.helperText))));
};
// this is a default Props of the component
Dropdown$1.defaultProps = {
    elevation: '1',
    fullWidth: true,
    // helperTextType: "",
    dropDownTextSize: 14,
    dropDownTextColor: '#000',
    activeTextColor: '#000',
    dropdownListMargin: 0,
    dropdownListPadding: 8,
    options: [
    // { label: 'Option', value: 'url' },
    // { label: 'Option 1', value: 'url' },
    ],
    label: '',
    isRequired: false,
    Url: '',
    keyName: '',
    valueName: ''
};

const DropdownProps = {
  elevation: ['0', '1', '2', '3', '4', '5'],
  fullWidth: true,
  dropDownTextSize: 0,
  dropDownTextColor: '#000',
  activeTextColor: '#000',
  dropdownListMargin: 0,
  dropdownListPadding: 0,
  options: [],
  label: '',
  isRequired: false,
  Url: 'https://jsonplaceholder.typicode.com/users',
  keyName: 'name',
  valueName: 'id'
};

const TableCom$1 = styled.table `
width:100%;
border-collapse:collapse;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const TableComponent$1 = styled.div `overflow:auto;
box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
border-radius:4px;
`;
const Thead$1 = styled.thead ``;
const Span$6 = styled.span ``;
const Tr$1 = styled.tr `
border-bottom:1px solid rgba(224, 224, 224, 1);
`;
const Countlist$1 = styled.span `
padding: 4px;
`;
const Tbody$1 = styled.tbody ``;
const Label$6 = styled.span `flex-grow:1;
padding: 4px 14px;
font-size: 18px;
font-weight: 500;
text-transform: capitalize;
`;
const Nodata$1 = styled.div `
text-align: center;
justify-content: center;
display: flex;
font-size: 15px;
text-transform: capitalize;
font-weight: 500;
line-height: 40px;`;
const Input$7 = styled.input `
padding: 5px 20px 5px 5px;
margin:8px 0px;
border-radius: 4px;
outline: none;
font-size: 14px;
box-sizing: border-box;
cursor: revert;
border: 1px solid #ddd;
&:hover{
border: 1px solid #ddd;
}
&:focused{
border: 1px solid #2bb9bd;
}

&::placeholder {
color: #9b9b9b;
}
`;
const Header$3 = styled.div `
width:100%;
height: 50px;
line-height: 50px;
display:flex; 
${props => props && css `
${(props) => {
    if (props.search) {
        return `
::after {
    content: "\f002";
    font-family: FontAwesome;
    margin-left: -25px;
    margin-right: 25px;
    color:#aaa;
}
`;
    }
}}
`}

`;
const Th$1 = styled.th `
padding:12px;margin:0px;`;
const Td$1 = styled.td `
padding:12px;margin:0px;
&.action{
display: flex;
justify-content: space-around;
}
& span{
cursor:pointer;
}`;
const Pagination$1 = styled.div `
display: flex;
width: 100%;
text-align: right;
@media (max-width: 376px) { 
justify-content: end;
margin: 10px 0px 10px 20px;
}
@media (min-width: 377px) { 
justify-content: flex-end;
margin: 10px 0px 10px -20px;
}
& a{
text-decoration:none;
}
& .count{
cursor:pointer;
padding: 6px 12px;
margin-left:-1px;
font-size: 16px;
font-weight: 500;
letter-spacing: 1px;
color:#337ab7;
float:left;
& select {
align-items: center;
border: none;
margin: 0;
padding: 0;
outline:none;
}
}  
& .disabled{
color: #777;
cursor:not-allowed;
padding: 6px 12px;
margin-left:-1px;
font-size: 16px;
font-weight: 500;
letter-spacing: 1px;
float:left;
}
`;
const Select$3 = styled.select `
font-size: 16px;`;
const Option$2 = styled.option ``;

// This a table component
const Table = (props) => {
    /* this is a props variables */
    const { data, edit, header, deleted, deletedfun, title, search, paginationCount, editfun, editicon, deletedicon, showdata } = props;
    // this is a state of handling variables
    const [pager, setPage] = React.useState(0);
    const [stateshowdata, setPageshowdata] = React.useState(showdata);
    const [value, setvalue] = React.useState("");
    //   end 
    // this is a data of table colums(Headers)
    let dataColumns = header;
    // this is a data of table rows
    let dataRows = data;
    const datalistcount = (l) => {
        setPageshowdata(JSON.parse(l));
    };
    const handleChnage = (e) => {
        setvalue(e.target.value);
    };
    const maped = () => {
        const data = dataRows === null || dataRows === void 0 ? void 0 : dataRows.filter((v) => { var _a; return (_a = ((v === null || v === void 0 ? void 0 : v.name).toLowerCase())) === null || _a === void 0 ? void 0 : _a.includes(value === null || value === void 0 ? void 0 : value.toLowerCase()); });
        return data;
    };
    const mappedData = search ? value ? maped() : dataRows : dataRows;
    return React.createElement(TableComponent$1, null,
        (search || title) && React.createElement(Header$3, { search: search },
            React.createElement(Label$6, null, title),
            search && React.createElement(Input$7, { onChange: (e) => handleChnage(e), placeholder: "Search..." })),
        React.createElement(TableCom$1, Object.assign({}, props),
            React.createElement(Thead$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_thead' },
                React.createElement(Tr$1, null, dataColumns === null || dataColumns === void 0 ? void 0 :
                    dataColumns.map((column) => { return React.createElement(Th$1, null, column === null || column === void 0 ? void 0 : column.name); }),
                    (edit || deleted) && React.createElement(Th$1, null, 'Actions'))),
            React.createElement(Tbody$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_tbody' }, mappedData === null || mappedData === void 0 ? void 0 : mappedData.slice(pager, stateshowdata + pager).map((row) => {
                return React.createElement(Tr$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_tr' }, dataColumns === null || dataColumns === void 0 ? void 0 :
                    dataColumns.map((column) => { return React.createElement(Td$1, null, row[column === null || column === void 0 ? void 0 : column.field]); }),
                    (edit || deleted) && React.createElement(Td$1, { className: "action" },
                        edit && React.createElement(Span$6, { onClick: () => editfun && editfun(row) },
                            " ",
                            editicon ? editicon : React.createElement("i", { className: "fa fa-pencil" })),
                        deleted && React.createElement(Span$6, { onClick: () => deletedfun && deletedfun(row) }, deletedicon ? deletedicon : React.createElement("i", { className: "fa fa-trash-o" }))));
            }))),
        (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length) === 0 && React.createElement(Nodata$1, null, "no data"),
        (dataRows.length > 0) && React.createElement(Pagination$1, null,
            React.createElement(Span$6, { className: "count" },
                React.createElement(Select$3, { name: "counts", id: "counts", value: stateshowdata, onChange: (e) => datalistcount(e.target.value) }, paginationCount === null || paginationCount === void 0 ? void 0 : paginationCount.map((l) => {
                    return React.createElement(Option$2, { value: l }, l);
                }))),
            React.createElement(Countlist$1, null,
                pager,
                "\u00A0/\u00A0",
                stateshowdata + pager,
                "\u00A0of\u00A0", mappedData === null || mappedData === void 0 ? void 0 :
                mappedData.length),
            React.createElement(Span$6, { className: pager <= 0 ? 'disabled' : 'count', onClick: () => pager > 0 && setPage(0) },
                React.createElement(Span$6, null, "\u300A"),
                " "),
            React.createElement(Span$6, { className: pager <= 0 ? 'disabled' : 'count', onClick: () => pager > 0 && setPage(pager - stateshowdata) },
                React.createElement(Span$6, null, "\u2329"),
                " "),
            React.createElement(Span$6, { className: ((stateshowdata + pager) >= (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length)) ? 'disabled' : 'count', onClick: () => (((stateshowdata + pager) < (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length))) && setPage(pager + stateshowdata) },
                React.createElement(Span$6, null, "\u232A")),
            React.createElement(Span$6, { className: ((stateshowdata + pager) >= (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length)) ? 'disabled' : 'count', onClick: () => (((stateshowdata + pager) <= (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length))) && setPage((mappedData === null || mappedData === void 0 ? void 0 : mappedData.length) - stateshowdata) },
                React.createElement(Span$6, null, "\u300B"))));
};
// this is a default Props of the component
Table.defaultProps = {
    showdata: 10,
    paginationCount: [50, 100, 200],
    title: "Table",
    search: false
};

const TableProps = { showdata: 0, paginationCount: [50, 100, 200], title: '', search: false };

const Img$4 = styled.img `
 height:${props => props.iconHeight ? props.iconHeight + 'px' : '100%'};
 width:${props => props.iconWidth ? props.iconWidth + 'px' : '100%'};

 ${(props) => {
    if (props.iconPosition === "left") {
        return `
           margin-right:10px;
        `;
    }
    else {
        return `
      margin-left:10px;
      `;
    }
}}
`;
const Span$5 = styled.span `
${(props) => {
    if (props.iconPosition === "left") {
        return `
        & svg,img {
            height:${props.iconHeight ? props.iconHeight + 'px' : '100%'};
            width:${props.iconWidth ? props.iconWidth + 'px' : '100%'};
            margin-right:10px;
          }
          & i{
            margin-right:10px;
          }
    `;
    }
    else {
        return `
        & svg,img {
            height:${props.iconHeight ? props.iconHeight + 'px' : '100%'};
            width:${props.iconWidth ? props.iconWidth + 'px' : '100%'};
            margin-left:10px;
          }
          & i{
            margin-left:10px;
          }
  `;
    }
}}

display: flex;
align-items: center;`;
const Body$2 = styled.div `
width: 100%;
padding:0px;
background-color: #fff;
outline: none;
cursor:pointer;
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
const Header$2 = styled.div `
padding: 0px;
min-height: 48px;
transition: min-height 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
display:flex;
justify-content: space-between;
width: 100%;
align-items: center;
cursor:pointer;
background:transparent;
& .sub{
color:rgba(0, 0, 0, 0.54);
}
& i{
transform: rotate(0deg);
transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
const CollapseButton = styled.div `
box-shadow:0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
border-radius:4px;
${props => props && css `
${(props) => {
    if (props.open) {
        return `
margin-bottom:20px;
`;
    }
}}
    `}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Collapse component
const Collapse = (props) => {
    var _a;
    /* this is a props variables */
    const { body, open, handleOpen, title, iconPosition, openIcon, subtitle, closeIcon, children, inLineStyles } = props;
    const [opencollapse, setopencollapse] = React.useState(open ? open : false);
    const opens = props && ((_a = [...Object === null || Object === void 0 ? void 0 : Object.keys(props)]) === null || _a === void 0 ? void 0 : _a.filter(v => {
        if (v === 'open') {
            return v;
        }
    }));
    const handleOpens = (e) => {
        if ((opens === null || opens === void 0 ? void 0 : opens.length) === 0) {
            setopencollapse(!opencollapse);
        }
        else {
            handleOpen && handleOpen(e);
        }
    };
    const displayIcon = () => {
        return (React.createElement(React.Fragment, null,
            (props === null || props === void 0 ? void 0 : props.url) &&
                React.createElement(Img$4, { id: (props === null || props === void 0 ? void 0 : props.id) + '_img', iconWidth: props === null || props === void 0 ? void 0 : props.iconWidth, iconHeight: props === null || props === void 0 ? void 0 : props.iconHeight, iconPosition: props.iconPosition, src: props === null || props === void 0 ? void 0 : props.url }),
            (props === null || props === void 0 ? void 0 : props.icon) && (props === null || props === void 0 ? void 0 : props.icon)));
    };
    return React.createElement(CollapseButton, Object.assign({}, props),
        React.createElement(Header$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', inLineStyles: inLineStyles, onClick: (e) => handleOpens && handleOpens(e) },
            React.createElement(Span$5, { id: (props === null || props === void 0 ? void 0 : props.id) + '_span', iconPosition: iconPosition, iconWidth: props === null || props === void 0 ? void 0 : props.iconWidth, iconHeight: props === null || props === void 0 ? void 0 : props.iconHeight },
                props.iconPosition === "left" && displayIcon(),
                title),
            subtitle && React.createElement(Span$5, { className: "sub" }, subtitle),
            React.createElement(Span$5, { iconPosition: iconPosition },
                props.iconPosition === "right" && displayIcon(),
                (((opens === null || opens === void 0 ? void 0 : opens.length) > 0) ? open : opencollapse) ? openIcon ? openIcon : React.createElement("i", { className: 'fa fa-sort-up' }) : closeIcon ? closeIcon : React.createElement("i", { className: 'fa fa-sort-down' }))),
        (((opens === null || opens === void 0 ? void 0 : opens.length) > 0) ? open : opencollapse) && React.createElement(Body$2, { inLineStyles: inLineStyles }, children ? children : body));
};
// this is a default Props of the component
Collapse.defaultProps = {
    title: "Collapse",
    subtitle: "collapse subtitle",
    body: "Collapse Body",
    iconPosition: 'left',
    iconHeight: 20,
    iconWidth: 20,
    url: '',
    icon: null
};

const CollapseProps = {
  title: '',
  subtitle: '',
  body: '',
  iconPosition: ['left', 'right'],
  iconHeight: 0,
  iconWidth: 0,
  url: '',
  icon: '',
};

const Span$4 = styled.span ``;
const TooltipButton = styled.span `
cursor: pointer;
position: relative;
width:fit-content;
&:hover {
& span{ 
opacity: 1;
visibility: visible;
}
}
${props => props && css `
${(props) => {
    if (props.placement === "bottom") {
        return `& span{
background-color: #3f51b5;
border-radius: 4px;
color: #fff;
opacity: 0;
padding:4px;
position: absolute;
text-align: center;
transition: opacity 0.5s;
visibility: hidden;
width:max-content;
bottom:-34px;
z-index: 1;
font-size:12px;
&::before {
border-width: 5px;
border-style: solid;
border-color:transparent transparent #3f51b5 transparent;
content: "";
left: 50%;
margin-left: -5px;
position: absolute;
top: -10px;
 }
}`;
    }
    else if (props.placement === "top") {
        return `
 & span{
background-color: #3f51b5;
border-radius: 4px;
color: #fff;
opacity: 0;
padding:4px;
margin-top:-33px;
position: absolute;
text-align: center;
transition: opacity 0.5s;
visibility: hidden;
width:max-content;
z-index: 1;
font-size:12px;
&::after {
border-width: 5px;
border-style: solid;
border-color: #3f51b5 transparent transparent transparent;
content: "";
left: 50%;
margin-left: -5px;
position: absolute;
top: 100%;
 }
}`;
    }
    else if (props.placement === "right") {
        return `
 & span{
background-color: #3f51b5;
border-radius: 4px;
color: #fff;
opacity: 0;
padding:4px;
position: absolute;
text-align: center;
transition: opacity 0.5s;
visibility: hidden;
width:max-content;
z-index: 1;
font-size:12px;
right: -100%;
top: 0px;
&::after {
border-width: 5px;
border-style: solid;
border-color: transparent #3f51b5 transparent transparent;
content: "";
left: -10px;
position: absolute;
top: 30%;
 }
}`;
    }
    else if (props.placement === "left") {
        return `
 & span{
background-color: #3f51b5;
border-radius: 4px;
color: #fff;
opacity: 0;
padding:4px;
position: absolute;
text-align: center;
transition: opacity 0.5s;
visibility: hidden;
width:max-content;
z-index: 1;
font-size:12px;
left: -100%;
top: 0px;
&::after {
border-width: 5px;
border-style: solid;
border-color: transparent transparent transparent #3f51b5;
content: "";
right: -10px;
position: absolute;
top: 30%;
 }
}`;
    }
}}
`}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Tooltip component
const Tooltip = (props) => {
    /* this is a props variables */
    const { children, title } = props;
    return React.createElement(TooltipButton, Object.assign({}, props),
        React.createElement(Span$4, null, title),
        children);
};
// this is a default Props of the component
Tooltip.defaultProps = {
    title: "Tooltip",
    placement: "top"
};

const TooltipProps = { title: '', placement: ['right', 'left', 'top', 'bottom'] };

const Tabcontent = styled.div `
  /* padding: 6px; */
`;
const TabTitle = styled.div `
  display: flex;
  align-items: center;
  ${(props) => props && css `
    ${(props) => {
    if (props.align === 'center') {
        return `
          text-align:center;`;
    }
    else if (props.align === 'left') {
        return `
           text-align:left;`;
    }
    else {
        return `
          text-align:right;`;
    }
}}

    ${(props) => {
    if (props.elevation === '1') {
        return `
            box-shadow: 0 3px 3px rgba(0,0,0,0.2);
                `;
    }
    else if (props.elevation === '2') {
        return `
            box-shadow: 0 1px 1px rgba(0,0,0,0.15), 
            0 2px 2px rgba(0,0,0,0.15), 
            0 4px 4px rgba(0,0,0,0.15), 
            0 8px 8px rgba(0,0,0,0.15);
            `;
    }
    else if (props.elevation === '3') {
        return `
            box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
                  0 2px 2px rgba(0,0,0,0.12), 
                  0 4px 4px rgba(0,0,0,0.12), 
                  0 8px 8px rgba(0,0,0,0.12),
                  0 16px 16px rgba(0,0,0,0.12);
            `;
    }
    else if (props.elevation === '4') {
        return `
            box-shadow: 0 1px 1px rgba(0,0,0,0.11), 
                  0 2px 2px rgba(0,0,0,0.11), 
                  0 4px 4px rgba(0,0,0,0.11), 
                  0 8px 8px rgba(0,0,0,0.11), 
                  0 16px 16px rgba(0,0,0,0.11), 
                  0 32px 32px rgba(0,0,0,0.11);
            `;
    }
    else {
        return `
            box-shadow:none;
            `;
    }
}}

    ${(props) => {
    var _a;
    if ((props === null || props === void 0 ? void 0 : props.variant) === "bordered") {
        return `
          border:1px solid ${(_a = props.borderColor) !== null && _a !== void 0 ? _a : '#dad5da'};
          border-radius:10px;
        `;
    }
}}

    ${(props) => {
    if ((props === null || props === void 0 ? void 0 : props.variant) === "withoutBordered") {
        return `
              align-items:flex-end;
            `;
    }
}}
    `}
`;
const TabsCom = styled.div `
  ${(props) => props &&
    css `
      ${(props) => {
        if (props.fullWidth) {
            return `
          flex:1;`;
        }
    }}
    `}
`;
const Div$4 = styled.div `
  ${(props) => props &&
    css `
    ${(props) => {
        if (!(props === null || props === void 0 ? void 0 : props.inlineHiddenstyled)) {
            return `
        cursor: pointer;
        padding: 10px;
        border-radius: 2px 2px 0 0;
        text-transform: capitalize;
        border: 1px solid #f0f0f0;
        border-right-width: 2px;
        background-color: #fafafa;  
        font-size: 14px;
    `;
        }
    }}
      ${(props) => {
        if (!(props === null || props === void 0 ? void 0 : props.inlineHiddenstyled)) {
            if ((props === null || props === void 0 ? void 0 : props.variant) === "contained") {
                if (props.activetab) {
                    return `
                background-color: ${props.backgroundColor};    
                border-color: ${props.backgroundColor};    
                color: ${props === null || props === void 0 ? void 0 : props.activeColor};
            `;
                }
            }
            else if (props.variant === "standard") {
                if (props.activetab) {
                    return `
                border-bottom-color:transparent;
                background-color: #fff;
                color: ${props === null || props === void 0 ? void 0 : props.activeColor};
              `;
                }
                else {
                    return `
                    border-bottom-color:#f0f0f0;
               `;
                }
            }
            else if (props.variant === "bordered") {
                if (props.activetab) {
                    return `
                padding:10px;
                margin:5px;
                border:1px solid ${props.activeColor};
                border-radius:5px;
                background-color:${props.backgroundColor};
                color:${props.activeColor};
              `;
                }
                else {
                    return `
                background-color:transparent;
                border:0;
                padding:10px;
                margin:5px;
              `;
                }
            }
            else if (props.variant === "withoutBordered") {
                return `
              border:0px;
              border-bottom:${props.activetab ? `2px solid ${props.activeColor}` : '1px solid #f0f0f0'};
              font-weight:${props.activetab ? '500' : '400'};
              background-color:transparent;
              color:${props.activetab ? props.activeColor : '#000'};
            `;
            }
        }
    }}
  
      ${(props) => {
        if (!(props === null || props === void 0 ? void 0 : props.inlineHiddenstyled)) {
            if (props.size === "small") {
                return `
              font-size:14px;
              padding:5px;
               `;
            }
            else if (props.size === "medium") {
                return `
              font-size:17px;
              padding:8px;
               `;
            }
            else if (props.size === "large") {
                return `
              font-size:20px;
              padding:10px;
               `;
            }
        }
    }}
    `}
`;
const SubText = styled.span `
display: block;
font-size: 10px;
margin-top: 4px;
`;
const Styledtab = styled.div `
  ${(props) => (props.inLineStyles ? { ...props.inLineStyles } : '')}
`;
const Number = styled.div `
width:23px;
height:23px;
display:flex;
align-items:center;
justify-content:center;
background-color:#B6B6B6;
border-radius:50%;
color:#fff;
margin-left:10px;
font-size: 12px;

${(props) => props && css `
${(props) => {
    if (props.activetab) {
        return `
          background-color: ${props.activeColor};    
      `;
    }
}}
      `}

`;
const FlexStyle = styled.div `
display: flex;
align-items: center;
justify-content: center;
${(props) => (props.labelStyle ? { ...props.labelStyle } : '')}
`;

// This a Tab component
const Tab = (props) => {
    /* this is a props variables */
    const { children, align, onChange, activetabs } = props;
    const [isactive, setisactive] = React.useState(activetabs ? activetabs : 0);
    const childHead = (c, activeTab) => {
        var _a, _b, _c, _d, _e;
        return ((_a = c === null || c === void 0 ? void 0 : c.props) === null || _a === void 0 ? void 0 : _a.label) ? TabNumber(c === null || c === void 0 ? void 0 : c.props, activeTab, (_b = c === null || c === void 0 ? void 0 : c.props) === null || _b === void 0 ? void 0 : _b.tabChildren) : (_e = (_d = (_c = c === null || c === void 0 ? void 0 : c.props) === null || _c === void 0 ? void 0 : _c.component) === null || _d === void 0 ? void 0 : _d.properties) === null || _e === void 0 ? void 0 : _e.title;
    };
    const childHeadStyleHidden = (c) => {
        var _a;
        return (_a = c === null || c === void 0 ? void 0 : c.props) === null || _a === void 0 ? void 0 : _a.tabChildren;
    };
    const TabNumber = (c, activeTab, tabChildren) => {
        if (tabChildren) {
            return tabChildren;
        }
        else {
            return (React.createElement(FlexStyle, { id: (props === null || props === void 0 ? void 0 : props.id) + (c === null || c === void 0 ? void 0 : c.label) + '_div', className: activeTab ? 'activeChildHead' : 'inActiveChildHead', labelStyle: props === null || props === void 0 ? void 0 : props.labelStyle }, c === null || c === void 0 ? void 0 :
                c.label,
                (c === null || c === void 0 ? void 0 : c.number) && (React.createElement(Number, { id: (props === null || props === void 0 ? void 0 : props.id) + (c === null || c === void 0 ? void 0 : c.number) + '_sub_div', activetab: activeTab, className: activeTab ? 'activeChildNumber' : 'inActiveChildNumber', activeColor: props.activeColor }, c === null || c === void 0 ? void 0 : c.number))));
        }
    };
    const childSubHead = (c) => {
        var _a, _b;
        return ((_a = c === null || c === void 0 ? void 0 : c.props) === null || _a === void 0 ? void 0 : _a.subTitle) ? (_b = c === null || c === void 0 ? void 0 : c.props) === null || _b === void 0 ? void 0 : _b.subTitle : '';
    };
    let tabs = React.Children.map(children, (child, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // which helps us decide which one is active
        const data = childHead((child && child), (isactive === index ? true : false));
        return (React.createElement(TabsCom, { id: (props === null || props === void 0 ? void 0 : props.id) + "_" + ((_b = (_a = data === null || data === void 0 ? void 0 : data.props) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b[0]) + ('_parent_div'), fullWidth: props.fullWidth },
            React.createElement(Div$4, { className: 'tabTitleChildDiv', id: (props === null || props === void 0 ? void 0 : props.id) + "_" + ((_d = (_c = data === null || data === void 0 ? void 0 : data.props) === null || _c === void 0 ? void 0 : _c.children) === null || _d === void 0 ? void 0 : _d[0]) + '_sub_div', variant: props.variant, activetab: isactive === index ? true : false, backgroundColor: props.backgroundColor, activeColor: props.activeColor, size: props.size, 
                // border={props.border}
                // provides a way to change that state
                onClick: () => {
                    setisactive(index);
                    onChange && onChange(index);
                }, inlineHiddenstyled: childHeadStyleHidden(child && child) },
                childHead(child && child, isactive === index ? true : false),
                ((_e = child === null || child === void 0 ? void 0 : child.props) === null || _e === void 0 ? void 0 : _e.subTitle) && (React.createElement(SubText, { id: (props === null || props === void 0 ? void 0 : props.id) + "_" + ((_g = (_f = data === null || data === void 0 ? void 0 : data.props) === null || _f === void 0 ? void 0 : _f.children) === null || _g === void 0 ? void 0 : _g[0]) + '_div', className: isactive === index ? 'activeChildSubHead' : 'inActiveChildSubHead', style: {
                        color: ((_h = child === null || child === void 0 ? void 0 : child.props) === null || _h === void 0 ? void 0 : _h.color) ? (_j = child === null || child === void 0 ? void 0 : child.props) === null || _j === void 0 ? void 0 : _j.color : 'inherit',
                    } }, childSubHead(child && child))))));
    });
    let tabs_childrens = React.Children.map(children, (child, index) => {
        if (index === isactive) {
            return child;
        }
    });
    return (React.createElement(Styledtab, Object.assign({}, props),
        React.createElement(TabTitle, { id: (props === null || props === void 0 ? void 0 : props.id) + '_title_div', className: "tabTitle", variant: props.variant, align: align, borderColor: props.borderColor, elevation: props.elevation }, tabs),
        React.createElement(Tabcontent, { id: (props === null || props === void 0 ? void 0 : props.id) + '_content_div' }, tabs_childrens)));
};
// this is a default Props of the component
Tab.defaultProps = {
    align: 'center',
    activetabs: 0,
    fullWidth: true,
    size: 'small',
    backgroundColor: '#3f51b5',
    elevation: '0',
    activeColor: '#1890ff',
    variant: 'bordered',
};

const TabProps = {
  align: ['center', 'left', 'right'],
  activetabs: 0,
  fullWidth: false,
  size: ['small', 'medium', 'large'],
  backgroundColor: '#000',
  elevation: ['0', '1', '2', '3', '4'],
  activeColor: '#000',
  variant: ['standard', 'contained', 'bordered', 'withoutBordered'],
};

const StyledRating = styled.div `
display:flex;
flex-direction: row-reverse;
font-size:1.5em;
justify-content:space-around;
padding:0 .2em;
text-align:center;
width:5em;
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
const Label$5 = styled.label `
color:#f0f0f0;
${props => props && css `
${(props) => {
    if (!props.disabled) {
        return `
cursor:pointer;
&:hover{
color:#fc0;
}
&.filled{
color:#fc0;
}
`;
    }
    else {
        return `
&.filled{
color:#b1b1b1;
}
`;
    }
}}
`}

`;

// This a Rating component
const Rating = (props) => {
    var _a;
    /* this is a props variables */
    const { ratingCount, onChange, value, disabled, Icon } = props;
    return React.createElement(StyledRating, Object.assign({}, props), (_a = [...Array(ratingCount)]) === null || _a === void 0 ? void 0 : _a.map((v, i) => { return React.createElement(Label$5, { disabled: disabled, className: ((ratingCount - i) <= value) ? "filled" : "", onClick: () => !disabled && (onChange && onChange(ratingCount - (i))) },
        Icon ? Icon : React.createElement(React.Fragment, null, "\u2605"),
        v); }));
};
// this is a default Props of the component
Rating.defaultProps = {
    ratingCount: 5,
    value: 3,
    disabled: false
};

const RatingProps = {
  ratingCount: 0,
  value: 0,
  disabled: false,
};

const A = styled.a `
  cursor: pointer;
  display: inline-flex;
  text-decoration: unset;
  &:not(:last-of-type) {
    &::after {
      margin: 0 6px;
      color: #c1d3de;
    }
  } 
  &.active {
    color: #000;
    text-decoration: unset;
    cursor: pointer;
  } 
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a BreadcrumbItem component
const BreadcrumbItem = (props) => {
    /* this is a props variables */
    const { children, href, active } = props;
    const pushPath = (url) => {
        window.history.pushState({ urlPath: url }, "", url);
    };
    return React.createElement(A, Object.assign({}, props, { onClick: () => href && pushPath(href), className: active ? 'active' : "" }), children && children);
};
// this is a default Props of the component
BreadcrumbItem.defaultProps = {
    children: 'Path',
};

const BreadcrumbItemsProps = {
  children: '',
};

const StyledBreadcrumItem = styled.nav `
display: flex;
flex-flow: row;
flex-wrap: wrap;
${props => props && css `
${(props) => {
    if (props.Icon === "slice") {
        return `
               & a{
                &:not(:last-of-type) {
                  &::after {
                    content: '/';
                  }
                } 
               }
`;
    }
    else {
        return `
                & a{
                  &:not(:last-of-type) {
                    &::after {
                      content: '>';
                    }
                  } 
                }
`;
    }
}}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}

`}
`;

// This a Breadcrumb component
const Breadcrumb = (props) => {
    /* this is a props variables */
    const { children } = props;
    return React.createElement(StyledBreadcrumItem, Object.assign({}, props), children && children);
};
// this is a default Props of the component
Breadcrumb.defaultProps = {
    Icon: 'slice',
};

const BreadcrumbProps = {
  Icon: ['arrow', 'slice'],
};

const StyledbuttonGroup = styled.div `
display: flex;
align-items: center;
border-radius:5px;
overflow: hidden;
& button {
border-radius:0px;
flex:1;
text-transform:uppercase;
&:hover{
opacity:0.9;
}
}
${props => props && css `
${(props) => {
    if (props.variant === "outlined") {
        return `
            & button{
            background: unset;
            border-color:${props.backgroundColor};
            &:first-child {
              border-radius: 5px 0 0 5px;
            }
            &:last-child {
              border-radius: 0 5px 5px 0;
            }            
            color: #000;
            &:focus {
            color: #000;
            }
            }
            `;
    }
    else {
        return `
          & button{
          background-color:${props.backgroundColor};
          border-color:${props.backgroundColor};
            &:not(:last-child) {
              border-right: 2px solid;
            } 
          }
        `;
    }
}}

${(props) => {
    if (props.elevation === '1') {
        return `
        box-shadow: 0 3px 3px rgba(0,0,0,0.2);
            `;
    }
    else if (props.elevation === '2') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.15), 
        0 2px 2px rgba(0,0,0,0.15), 
        0 4px 4px rgba(0,0,0,0.15), 
        0 8px 8px rgba(0,0,0,0.15);
        `;
    }
    else if (props.elevation === '3') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
              0 2px 2px rgba(0,0,0,0.12), 
              0 4px 4px rgba(0,0,0,0.12), 
              0 8px 8px rgba(0,0,0,0.12),
              0 16px 16px rgba(0,0,0,0.12);
        `;
    }
    else if (props.elevation === '4') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.11), 
              0 2px 2px rgba(0,0,0,0.11), 
              0 4px 4px rgba(0,0,0,0.11), 
              0 8px 8px rgba(0,0,0,0.11), 
              0 16px 16px rgba(0,0,0,0.11), 
              0 32px 32px rgba(0,0,0,0.11);
        `;
    }
    else {
        return `
        box-shadow:none;
        `;
    }
}}

${(props) => {
    if (props.buttonWidth) {
        return `
        width:${props.buttonWidth}px;`;
    }
}}

${(props) => {
    if (props.color) {
        return `
        & button{
          color:${props.color};
        }
        `;
    }
}}
${(props) => {
    if (props.disabled) {
        return `
background:gray;
border: 1px solid gray;
& button{
border: none;
background:gray;
}
& button:hover{
  cursor: no-drop;
}
  `;
    }
}}
    
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}

`}
`;

// This a buttonGroup component
const ButtonGroup = (props) => {
    // const { disabled } = props;
    /* this is a props variables */
    const { children } = props;
    const isDisd = (d) => {
        const a = d['disabled'] = true;
        return a;
    };
    const isDis = (dis) => {
        return isDisd(dis);
    };
    const isDisabled = (data) => {
        var _a;
        (_a = [...data || []]) === null || _a === void 0 ? void 0 : _a.map((v) => {
            return isDis(v);
        });
    };
    React.useEffect(() => {
        let a = document.getElementsByTagName("button");
        if ((a === null || a === void 0 ? void 0 : a.length) > 0) {
            isDisabled(a);
        }
    }, [props.disabled]);
    return React.createElement(StyledbuttonGroup, Object.assign({}, props), children && children);
};
// this is a default Props of the component
ButtonGroup.defaultProps = {
    variant: "contained",
    elevation: '0',
    backgroundColor: '#3f51b5',
    color: '#000',
};

const ButtonGroupProps = {
  disabled: false,
  variant: ['contained', 'outlined'],
  elevation: ['0', '1', '2', '3', '4'],
  backgroundColor: '#000',
  color: '#000',
};

const TabpanelCom = styled.div `
// box-shadow : 0 2px 12px rgb(0 0 0 / 20%);
${props => props.children ? '' : 'min-height:20px'}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Tabpanel component
const Tabpanel = (props) => {
    /* this is a props variables */
    const { children, label, className } = props;
    return React.createElement(TabpanelCom, Object.assign({}, props, { className: `${className}` }), children !== null && children !== void 0 ? children : label);
};
Tabpanel.defaultProps = {
    label: "Tab Panel",
    title: "Tab Panel",
    color: 'inherit',
    subTitle: '',
    number: ''
};

const TabpanelProps = { label: '', title: '', color: '#000', subTitle: '', number: '' };

const StyledFloating = styled.button `
width: 56px;
height: 56px;
padding: 0;
font-size: 0.875rem;
min-width: 0;
box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
box-sizing: border-box;
min-height: 36px;
transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
font-weight: 500;
line-height: 1.75;
border-radius: 50%;
letter-spacing: 0.02857em;
text-transform: uppercase;
outline: none;
cursor:pointer;
${props => props && css `
${(props) => {
    if (props.color === "primary") {
        return `
background-color: #3f51b5;
color: #fff;
border: 1px solid #3f51b5;
`;
    }
    else if (props.color === "secondary") {
        return `
background-color: #c51162;
color: #fff;
border: 1px solid #c51162;
`;
    }
    else if (props.color === "default") {
        return `
background-color: #e0e0e0;
color: #000;
border: 1px solid #e0e0e0;
`;
    }
}}
`}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This a Floating Button component
const Floating = (props) => {
    /* this is a props variables */
    const { children } = props;
    return React.createElement(StyledFloating, Object.assign({}, props), children && children);
};
// this is a default Props of the component
Floating.defaultProps = {
    color: "primary",
};

const FloatingProps = {
  color: ['primary', 'secondary', 'default'],
};

const StepperEle = styled.div `
flex-direction: row;
flex-wrap: nowrap;
justify-content: space-around;
align-content: center;
align-items: flex-start;
display: flex;
`;
const Span$3 = styled.span `
padding:0px 6px;
display: inline-block;
width: 85%;
${props => props && css `
${(props) => {
    if (props.activetab) {
        return `
color: #000;
&:after {
border-bottom: solid 1px #3f51b5;
}
`;
    }
    else {
        return `
color: #6d6d6d;
&:after {
border-bottom: solid 1px #ccc;
}
`;
    }
}}
${(props) => {
    if (props.line) {
        return `
        &:after {
            content: "";
            display: inline-block;
            width: 100%;
            float: right;
            position: relative;
            top: -10px;
        }
`;
    }
}}
`}
`;
const SpanList = styled.span `
background-color: #fff;
display: inline-block;
position: relative;
z-index: 9;
padding-right: 4px;
`;
const Num = styled.span `
float: left;
display: inline-block;
color: #fff;
height: 32px;
width: 32px;
margin: auto;
justify-content: center;
align-items: center;
text-align: center;
display: flex;
border-radius: 500px;
${props => props && css `
${(props) => {
    if (props.activetab) {
        return `
background-color: #3f51b5;
`;
    }
    else {
        return `
background-color: #b1b1b1;
`;
    }
}}
`}
`;
const StepsCom = styled.div `
flex: 0 1 33.3%;
align-self: auto;
padding: 20px 0;
`;

// This is a Stepper component
const Stepper = (props) => {
    /* this is a props variables */
    const { steps, activeStep } = props;
    const tick = "✓";
    return (React__default.createElement(StepperEle, Object.assign({}, props), steps === null || steps === void 0 ? void 0 : steps.map((v, i) => {
        return React__default.createElement(StepsCom, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' },
            React__default.createElement(Num, { activetab: (activeStep >= i) ? true : false }, v.Icon ? v.Icon : (activeStep !== 0 ? (activeStep >= i + 1) ? tick : (i + 1) : (i + 1))),
            React__default.createElement(Span$3, { activetab: (activeStep >= i) ? true : false, line: (steps.length) !== (i + 1) ? true : false },
                React__default.createElement(SpanList, null, v === null || v === void 0 ? void 0 : v.title)));
    })));
};
// this is a default Props of the component
Stepper.defaultProps = {
    activeStep: 0
};

const StepperProps = {
  activeStep: 0,
};

const PopconfirmEle = styled.div `
background: rgba(0,0,0,0.2);
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
transition: opacity 0.4s, visibility 0.4s;
z-index: 1000;
${props => props && css `
${(props) => {
    if (props.open) {
        return `
visibility: visible;
opacity: 1;
`;
    }
    else {
        return `
visibility: hidden;
opacity: 0;
`;
    }
}}
`}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
const Div$3 = styled.div `
transform: translate(0, 0);
background: #fff;
position: relative;
transition: transform 0.4s;
margin: 10rem auto;
border-radius: 6px;
width: 300px;
text-align: center;
`;
const Title = styled.header `
border-top-left-radius: 6px;
border-top-right-radius: 6px;
padding: 10px 8px;
background-color: #f6f7f9;
border-bottom: 1px solid #e5e5e5;
font-size: 16px;
`;
const I = styled.header `
float: right;
color: #c4c5c7;
cursor: pointer;
transition: all .5s ease;
padding: 0 2px;
border-radius: 1px;
`;
const Footer = styled.footer `
border-top: 1px solid #e5e5e5;
padding: 12px 10px;
text-align: end;
`;
const Ok = styled.span `
padding: 5px 15px;
border-radius: 3px;
background-color: #3f51b5;
border: 1px solid #3f51b5;
color: #f5f5f5;
cursor: pointer;
`;
const Cancel = styled.span `
background-color: rgb(248, 248, 248);
border: 1px solid rgba(204, 204, 204, 0.5);
color: #5D5D5D;
padding: 5px 15px;
border-radius: 3px;
cursor: pointer;
margin: 0px 6px;
`;
const Body$1 = styled.div `
font-size: 16px;
padding: 12px 30px;
`;

// This is a Popconfirm component
const Popconfirm = (props) => {
    /* this is a props variables */
    const { message, onClose, onAdd, onAddText, onCloseText, title } = props;
    return (React__default.createElement(PopconfirmEle, Object.assign({}, props),
        React__default.createElement(Div$3, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' },
            title && React__default.createElement(Title, null,
                title,
                React__default.createElement(I, { onClick: (e) => onClose && onClose(e) }, "X")),
            React__default.createElement(Body$1, null, message),
            React__default.createElement(Footer, { id: (props === null || props === void 0 ? void 0 : props.id) + '_footer' },
                React__default.createElement(Cancel, { id: (props === null || props === void 0 ? void 0 : props.id) + '_span', onClick: (e) => onClose && onClose(e) }, onCloseText),
                React__default.createElement(Ok, { onClick: (e) => onAdd && onAdd(e) }, onAddText)))));
};
// this is a default Props of the component
Popconfirm.defaultProps = {
    message: "Simple Confirmation Popup",
    onAddText: "OK",
    onCloseText: "Cancel"
};

const PopconfirmProps = {
  message: '',
  onAddText: '',
  onCloseText: '',
};

const TableCom = styled.table `
width:100%;
border-collapse:collapse;
${props => props && css `
${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const TableComponent = styled.div `overflow:auto;
box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
border-radius:4px;
`;
const Thead = styled.thead ``;
const Span$2 = styled.span ``;
const Tr = styled.tr `
border-bottom:1px solid rgba(224, 224, 224, 1);
`;
const Countlist = styled.span `
padding: 4px;
`;
const Tbody = styled.tbody ``;
const Label$4 = styled.span `flex-grow:1;
padding: 4px 14px;
font-size: 18px;
font-weight: 500;
text-transform: capitalize;
`;
const Nodata = styled.div `
text-align: center;
justify-content: center;
display: flex;
font-size: 15px;
text-transform: capitalize;
font-weight: 500;
line-height: 40px;`;
const Input$6 = styled.input `
padding: 5px 20px 5px 5px;
margin:8px 0px;
border-radius: 4px;
outline: none;
font-size: 14px;
box-sizing: border-box;
cursor: revert;
border: 1px solid #ddd;
&:hover{
border: 1px solid #ddd;
}
&:focused{
border: 1px solid #2bb9bd;
}

&::placeholder {
color: #9b9b9b;
}
`;
const Header$1 = styled.div `
width:100%;
height: 50px;
line-height: 50px;
display:flex; 
${props => props && css `
${(props) => {
    if (props.search) {
        return `
::after {
    content: "\f002";
    font-family: FontAwesome;
    margin-left: -25px;
    margin-right: 25px;
    color:#aaa;
}
`;
    }
}}
`}

`;
const Filter = styled.label `
color: #fff;
padding: 2px;`;
const Th = styled.th `
&:hover{
  & label{
    color: #6c6d73a6;
  }
}
cursor:pointer;
padding:12px;margin:0px;`;
const Td = styled.td `
padding:12px;margin:0px;
&.action{
display: flex;
justify-content: space-around;
}
& span{
cursor:pointer;
}`;
const Pagination = styled.div `
display: flex;
width: 100%;
text-align: right;
@media (max-width: 376px) { 
justify-content: end;
margin: 10px 0px 10px 20px;
}
@media (min-width: 377px) { 
justify-content: flex-end;
margin: 10px 0px 10px -20px;
}
& a{
text-decoration:none;
}
& .count{
cursor:pointer;
padding: 6px 12px;
margin-left:-1px;
font-size: 16px;
font-weight: 500;
letter-spacing: 1px;
color:#337ab7;
float:left;
& select {
align-items: center;
border: none;
margin: 0;
padding: 0;
outline:none;
}
}  
& .disabled{
color: #777;
cursor:not-allowed;
padding: 6px 12px;
margin-left:-1px;
font-size: 16px;
font-weight: 500;
letter-spacing: 1px;
float:left;
}
`;
const Select$2 = styled.select `
font-size: 16px;`;
const Option$1 = styled.option ``;

// This a table component
const DataTable = (props) => {
    /* this is a props variables */
    const { data, edit, deleted, header, sortBy, deletedfun, title, search, paginationCount, editfun, editicon, deletedicon, showdata } = props;
    // this is a state of handling variables
    const [pager, setPage] = React.useState(0);
    const [stateshowdata, setPageshowdata] = React.useState(showdata);
    const [value, setvalue] = React.useState("");
    //   end 
    // this is a data of table colums(Headers)
    let dataColumns = header;
    // this is a data of table rows
    let dataRows = data;
    const datalistcount = (l) => {
        setPageshowdata(JSON.parse(l));
    };
    const handleChnage = (e) => {
        setvalue(e.target.value);
    };
    const maped = () => {
        const data = dataRows === null || dataRows === void 0 ? void 0 : dataRows.filter((v) => { var _a; return (_a = ((v === null || v === void 0 ? void 0 : v.name).toLowerCase())) === null || _a === void 0 ? void 0 : _a.includes(value === null || value === void 0 ? void 0 : value.toLowerCase()); });
        return data;
    };
    const compareBy = (key) => {
        return function (a, b) {
            if (a[key] < b[key])
                return -1;
            if (a[key] > b[key])
                return 1;
            return 0;
        };
    };
    const sortByfun = (val) => {
        let arrayCopy = [...dataRows];
        arrayCopy.sort(compareBy(val));
        sortBy && sortBy(arrayCopy);
    };
    const mappedData = search ? value ? maped() : dataRows : dataRows;
    return React.createElement(TableComponent, null,
        (search || title) && React.createElement(Header$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', search: search },
            React.createElement(Label$4, null, title),
            search && React.createElement(Input$6, { onChange: (e) => handleChnage(e), placeholder: "Search..." })),
        React.createElement(TableCom, Object.assign({}, props),
            React.createElement(Thead, { id: (props === null || props === void 0 ? void 0 : props.id) + '_thead' },
                React.createElement(Tr, { id: (props === null || props === void 0 ? void 0 : props.id) + '_tr' }, dataColumns === null || dataColumns === void 0 ? void 0 :
                    dataColumns.map((column) => {
                        return React.createElement(Th, { onClick: () => sortByfun(column === null || column === void 0 ? void 0 : column.field) }, column === null || column === void 0 ? void 0 :
                            column.name,
                            React.createElement(Filter, null, "\u21C5"));
                    }),
                    (edit || deleted) && React.createElement(Th, null, 'Actions'))),
            React.createElement(Tbody, null, mappedData === null || mappedData === void 0 ? void 0 : mappedData.slice(pager, stateshowdata + pager).map((row) => {
                return React.createElement(Tr, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_tr' }, dataColumns === null || dataColumns === void 0 ? void 0 :
                    dataColumns.map((column) => {
                        return React.createElement(Td, { id: (props === null || props === void 0 ? void 0 : props.id) + '_td' }, row[column === null || column === void 0 ? void 0 : column.field]);
                    }),
                    (edit || deleted) && React.createElement(Td, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_td', className: "action" },
                        edit && React.createElement(Span$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_span', onClick: () => editfun && editfun(row) },
                            " ",
                            editicon ? editicon : React.createElement("i", { className: "fa fa-pencil" })),
                        deleted && React.createElement(Span$2, { onClick: () => deletedfun && deletedfun(row) }, deletedicon ? deletedicon : React.createElement("i", { className: "fa fa-trash-o" }))));
            }))),
        (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length) === 0 && React.createElement(Nodata, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' }, "no data"),
        (dataRows.length > 0) && React.createElement(Pagination, null,
            React.createElement(Span$2, { className: "count" },
                React.createElement(Select$2, { name: "counts", id: "counts", value: stateshowdata, onChange: (e) => datalistcount(e.target.value) }, paginationCount === null || paginationCount === void 0 ? void 0 : paginationCount.map((l) => {
                    return React.createElement(Option$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_option', value: l }, l);
                }))),
            React.createElement(Countlist, null,
                pager,
                "\u00A0/\u00A0",
                stateshowdata + pager,
                "\u00A0of\u00A0", mappedData === null || mappedData === void 0 ? void 0 :
                mappedData.length),
            React.createElement(Span$2, { className: pager <= 0 ? 'disabled' : 'count', onClick: () => pager > 0 && setPage(0) },
                React.createElement(Span$2, null, "\u300A"),
                " "),
            React.createElement(Span$2, { className: pager <= 0 ? 'disabled' : 'count', onClick: () => pager > 0 && setPage(pager - stateshowdata) },
                React.createElement(Span$2, null, "\u2329"),
                " "),
            React.createElement(Span$2, { className: ((stateshowdata + pager) >= (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length)) ? 'disabled' : 'count', onClick: () => (((stateshowdata + pager) < (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length))) && setPage(pager + stateshowdata) },
                React.createElement(Span$2, null, "\u232A")),
            React.createElement(Span$2, { className: ((stateshowdata + pager) >= (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length)) ? 'disabled' : 'count', onClick: () => (((stateshowdata + pager) <= (mappedData === null || mappedData === void 0 ? void 0 : mappedData.length))) && setPage((mappedData === null || mappedData === void 0 ? void 0 : mappedData.length) - stateshowdata) },
                React.createElement(Span$2, null, "\u300B"))));
};
// this is a default Props of the component
DataTable.defaultProps = {
    showdata: 10,
    paginationCount: [50, 100, 200],
    title: "Data Table",
    search: false
};

const DataTableProps = {
  showdata: 0,
  paginationCount: [50, 100, 200],
  title: '',
  search: false,
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const R = styled.div `
  text-align: center;
  list-style: none;
  li {
    display: inline-block;
  }
  & .arrow {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-top: 2px solid #000;
    border-right: 2px solid #000;
  }
  & .arrow-right {
    transform: rotate(45deg);
  }
  & .arrow-left {
    transform: rotate(-135deg);
  }
  `;
const Span$1 = styled.div `
text-transform: uppercase;
transform: rotate(
  -90deg
  );
  background: #F9F9F9;
  height: fit-content;
  /* margin: auto 0px; */
  border-radius: 3px;
  padding: 3px 12px;
  color:#6F6F6F;
`;
const List = styled.div `
text-align:center;
margin: auto
`;
const StyledWeekCalendar = styled.div `
width: 100%;
min-width: 400px;
border-radius: 10px;
border: 1px solid #dddddd63;
& span{
${props => props.inLineStyles && { ...props.inLineStyles }}
}
${props => props.inLineStyles && { ...props.inLineStyles }}
`;
const Top = styled.div `
display: flex;
justify-content: space-between;
align-items: center;
`;
const Arrow = styled.span `
${(props) => {
    if (props.isdisabled) {
        return `
        color:#e8e8e8;
        `;
    }
}}

display: flex;
align-items: center;
justify-content: center;
border: 0;
background-color:#FFF;
border-radius: 12px;
width: 2.5rem;
height: 2.5rem;
outline:none;
cursor: pointer;
`;
const Calendar = styled.div `
display: flex;
width: 100%;
justify-content: center;
align-items: center;
`;
const DaySpan = styled.span `
color: #000;
font-size: .875em;
font-weight: 500;
justify-self: center;
text-transform: uppercase;
&.fadedDay {
	color: #999FA6;
}
`;
const DayDate = styled.span `
border: 0;
padding: 0;
width: 2.25rem;
height: 2.25rem;
display: flex;
align-items: center;
justify-content: center;
font-weight: 600;
font-size:18px;
&.fadedDate {
	color: #B6B6B6;
}
${(props) => {
    if (props.activeColor) {
        return `
      &.current-day {
        // color: ${props.activeColor};
        color: #fff;
        background-color: ${props.activeColor};
        border-radius:50%
      }
  `;
    }
}}
${(props) => {
    var _a;
    if (props.dateValue && ((_a = props.dateValue) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return `
        background-color: ${props.activeColor};
        color: #fff !important;
        border-radius:50%
`;
    }
}}

`;

const WeekCalendar = (props) => {
    /* this is a props variables */
    const { weekStartDate, weekEndDate, activeColor, onChange, dateValue, currentDate } = props;
    //   state
    const [datevalue, setdatevalue] = React.useState(weekStartDate);
    const [currentDateValue, setcurrentDateValue] = React.useState(currentDate);
    const [next, setnext] = React.useState(false);
    const [prev, setprev] = React.useState(0);
    const [selectedDate, setSelectedDate] = React.useState(dateValue);
    // end
    React.useEffect(() => {
        setcurrentDateValue(currentDate);
    }, [props.currentDate]);
    React.useEffect(() => {
        setdatevalue(weekStartDate);
    }, [props.weekStartDate]);
    // week calendar list out
    function WeekCalendar() {
        debugger;
        const date = currentDateValue ? currentDateValue : datevalue;
        const lastDayOfWeek = (moment(date, 'MM-DD-YYYY').endOf('week'));
        let weekDays = [];
        debugger;
        for (let i = 6; i >= 0; i--) {
            debugger;
            const day = (moment(lastDayOfWeek, 'MM-DD-YYYY').subtract(i, 'days'));
            console.log(weekDays);
            weekDays.push({
                value: day.format('DD'),
                label: day.format('ddd'),
                date: day,
                mnth: day.format('MM'),
                month: day.format('MMM'),
            });
        }
        // const weekDays = [1, 2, 3, 4, 5, 6, 7].map((v: any, i: any) => {
        //   const day = moment(lastDayOfWeek).subtract(i, 'days');
        //   console.log(v)
        //   return ({
        //     value: day.format('DD'),
        //     label: day.format('ddd'),
        //     date: day,
        //     mnth: day.format('MM'),
        //     month: day.format('MMM'),
        //   });
        // })
        console.log(weekDays);
        return [...weekDays];
    }
    // end
    const headers = WeekCalendar();
    // next week of calendar
    const onNext = () => __awaiter(void 0, void 0, void 0, function* () {
        if (currentDate) {
            // var today = now.getFullYear() + (now.getMonth() + 1) + now.getDate();
            // var aa = new Date(currentDate)
            // var selectedDates = (aa.getFullYear() + (aa.getMonth() + 1) + aa.getDate())
            // if (selectedDates > today) {
            //   setprev(prev + 1);
            //   setcurrentDateValue(moment(currentDateValue).add(1, 'week'))
            // }
            setprev(prev + 1);
            setcurrentDateValue((moment(currentDateValue, 'MM-DD-YYYY').add(1, 'week')));
            // setcurrentDateValue(moment(currentDate).add(1, 'week'))
            return false;
        }
        if (weekEndDate) {
            headers === null || headers === void 0 ? void 0 : headers.filter((d) => {
                if (moment(weekEndDate, 'MM-DD-YYYY') < (moment(d.date._dx, 'MM-DD-YYYY').add(1, 'week'))) {
                    setnext(true);
                    return false;
                }
            });
        }
        if (next) {
            return false;
        }
        setprev(prev + 1);
        setdatevalue((moment(datevalue, 'MM-DD-YYYY').add(1, 'week')));
    });
    // end
    // next previous of calendar
    const onPrevious = () => {
        if (currentDateValue) {
            var now = new Date(currentDateValue);
            var today = now.getFullYear() + (now.getMonth() + 1) + now.getDate();
            var aa = new Date(weekStartDate);
            var selectedDates = (aa.getFullYear() + (aa.getMonth() + 1) + aa.getDate()) + 1;
            setprev(Math.round((today - selectedDates) / 6));
            if (prev > 0) {
                setprev(prev - 1);
                setcurrentDateValue((moment(currentDateValue, 'MM-DD-YYYY').subtract(1, 'week')));
            }
            return;
        }
        if (prev !== 0) {
            setprev(prev - 1);
        }
        setnext(false);
        if (prev !== 0) {
            setdatevalue((moment(datevalue, 'MM-DD-YYYY').subtract(1, 'week')));
        }
    };
    // end
    const selectDate = (val) => {
        debugger;
        let date = (moment(val, 'MM-DD-YYYY').format('MM-DD-YYYY'));
        setSelectedDate(date);
        onChange && onChange(date);
    };
    const checkDisable = (weekEndDate, d, weekStartDate) => {
        return ((weekEndDate && (d === null || d === void 0 ? void 0 : d.value) > moment(weekEndDate, 'MM-DD-YYYY').format('DD') && (d === null || d === void 0 ? void 0 : d.mnth) === moment(weekEndDate, 'MM-DD-YYYY').format('MM')) || ((d === null || d === void 0 ? void 0 : d.value) < moment(weekStartDate, 'MM-DD-YYYY').format('DD') && (d === null || d === void 0 ? void 0 : d.mnth) === moment(weekStartDate, 'MM-DD-YYYY').format('MM')));
    };
    var now = new Date(currentDateValue);
    now.getFullYear() + (now.getMonth()) + now.getDate();
    var aa = new Date(weekStartDate);
    (aa.getFullYear() + (aa.getMonth() + 1) + aa.getDate());
    return (React.createElement(StyledWeekCalendar, Object.assign({}, props),
        React.createElement(Top, { id: (props === null || props === void 0 ? void 0 : props.id) + '_parent_div' },
            React.createElement(Arrow, { id: (props === null || props === void 0 ? void 0 : props.id) + '_parent_span', onClick: () => onPrevious(), 
                // isdisabled={(currentDateValue && weekStartDate) ? (selectedDates > today) ? true : false
                //   : (prev === 0 ? true : false)}
                isdisabled: (prev === 0 ? true : false) },
                React.createElement(R, null,
                    React.createElement("li", null,
                        React.createElement("span", { className: "arrow arrow-left" })))),
            React.createElement(Calendar, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_span' }, headers === null || headers === void 0 ? void 0 :
                headers.map((d, i) => {
                    return i === 0 && React.createElement(Span$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_' + (d === null || d === void 0 ? void 0 : d.month) + '_sub_div', className: "month" }, d === null || d === void 0 ? void 0 : d.month);
                }), headers === null || headers === void 0 ? void 0 :
                headers.map((d) => {
                    return (React.createElement(List, { id: (props === null || props === void 0 ? void 0 : props.id) + '_' + (d === null || d === void 0 ? void 0 : d.label) + '_sublevel_div' },
                        React.createElement(DaySpan, { id: (props === null || props === void 0 ? void 0 : props.id) + '_' + (d === null || d === void 0 ? void 0 : d.label) + '_sublevel_span', className: `${checkDisable(weekEndDate, d, weekStartDate) ? 'fadedDay' : 'activeDay'}` }, d === null || d === void 0 ? void 0 : d.label),
                        React.createElement(DayDate, { id: (props === null || props === void 0 ? void 0 : props.id) + '_' + (d === null || d === void 0 ? void 0 : d.label.replaceAll('', '_')) + '_span', activeColor: activeColor, dateValue: selectedDate === moment(d === null || d === void 0 ? void 0 : d.date, 'MM-DD-YYYY').format('MM-DD-YYYY') ? selectedDate : '', 
                            // className={`${isActive(d?.value, d?.label) ? 'current-day' : ''} ${checkDisable(weekEndDate, d, weekStartDate) ? 'fadedDate' : 'activeDate'}`}
                            className: `${moment(currentDate, 'MM-DD-YYYY').format('MM-DD-YYYY') === moment(d === null || d === void 0 ? void 0 : d.date, 'MM-DD-YYYY').format('MM-DD-YYYY') ? 'current-day' : ''} ${checkDisable(weekEndDate, d, weekStartDate) ? 'fadedDate' : 'activeDate'}`, onClick: () => !checkDisable(weekEndDate, d, weekStartDate) && selectDate(d === null || d === void 0 ? void 0 : d.date), style: {
                                cursor: !checkDisable(weekEndDate, d, weekStartDate) ? 'pointer' : 'auto'
                            } }, d === null || d === void 0 ? void 0 : d.value)));
                })),
            React.createElement(Arrow, { id: (props === null || props === void 0 ? void 0 : props.id) + '_arrow_span', onClick: () => onNext(), isdisabled: next },
                React.createElement(R, null,
                    React.createElement("li", null,
                        React.createElement("span", { className: "arrow arrow-right" })))))));
};
// this is a default Props of the component
WeekCalendar.defaultProps = {
    weekStartDate: new Date(),
    weekEndDate: null,
    activeColor: '#008FFD',
};

const WeekCalendarProps = { weekStartDate: '', weekEndDate: '', activeColor: '#000' };

const BackgroundImageDivision = styled.div `
width: 100%;
${(props) => props &&
    css `
      ${(props) => {
        if (props.url && props.url.length > 0) {
            return `
          background:url('${props.url}');`;
        }
    }}

${(props) => {
        if (props.backgroundPosition) {
            return `
          background-position:${props.backgroundPosition};`;
        }
    }}


${(props) => {
        if (props.backgroundPositionX) {
            return `
          background-position-x:${props.backgroundPositionX};`;
        }
    }}


${(props) => {
        if (props.backgroundPositionY) {
            return `
          background-position-y:${props.backgroundPositionY};`;
        }
    }}


${(props) => {
        if (props.backgroundRepeat) {
            return `
          background-repeat:${props.backgroundRepeat};`;
        }
    }}


${(props) => {
        if (props.backgroundRepeatX) {
            return `
          background-repeat-x:${props.backgroundRepeatX};`;
        }
    }}


${(props) => {
        if (props.backgroundRepeatY) {
            return `
          background-repeat-y:${props.backgroundRepeatY};`;
        }
    }}


${(props) => {
        if (props.backgroundAttachment) {
            return `
          background-attachment:${props.backgroundAttachment};`;
        }
    }}


${(props) => {
        if (props.backgroundSize) {
            return `
          background-size:${props.backgroundSize};`;
        }
    }}


${(props) => {
        if (props.backgroundOrigin) {
            return `
          background-origin:${props.backgroundOrigin};`;
        }
    }}

${props.inLineStyles && { ...props.inLineStyles }}

    `}
`;

const BackgroundImage = (props) => {
    return React__default.createElement(BackgroundImageDivision, Object.assign({}, props), (props === null || props === void 0 ? void 0 : props.children) && (props === null || props === void 0 ? void 0 : props.children));
};
BackgroundImage.defaultProps = {
    url: '',
    backgroundPosition: '0% 0%',
    backgroundPositionX: 'left',
    backgroundPositionY: 'top',
    backgroundRepeat: 'repeat',
    backgroundRepeatX: 'repeat',
    backgroundRepeatY: 'repeat',
    backgroundAttachment: 'scroll',
    backgroundSize: 'auto',
    backgroundOrigin: 'padding-box',
};

const BackgroundImageProps = {
  url: '',
  backgroundPosition: ['0% 0%', 'bottom', 'center', 'inherit', 'left', 'revert', 'right', 'top', 'unset'],
  backgroundPositionX: ['center', 'inherit', 'initial', 'left', 'revert', 'right', 'unset'],
  backgroundPositionY: ['bottom', 'center', 'inherit', 'initial', 'revert', 'top', 'unset'],
  backgroundRepeat: [
    'repeat',
    'repeat-x',
    'repeat-y',
    'no-repeat',
    'space',
    'round',
    'initial',
    'inherit',
    'unset',
    'revert',
  ],
  backgroundRepeatX: ['repeat', 'no-repeat', 'initial', 'inherit', 'unset', 'revert'],
  backgroundRepeatY: ['repeat', 'no-repeat', 'initial', 'inherit', 'unset', 'revert'],
  backgroundAttachment: ['fixed', 'initial', 'inherit', 'scroll', 'unset', 'revert'],
  backgroundSize: ['auto', 'contain', 'cover', 'inherit', 'initial', 'revert', 'unset'],
  backgroundOrigin: ['border-box', 'padding-box', 'content-box', 'inherit', 'initial', 'unset'],
};

const InputWrapper = styled.div `
display: flex;
align-items: center;
flex-wrap: wrap;
`;
const OtpInputField = styled.input `
    text-align: center;
    width: 30px;
    padding: 10px;
    margin: 10px;
    font-size:16px;
    color:#000;
    ${(props) => props &&
    css `
      ${(props) => {
        if (props.variant === "standard") {
            return `
            border:0;
            border-bottom:1px solid #000;
            &:focus{
                outline: none;
            }
          `;
        }
        else {
            return `
            border:1px solid #000;
            `;
        }
    }}

${props.inLineStyles && { ...props.inLineStyles }}

    `}
`;

const OtpInput = (props) => {
    var _a, _b;
    const inputRefs = React__default.useRef([]);
    const [value, setValue] = React__default.useState({});
    const onchange = (eventValue, index) => {
        let newValue;
        if (eventValue) {
            newValue = Object.assign(Object.assign({}, value), { [index]: eventValue });
        }
        else {
            newValue = Object.assign({ [index]: eventValue }, value);
        }
        setValue(newValue);
        let convertToString = Object.keys(newValue).map(l => newValue[l]).join('');
        (props === null || props === void 0 ? void 0 : props.onChange) && (props === null || props === void 0 ? void 0 : props.onChange(convertToString));
        if (eventValue !== "") {
            if (index === 0) {
                inputRefs.current[index].style.borderColor = props === null || props === void 0 ? void 0 : props.focusBorderColor;
                inputRefs.current[index].style.color = props === null || props === void 0 ? void 0 : props.focusTextColor;
            }
            if (inputRefs.current[index + 1] != undefined || inputRefs.current[index + 1] != null) {
                inputRefs.current[index + 1].focus();
                // inputRefs.current[index+1].style.borderColor=props?.borderColor;
                // inputRefs.current[index+1].style.color=props?.textColor;
            }
        }
    };
    const onFocus = (index) => {
        inputRefs.current[index].style.borderColor = props === null || props === void 0 ? void 0 : props.focusBorderColor;
        inputRefs.current[index].style.color = props === null || props === void 0 ? void 0 : props.focusTextColor;
    };
    const backbutton = (e, index) => {
        if ((e.which >= 48 && e.which <= 57) || e.which === 46 || e.keyCode === 8) {
            if (e.keyCode === 8) {
                value[index] = '';
                setValue(value);
                inputRefs.current[index].style.borderColor = '#000';
                inputRefs.current[index].style.color = '#000';
                if (inputRefs.current[index - 1] != undefined || inputRefs.current[index - 1] != null) {
                    inputRefs.current[index - 1].focus();
                    inputRefs.current[index - 1].select();
                }
                e.preventDefault();
                onchange('', index);
            }
            return true;
        }
        else {
            e.preventDefault();
            return false;
        }
    };
    React__default.useEffect(() => {
        if (!props.value) {
            setValue({});
        }
    }, [props === null || props === void 0 ? void 0 : props.value]);
    const inputNumber = (_a = props === null || props === void 0 ? void 0 : props.numberOfInputs) !== null && _a !== void 0 ? _a : (_b = OtpInput.defaultProps) === null || _b === void 0 ? void 0 : _b.numberOfInputs;
    return (React__default.createElement(InputWrapper, { id: props === null || props === void 0 ? void 0 : props.id, name: props === null || props === void 0 ? void 0 : props.name, className: props === null || props === void 0 ? void 0 : props.className }, [...Array(inputNumber)].map((val, index) => {
        var _a;
        return (React__default.createElement(OtpInputField, Object.assign({}, props, { id: '', className: '', name: '', variant: props === null || props === void 0 ? void 0 : props.variant, inLineStyles: props === null || props === void 0 ? void 0 : props.inLineStyles, 
            // autoFocus={index === 0 && true}
            onFocus: () => onFocus(index), key: val ? val : index, type: props === null || props === void 0 ? void 0 : props.type, maxLength: 1, ref: (el) => {
                var _a;
                if (el != undefined || el != null) {
                    if (((_a = inputRefs === null || inputRefs === void 0 ? void 0 : inputRefs.current) === null || _a === void 0 ? void 0 : _a.length) < inputNumber) {
                        (inputRefs.current = [...inputRefs.current, el]);
                    }
                }
            }, value: (_a = value[index]) !== null && _a !== void 0 ? _a : '', onChange: (e) => { var _a; return onchange((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value, index); }, onKeyDown: (e) => { backbutton(e, index); } })));
    })));
};
OtpInput.defaultProps = {
    numberOfInputs: 4,
    variant: "standard",
    type: "text",
    focusTextColor: '#0071F2',
    focusBorderColor: '#0071F2',
};

const OtpInputProps = {
  numberOfInputs: 0,
  variant: ['standard', 'outlined'],
  type: ['number', 'password', 'text'],
  focusTextColor: '#000',
  focusBorderColor: '#000',
};

const Input$5 = styled.input `
width:100%;
padding: 10px;
font-size:16px;
color:#000;
${(props) => props &&
    css `
      ${(props) => {
        if (props.variant === "standard") {
            return `
            border:0;
            border-bottom:1px solid #000;
            &:focus{
                outline: none;
            }
          `;
        }
        else if (props.variant === "outlined") {
            return `
            border:1px solid #000;
            border-radius: 4px;
            `;
        }
        else {
            return `
            border:0;
            &:focus{
              border:0;
              outline: none;
            }
          `;
        }
    }}

      ${props.inLineStyles && { ...props.inLineStyles }} 

      `}
`;

let autoComplete;
const loadScript = (url, callback) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    if (script === null || script === void 0 ? void 0 : script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    }
    else {
        script.onload = () => callback();
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};
function handleScriptLoad(autoCompleteRef, returnObject) {
    autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current);
    autoComplete.setFields(["address_components", "formatted_address", "geometry"]);
    autoComplete.addListener("place_changed", () => handlePlaceSelect(returnObject));
}
const handlePlaceSelect = (returnObject) => {
    var _a, _b, _c, _d;
    const addressObject = autoComplete.getPlace();
    if (addressObject) {
        let _obj = {};
        _obj["address"] = addressObject === null || addressObject === void 0 ? void 0 : addressObject.formatted_address;
        _obj["latitude"] = (_b = (_a = addressObject === null || addressObject === void 0 ? void 0 : addressObject.geometry) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.lat();
        _obj["longitude"] = (_d = (_c = addressObject === null || addressObject === void 0 ? void 0 : addressObject.geometry) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.lng();
        returnObject(_obj);
        // console.log(addressObject)
    }
};
const LocationSearch = (props) => {
    var _a, _b;
    const [query, setQuery] = React__default.useState((_a = props === null || props === void 0 ? void 0 : props.value) !== null && _a !== void 0 ? _a : {});
    const autoCompleteRef = React__default.useRef(null);
    const returnObject = (data) => {
        setQuery(data);
        (props === null || props === void 0 ? void 0 : props.onChange) && (props === null || props === void 0 ? void 0 : props.onChange(data));
    };
    React__default.useEffect(() => {
        loadScript(`https://maps.googleapis.com/maps/api/js?key=${props.apiKey}&libraries=places`, () => handleScriptLoad(autoCompleteRef, returnObject));
    }, []);
    const pacContainer = document.getElementsByClassName('pac-container')[0];
    if (pacContainer != undefined || pacContainer != null) {
        pacContainer.style.boxShadow = "0 2px 4px rgb(0 0 0 / 20%)";
        pacContainer.style.padding = "10px 0px";
        pacContainer.style.borderRadius = "0 0 8px 8px";
    }
    return (React__default.createElement(Input$5, Object.assign({}, props, { ref: autoCompleteRef, value: (_b = query === null || query === void 0 ? void 0 : query.address) !== null && _b !== void 0 ? _b : '', placeholder: props.placeHolder, onChange: event => setQuery(Object.assign(Object.assign({}, query), { address: event.target.value })) })));
};
LocationSearch.defaultProps = {
    variant: 'standard',
    apiKey: 'AIzaSyBqeACJgp12OLU6EkHeUtFgya2naH1LhrU',
    placeHolder: 'Enter a City',
};

const LocationSearchProps = {
  variant: ['standard', 'outlined', 'none'],
  apiKey: '',
  placeHolder: '',
};

const Container = styled.div `
position: relative;
width:100%;
 `;
const Input$4 = styled.input `
width: 100%;
font-size:16px;
color:#000;
padding:10px;
    ${(props) => props &&
    css `
      ${(props) => {
        if (props.variant === "standard") {
            return `
            border:0;
            border-bottom:1px solid #000;
            &:focus{
                outline: none;
            }
          `;
        }
        else if (props.variant === "outlined") {
            return `
            border:1px solid #000;
            border-radius: 4px;
            `;
        }
        else {
            return `
            border:0;
            &:focus{
              border:0;
              outline: none;
            }
          `;
        }
    }}

${props.inLineStyles && { ...props.inLineStyles }}

      `}
`;
const DropDown$1 = styled.div `
margin-top: 10px;
border-radius: 10px;
position: absolute;
width: 100%;
max-height:250px;
overflow: auto;
background-color: #fff;
${(props) => {
    if (props.elevation === '1') {
        return `
        box-shadow: 0 3px 3px rgba(0,0,0,0.2);
            `;
    }
    else if (props.elevation === '2') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.15), 
        0 2px 2px rgba(0,0,0,0.15), 
        0 4px 4px rgba(0,0,0,0.15), 
        0 8px 8px rgba(0,0,0,0.15);
        `;
    }
    else if (props.elevation === '3') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
              0 2px 2px rgba(0,0,0,0.12), 
              0 4px 4px rgba(0,0,0,0.12), 
              0 8px 8px rgba(0,0,0,0.12),
              0 16px 16px rgba(0,0,0,0.12);
        `;
    }
    else if (props.elevation === '4') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.11), 
              0 2px 2px rgba(0,0,0,0.11), 
              0 4px 4px rgba(0,0,0,0.11), 
              0 8px 8px rgba(0,0,0,0.11), 
              0 16px 16px rgba(0,0,0,0.11), 
              0 32px 32px rgba(0,0,0,0.11);
        `;
    }
    else {
        return `
        box-shadow:none;
        `;
    }
}}
`;
const DropDownList$1 = styled.div `
cursor: pointer;
&:hover{
    background-color: #e8e8e8;
}
${(props) => {
    if (props.dropDownListMargin) {
        return `
            margin:${props.dropDownListMargin}px;
          `;
    }
}}

      ${(props) => {
    if (props.dropDownListPadding) {
        return `
            padding:${props.dropDownListPadding}px;
          `;
    }
}}


${(props) => {
    if (props.dropDownListColor) {
        return `
            color:${props.dropDownListColor};
          `;
    }
}} 

${(props) => {
    if (props.dropDownListFontSize === "small") {
        return `
            font-size:16px;
          `;
    }
    else if (props.dropDownListFontSize === "medium") {
        return `
            font-size:20px;
          `;
    }
    else if (props.dropDownListFontSize === "large") {
        return `
            font-size:25px;
          `;
    }
}} 
`;

const AutoSuggestion = (props) => {
    var _a, _b, _c;
    const [value, setValue] = React__default.useState((_a = props === null || props === void 0 ? void 0 : props.value) !== null && _a !== void 0 ? _a : '');
    const [open, setOpen] = React__default.useState(false);
    const [suggestionList, setSuggestionList] = React__default.useState((_b = props === null || props === void 0 ? void 0 : props.options) !== null && _b !== void 0 ? _b : []);
    const handleChange = (e) => {
        var _a, _b, _c, _d;
        if ((props === null || props === void 0 ? void 0 : props.maxLength) && ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) <= (props === null || props === void 0 ? void 0 : props.maxLength) || (props === null || props === void 0 ? void 0 : props.minLength) && ((_d = (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) <= (props === null || props === void 0 ? void 0 : props.minLength)) {
            (props === null || props === void 0 ? void 0 : props.onChange) && props.onChange(e);
        }
        e.stopPropagation();
        setValue(e.target.value);
        filteredListSuggestion(e.target.value);
    };
    const filteredListSuggestion = (value) => {
        const filteredList = (props === null || props === void 0 ? void 0 : props.options) && (props === null || props === void 0 ? void 0 : props.options.filter((l) => l.label.toLowerCase().includes(value.toLowerCase())));
        setSuggestionList(filteredList);
    };
    const handleClick = (val) => {
        props.onChange && props.onChange(val);
        setValue(val.label);
        filteredListSuggestion(val.label);
        setOpen(false);
    };
    return (React__default.createElement(Container, { id: props === null || props === void 0 ? void 0 : props.id, name: props === null || props === void 0 ? void 0 : props.name, className: (_c = props === null || props === void 0 ? void 0 : props.className) !== null && _c !== void 0 ? _c : '' },
        React__default.createElement(Input$4, Object.assign({}, props, { id: '', className: '', name: '', variant: props.variant, inLineStyles: props.inLineStyles, value: value, onChange: (e) => handleChange(e), placeholder: props.placeHolder, onFocus: () => setOpen(true), onBlur: () => setOpen(false) })),
        open &&
            React__default.createElement(DropDown$1, { elevation: props.elevation }, suggestionList.length > 0 ? suggestionList.map((val) => {
                return (React__default.createElement(DropDownList$1, { id: (props === null || props === void 0 ? void 0 : props.id) + val.label + '_div', dropDownListMargin: props === null || props === void 0 ? void 0 : props.dropDownListMargin, dropDownListPadding: props === null || props === void 0 ? void 0 : props.dropDownListPadding, dropDownListColor: props === null || props === void 0 ? void 0 : props.dropDownListColor, dropDownListFontSize: props === null || props === void 0 ? void 0 : props.dropDownListFontSize, key: val.value, onMouseDown: (e) => {
                        e.button === 0 && handleClick(val);
                    } }, val.label));
            }) : (React__default.createElement(DropDownList$1, { dropDownListMargin: props === null || props === void 0 ? void 0 : props.dropDownListMargin, dropDownListPadding: props === null || props === void 0 ? void 0 : props.dropDownListPadding, dropDownListColor: props === null || props === void 0 ? void 0 : props.dropDownListColor, dropDownListFontSize: props === null || props === void 0 ? void 0 : props.dropDownListFontSize }, "No Data Found")))));
};
AutoSuggestion.defaultProps = {
    variant: 'standard',
    placeHolder: 'Auto Suggestion',
    elevation: '1',
    options: [],
    dropDownListFontSize: 'small',
    dropDownListColor: '#000',
    dropDownListMargin: 0,
    dropDownListPadding: 10,
};

const AutoSuggestionProps = {
  variant: ['standard', 'outlined', 'none'],
  placeHolder: '',
  elevation: ['0', '1', '2', '3', '4'],
  options: [],
  dropDownListFontSize: ['small', 'medium', 'large'],
  dropDownListColor: '#000',
  dropDownListMargin: 0,
  dropDownListPadding: 0,
  minLength:0,
  maxLength:0
};

const Wrapper$3 = styled.div `
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;
const TextWrapper = styled.div `
    display:flex;
    align-items: center;
    min-width: inherit;
    min-height: inherit;

    ${(props) => {
    if (props.fullWidth) {
        return `
            width:100%;
        `;
    }
}}

    ${(props) => {
    if (props.iconHeight) {
        return `
        & svg{
          height:${props.iconHeight ? props.iconHeight + 'px' : '100%'};
        }
        `;
    }
}}

    ${(props) => {
    if (props.iconWidth) {
        return `
        & svg{
          width:${props.iconWidth ? props.iconWidth + 'px' : '100%'};
        }
        `;
    }
}}

${(props) => {
    if (props.selectedTextColor) {
        return `
        & svg path {
          fill:${props.selectedTextColor};
        }
        & i{
          color:${props.selectedTextColor};
        }
        `;
    }
}}

${(props) => {
    if (props.iconPosition === "left") {
        return `
      & svg,i {
        margin-right:10px;
      }
        `;
    }
    else {
        return `
      & svg,i {
        margin-left:10px;
      }
      `;
    }
}}

${(props) => {
    if (props.textSize === "small") {
        return `
      & i{
        font-size:16px;
      }
        `;
    }
    else if (props.textSize === "medium") {
        return `
          & i{
            font-size:20px;
          }
        `;
    }
    else if (props.textSize === "large") {
        return `
      & i{
        font-size:25px;
      }
        `;
    }
}}

  

`;
const Img$3 = styled.img `
 height:${props => props.iconHeight ? props.iconHeight + 'px' : '100%'};
 width:${props => props.iconWidth ? props.iconWidth + 'px' : '100%'};

 ${(props) => {
    if (props.iconPosition === "left") {
        return `
           margin-right:10px;
        `;
    }
    else {
        return `
      margin-left:10px;
      `;
    }
}}
`;
const Text$2 = styled.span `
    ${(props) => {
    if (props.selectedTextColor) {
        return `
           color:${props.selectedTextColor};
        `;
    }
}}

      ${(props) => {
    if (props.textSize === "small") {
        return `
           font-size:16px;
        `;
    }
    else if (props.textSize === "medium") {
        return `
           font-size:20px;
        `;
    }
    else if (props.textSize === "large") {
        return `
           font-size:25px;
        `;
    }
}}
`;
const Label$3 = styled.span `
font-weight: 500;
`;
const SelectionDiv = styled.div `
border: 1px solid;
border-radius: 5px;
/* cursor: pointer; */
display:flex;
align-items:center;
justify-content:center;
text-transform: capitalize;
margin:10px 10px 10px 0px;
padding:5px 20px;
min-width: 70px;
min-height: 25px;
${(props) => {
    if (props.borderColors) {
        return `
    border-color:${props.borderColors}
  `;
    }
}}
${(props) => {
    if (props.backgroundColors) {
        return `
      background-color:${props.backgroundColors}
  `;
    }
}}
${(props) => props &&
    css `
      ${(props) => {
        if (props.fullWidth) {
            return `
            flex:1;
        `;
        }
    }}

      ${(props) => {
        if (props.selectedBorderColor) {
            return `
           border-color:${props.selectedBorderColor};
        `;
        }
    }}

      ${(props) => {
        if (props.selectedBackgroundColor) {
            return `
           background-color:${props.selectedBackgroundColor};
        `;
        }
    }}

${props.inLineStyles && { ...props.inLineStyles }}

    `}

`;
const Div$2 = styled.div ``;

const TapSelect = (props) => {
    var _a, _b, _c, _d;
    const [selected, setSelected] = React__default.useState((props === null || props === void 0 ? void 0 : props.defaultSelected) ? props === null || props === void 0 ? void 0 : props.defaultSelected : props.type.toLowerCase() === 'single' ? {} : []);
    const borderColor = props.selectedBorderColor
        ? props.selectedBorderColor
        : (_a = TapSelect.defaultProps) === null || _a === void 0 ? void 0 : _a.selectedBorderColor;
    const backgroundColor = props.selectedBackgroundColor
        ? props.selectedBackgroundColor
        : (_b = TapSelect.defaultProps) === null || _b === void 0 ? void 0 : _b.selectedBackgroundColor;
    const textColor = props.selectedTextColor ? props.selectedTextColor : (_c = TapSelect.defaultProps) === null || _c === void 0 ? void 0 : _c.selectedTextColor;
    const fontColor = props.textColor ? props.textColor : (_d = TapSelect.defaultProps) === null || _d === void 0 ? void 0 : _d.textColor;
    React__default.useEffect(() => {
        setSelected((props === null || props === void 0 ? void 0 : props.defaultSelected) ? props === null || props === void 0 ? void 0 : props.defaultSelected : props.type.toLowerCase() === 'single' ? {} : []);
    }, [props === null || props === void 0 ? void 0 : props.defaultSelected]);
    const getSelected = (e, item) => {
        props.options &&
            props.options.map((data) => {
                if (data.value === item.value) {
                    //single selection statement
                    if (props.type.toLowerCase() === 'single') {
                        if (selected.value === data.value) {
                            props.onChange && props.onChange({});
                            (props === null || props === void 0 ? void 0 : props.onClick) && props.onClick(e);
                            setSelected({});
                        }
                        else {
                            props.onChange && props.onChange(data);
                            (props === null || props === void 0 ? void 0 : props.onClick) && props.onClick(e, data);
                            setSelected(data);
                        }
                    }
                    //multile selection statement
                    else if (props.type.toLowerCase() === 'multiple') {
                        if (selected.find((l) => l.value === item.value) === undefined) {
                            props.onChange && props.onChange([...selected, Object.assign({}, data)]);
                            setSelected([...selected, Object.assign({}, data)]);
                        }
                        else {
                            const filteredData = selected.filter((l) => l.value != item.value);
                            props.onChange && props.onChange(filteredData);
                            setSelected(filteredData);
                        }
                    }
                }
            });
    };
    const selectedOptions = (val, returnValue, color) => {
        if (selected) {
            if ((props === null || props === void 0 ? void 0 : props.type) === 'single') {
                if (val.value === selected.value) {
                    return returnValue;
                }
                else {
                    return color;
                }
            }
            else {
                if (selected.filter((l) => l.value === val.value).length > 0) {
                    return returnValue;
                }
                else {
                    return color;
                }
            }
        }
    };
    const displayIcon = (val) => {
        return (React__default.createElement(React__default.Fragment, null,
            (val === null || val === void 0 ? void 0 : val.url) && (React__default.createElement(Img$3, { iconWidth: props === null || props === void 0 ? void 0 : props.iconWidth, iconHeight: props === null || props === void 0 ? void 0 : props.iconHeight, iconPosition: props.iconPosition, src: val === null || val === void 0 ? void 0 : val.url })),
            (val === null || val === void 0 ? void 0 : val.icon) && (val === null || val === void 0 ? void 0 : val.icon)));
    };
    return (React__default.createElement(Div$2, { id: props === null || props === void 0 ? void 0 : props.id, name: props === null || props === void 0 ? void 0 : props.name, className: props === null || props === void 0 ? void 0 : props.className },
        React__default.createElement(Label$3, { id: (props === null || props === void 0 ? void 0 : props.id) + '_span' }, props === null || props === void 0 ? void 0 : props.label),
        React__default.createElement(Wrapper$3, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' }, (props === null || props === void 0 ? void 0 : props.options) && (props === null || props === void 0 ? void 0 : props.options.map((val) => {
            return (React__default.createElement(SelectionDiv, { id: (props === null || props === void 0 ? void 0 : props.id) + "_" + (val === null || val === void 0 ? void 0 : val.label.replace(" ", "_")) + "_div", key: val.value, onClick: (e) => !(val === null || val === void 0 ? void 0 : val.disabled) && getSelected(e, val), className: `selectionDiv ${selectedOptions(val, true, false) ? 'active' : ''}`, selectedBorderColor: (val === null || val === void 0 ? void 0 : val.disabled) ? '#E0E0E0' : selectedOptions(val, borderColor, '#000'), selectedBackgroundColor: (val === null || val === void 0 ? void 0 : val.disabled) ? '#E0E0E0' : selectedOptions(val, backgroundColor, '#fff'), fullWidth: props === null || props === void 0 ? void 0 : props.fullWidth, style: {
                    cursor: (val === null || val === void 0 ? void 0 : val.disabled) ? 'auto' : 'pointer',
                }, inLineStyles: props === null || props === void 0 ? void 0 : props.inLineStyles, backgroundColors: props.backgroundColors, borderColors: props.borderColors },
                React__default.createElement(TextWrapper, { id: (props === null || props === void 0 ? void 0 : props.id) + '_' + val.label.replace(" ", "_") + '_div', fullWidth: props === null || props === void 0 ? void 0 : props.fullWidth, style: {
                        justifyContent: (val === null || val === void 0 ? void 0 : val.url) || (val === null || val === void 0 ? void 0 : val.icon) ? 'space-between' : 'center',
                    }, selectedTextColor: selectedOptions(val, textColor, fontColor), textSize: props === null || props === void 0 ? void 0 : props.textSize, iconWidth: props === null || props === void 0 ? void 0 : props.iconWidth, iconHeight: props === null || props === void 0 ? void 0 : props.iconHeight, iconPosition: props.iconPosition },
                    props.iconPosition === 'left' && displayIcon(val),
                    React__default.createElement(Text$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_' + val.label.replace(" ", "_") + '_span', selectedTextColor: (val === null || val === void 0 ? void 0 : val.disabled) ? '#B6B6B6' : selectedOptions(val, textColor, fontColor), textSize: props === null || props === void 0 ? void 0 : props.textSize }, val.label),
                    props.iconPosition === 'right' && displayIcon(val))));
        })))));
};
TapSelect.defaultProps = {
    type: 'single',
    fullWidth: false,
    selectedBorderColor: '#1890ff',
    selectedBackgroundColor: '#fff',
    selectedTextColor: '#1890ff',
    textSize: 'small',
    iconHeight: 20,
    iconWidth: 20,
    textColor: '#000',
    label: 'Select',
    options: [{ label: 'select', value: 'select' }],
    iconPosition: 'left',
};

const TapSelectProps = {
  type: ['single', 'multiple'],
  fullWidth: false,
  selectedBorderColor: '#000',
  selectedBackgroundColor: '#000',
  selectedTextColor: '#000',
  textSize: ['small', 'medium', 'large'],
  iconHeight: 0,
  iconWidth: 0,
  textColor: '#000',
  label: '',
  options: [],
  iconPosition: ['left', 'right'],
};

const Icon = styled.i `

${(props) => props &&
    css `

${(props) => {
        if (props.size === "small") {
            return `
          &::before{
            font-size:16px;
          }
          `;
        }
        else if (props.size === "medium") {
            return `
            &::before{
              font-size:25px;
            }
            `;
        }
        else if (props.size === "large") {
            return `
            &::before{
              font-size:40px;
            }
            `;
        }
        else if (typeof props.size === "number") {
            return `
            &::before{
              font-size:${props === null || props === void 0 ? void 0 : props.size}px;
            }
            `;
        }
    }} 

${props.inLineStyles && { ...props.inLineStyles }}

      `}
`;

const Icons = (props) => {
    return (React__default.createElement(Icon, Object.assign({}, props, { className: `fa fa-${props.fontIcon} ${(props === null || props === void 0 ? void 0 : props.className) && (props === null || props === void 0 ? void 0 : props.className.length) > 0 ? props === null || props === void 0 ? void 0 : props.className : ''}`, "aria-hidden": props.ariaHidden })));
};
Icons.defaultProps = {
    fontIcon: 'address-book',
    ariaHidden: 'true',
    size: 'small',
};

// import PropTypes from 'prop-types';

const IconsProps={
    inLineStyles:{},
    fontIcon:['address-book','address-book-o','address-card','address-card-o','adjust','american-sign-language-interpreting','anchor','archive','area-chart','arrows','arrows-h','arrows-v','asl-interpreting','assistive-listening-systems','asterisk','at','audio-description','automobile','balance-scale','ban','bank','bar-chart','bar-chart-o','barcode','bars','bath','bathtub','battery','battery-0','battery-1','battery-2','battery-3','battery-4','battery-empty','battery-full','battery-half','battery-quarter','battery-three-quarters','bed','beer','bell','bell-o','bell-slash','bell-slash-o','bicycle','binoculars','birthday-cake','blind','bluetooth','bluetooth-b','bolt','bomb','book','bookmark','bookmark-o','braille','briefcase','bug','building','building-o','bullhorn','bullseye','bus','cab','calculator','calendar','calendar-check-o','calendar-minus-o','calendar-o','calendar-plus-o','calendar-times-o','camera','camera-retro','car','caret-square-o-down','caret-square-o-left','caret-square-o-right','caret-square-o-up','cart-arrow-down','cart-plus','cc','certificate','check','check-circle','check-circle-o','check-square','check-square-o','child','circle','circle-o','circle-o-notch','circle-thin','clock-o','clone','close','cloud','cloud-download','cloud-upload','code','code-fork','coffee','cog','cogs','comment','comment-o','commenting','commenting-o','comments','comments-o','compass','copyright','creative-commons','credit-card','credit-card-alt','crop','crosshairs','cube','cubes','cutlery','dashboard','database','deaf','deafness','desktop','diamond','dot-circle-o','download','drivers-license','drivers-license-o','edit','ellipsis-h','ellipsis-v','envelope','envelope-o','envelope-open','envelope-open-o','envelope-square','eraser','exchange','exclamation','exclamation-circle','exclamation-triangle','external-link','external-link-square','eye','eye-slash','eyedropper','fax','feed','female','fighter-jet','file-archive-o','file-audio-o','file-code-o','file-excel-o','file-image-o','file-movie-o','file-pdf-o','file-photo-o','file-picture-o','file-powerpoint-o','file-sound-o','file-video-o','file-word-o','file-zip-o','film','filter','fire','fire-extinguisher','flag','flag-checkered','flag-o','flash','flask','folder','folder-o','folder-open','folder-open-o','frown-o','futbol-o','gamepad','gavel','gear','gears','gift','glass','globe','graduation-cap','group','hand-grab-o','hand-lizard-o','hand-paper-o','hand-peace-o','hand-pointer-o','hand-rock-o','hand-scissors-o','hand-spock-o','hand-stop-o','handshake-o','hard-of-hearing','hashtag','hdd-o','headphones','heart','heart-o','heartbeat','history','home','hotel','hourglass','hourglass-1','hourglass-2','hourglass-3','hourglass-end','hourglass-half','hourglass-o','hourglass-start','i-cursor','id-badge','id-card','id-card-o','image','inbox','industry','info','info-circle','institution','key','keyboard-o','language','laptop','leaf','legal','lemon-o','level-down','level-up','life-bouy','life-buoy','life-ring','life-saver','lightbulb-o','line-chart','location-arrow','lock','low-vision','magic','magnet','mail-forward','mail-reply','mail-reply-all','male','map','map-marker','map-o','map-pin','map-signs','meh-o','microchip','microphone','microphone-slash','minus','minus-circle','minus-square','minus-square-o','mobile','mobile-phone','money','moon-o','mortar-board','motorcycle','mouse-pointer','music','navicon','newspaper-o','object-group','object-ungroup','paint-brush','paper-plane','paper-plane-o','paw','pencil','pencil-square','pencil-square-o','percent','phone','phone-square','photo','picture-o','pie-chart','plane','plug','plus','plus-circle','plus-square','plus-square-o','podcast','power-off','print','puzzle-piece','qrcode','question','question-circle','question-circle-o','quote-left','quote-right','random','recycle','refresh','registered','remove','reorder','reply','reply-all','retweet','road','rocket','rss','rss-square','s15','search','search-minus','search-plus','send','send-o','server','share','share-alt','share-alt-square','share-square','share-square-o','shield','ship','shopping-bag','shopping-basket','shopping-cart','shower','sign-in','sign-language','sign-out','signal','signing','sitemap','sliders','smile-o','snowflake-o','soccer-ball-o','sort','sort-alpha-asc','sort-alpha-desc','sort-amount-asc','sort-amount-desc','sort-asc','sort-desc','sort-down','sort-numeric-asc','sort-numeric-desc','sort-up','space-shuttle','spinner','spoon','square','square-o','star','star-half','star-half-empty','star-half-full','star-half-o','star-o','sticky-note','sticky-note-o','street-view','suitcase','sun-o','support','tablet','tachometer','tag','tags','tasks','taxi','television','terminal','thermometer','thermometer-0','thermometer-1','thermometer-2','thermometer-3','thermometer-4','thermometer-empty','thermometer-full','thermometer-half','thermometer-quarter','thermometer-three-quarters','thumb-tack','thumbs-down','thumbs-o-down','thumbs-o-up','thumbs-up','ticket','times','times-circle','times-circle-o','times-rectangle','times-rectangle-o','tint','toggle-down','toggle-left','toggle-off','toggle-on','toggle-right','toggle-up','trademark','trash','trash-o','tree','trophy','truck','tty','tv','umbrella','universal-access','university','unlock','unlock-alt','unsorted','upload','user','user-circle','user-circle-o','user-o','user-plus','user-secret','user-times','users','vcard','vcard-o','video-camera','volume-control-phone','volume-down','volume-off','volume-up','warning','wheelchair','wheelchair-alt','wifi','window-close','window-close-o','window-maximize','window-minimize','window-restore','wrench','american-sign-language-interpreting','asl-interpreting','assistive-listening-systems','audio-description','blind','braille','cc','deaf','deafness','hard-of-hearing','low-vision','question-circle-o','sign-language','signing','tty','universal-access','volume-control-phone','wheelchair','wheelchair-alt','hand-grab-o','hand-lizard-o','hand-o-down','hand-o-left','hand-o-right','hand-o-up','hand-paper-o','hand-peace-o','hand-pointer-o','hand-rock-o','hand-scissors-o','hand-spock-o','hand-stop-o','thumbs-down','thumbs-o-down','thumbs-o-up','thumbs-up','ambulance','automobile','bicycle','bus','cab','car','fighter-jet','motorcycle','plane','rocket','ship','space-shuttle','subway','taxi','train','truck','wheelchair','wheelchair-alt','genderless','intersex','mars','mars-double','mars-stroke','mars-stroke-h','mars-stroke-v','mercury','neuter','transgender','transgender-alt','venus','venus-double','venus-mars','file','file-archive-o','file-audio-o','file-code-o','file-excel-o','file-image-o','file-movie-o','file-o','file-pdf-o','file-photo-o','file-picture-o','file-powerpoint-o','file-sound-o','file-text','file-text-o','file-video-o','file-word-o','file-zip-o','circle-o-notch','cog','gear','refresh','spinner','check-square','check-square-o','circle','circle-o','dot-circle-o','minus-square','minus-square-o','plus-square','plus-square-o','square','square-o','cc-amex','cc-diners-club','cc-discover','cc-jcb','cc-mastercard','cc-paypal','cc-stripe','cc-visa','credit-card','credit-card-alt','google-wallet','paypal','area-chart','bar-chart','bar-chart-o','line-chart','pie-chart','bitcoin','btc','cny','dollar','eur','euro','gbp','gg','gg-circle','ils','inr','jpy','krw','money','rmb','rouble','rub','ruble','rupee','shekel','sheqel','try','turkish-lira','usd','viacoin','won','yen','align-center','align-justify','align-left','align-right','bold','chain','chain-broken','clipboard','columns','copy','cut','dedent','eraser','file','file-o','file-text','file-text-o','files-o','floppy-o','font','header','indent','italic','link','list','list-alt','list-ol','list-ul','outdent','paperclip','paragraph','paste','repeat','rotate-left','rotate-right','save','scissors','strikethrough','subscript','superscript','table','text-height','text-width','th','th-large','th-list','underline','undo','unlink','angle-double-down','angle-double-left','angle-double-right','angle-double-up','angle-down',
                'angle-left','angle-right','angle-up','arrow-circle-down','arrow-circle-left','arrow-circle-o-down','arrow-circle-o-left','arrow-circle-o-right','arrow-circle-o-up','arrow-circle-right','arrow-circle-up','arrow-down','arrow-left','arrow-right','arrow-up','arrows','arrows-alt','arrows-h','arrows-v','caret-down','caret-left','caret-right','caret-square-o-down','caret-square-o-left','caret-square-o-right','caret-square-o-up','caret-up','chevron-circle-down','chevron-circle-left','chevron-circle-right','chevron-circle-up','chevron-down','chevron-left','chevron-right','chevron-up','exchange','hand-o-down','hand-o-left','hand-o-right','hand-o-up','long-arrow-down','long-arrow-left','long-arrow-right','long-arrow-up','toggle-down','toggle-left','toggle-right','toggle-up','arrows-alt','backward','compress','eject','expand','fast-backward','fast-forward','forward','pause','pause-circle','pause-circle-o','play','play-circle','play-circle-o','random','step-backward','step-forward','stop','stop-circle','stop-circle-o','youtube-play','500px','adn','amazon','android','angellist','apple','bandcamp','behance','behance-square','bitbucket','bitbucket-square','bitcoin','black-tie','bluetooth','bluetooth-b','btc','buysellads','cc-amex','cc-diners-club','cc-discover','cc-jcb','cc-mastercard','cc-paypal','cc-stripe','cc-visa','chrome','codepen','codiepie','connectdevelop','contao','css3','dashcube','delicious','deviantart','digg','dribbble','dropbox','drupal','edge','eercast','empire','envira','etsy','expeditedssl','fa','facebook','facebook-f','facebook-official','facebook-square','firefox','first-order','flickr','font-awesome','fonticons','fort-awesome','forumbee','foursquare','free-code-camp','ge','get-pocket','gg','gg-circle','git','git-square','github','github-alt','github-square','gitlab','gittip','glide','glide-g','google','google-plus','google-plus-circle','google-plus-official','google-plus-square','google-wallet','gratipay','grav','hacker-news','houzz','html5','imdb','instagram','internet-explorer','ioxhost','joomla','jsfiddle','lastfm','lastfm-square','leanpub','linkedin','linkedin-square','linode','linux','maxcdn','meanpath','medium','meetup','mixcloud','modx','odnoklassniki','odnoklassniki-square','opencart','openid','opera','optin-monster','pagelines','paypal','pied-piper','pied-piper-alt','pied-piper-pp','pinterest','pinterest-p','pinterest-square','product-hunt','qq','quora','ra','ravelry','rebel','reddit','reddit-alien','reddit-square','renren','resistance','safari','scribd','sellsy','share-alt','share-alt-square','shirtsinbulk','simplybuilt','skyatlas','skype','slack','slideshare','snapchat','snapchat-ghost','snapchat-square','soundcloud','spotify','stack-exchange','stack-overflow','steam','steam-square','stumbleupon','stumbleupon-circle','superpowers','telegram','tencent-weibo','themeisle','trello','tripadvisor','tumblr','tumblr-square','twitch','twitter','twitter-square','usb','viacoin','viadeo','viadeo-square','vimeo','vimeo-square','vine','vk','wechat','weibo','weixin','whatsapp','wikipedia-w','windows','wordpress','wpbeginner','wpexplorer','wpforms','xing','xing-square','y-combinator','y-combinator-square','yahoo','yc','yc-square','yelp','yoast','youtube','youtube-play','youtube-square','ambulance','h-square','heart','heart-o','heartbeat','hospital-o','medkit','plus-square','stethoscope','user-md','wheelchair','wheelchair-alt'],
    ariaHidden:['true','false'],
    className:'',
    size:['small','medium','large'],
};

const PopoverEle$1 = styled.div `
position: fixed;
background: white;
width: min-content;
padding: 10px 12px;
text-align: left;
border-radius: 4px;
box-shadow:0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
${props => props && css `

${(props) => {
    if (props.anchorOrigin.vertical === 'bottom' && props.anchorOrigin.horizontal === 'center') {
        return ` 
transform: translate(${(props.transform.left) - (props.transform.width / 2)}px, ${0}px);
`;
    }
    else if (props.anchorOrigin.vertical === 'top' && props.anchorOrigin.horizontal === 'center') {
        return `
transform: translate(${props.transform.left - (props.transform.width / 2)}px, ${-(props.transform.height + props.transform.height + 10)}px);
`;
    }
    else if (props.anchorOrigin.vertical === 'bottom' && props.anchorOrigin.horizontal === 'left') {
        return ` 
transform: translate(${(props.transform.left - props.transform.width) - props.transform.height}px, ${0}px);
`;
    }
    else if (props.anchorOrigin.vertical === 'top' && props.anchorOrigin.horizontal === 'left') {
        return ` 
transform: translate(${(props.transform.left - props.transform.width) - props.transform.height}px, ${-(props.transform.height + props.transform.height + 10)}px);
`;
    }
    else if (props.anchorOrigin.vertical === 'top' && props.anchorOrigin.horizontal === 'right') {
        return `
transform: translate(${(props.transform.left) - props.transform.height}px, ${-(props.transform.height + props.transform.height + 10)}px);
`;
    }
    else if (props.anchorOrigin.vertical === 'bottom' && props.anchorOrigin.horizontal === 'right') {
        return `
transform: translate(${props.transform.left - props.transform.height}px, ${0}px);
`;
    }
}}

${(props) => {
    if (props.open) {
        return ` 
visibility: visible;
opacity: 1;
`;
    }
    else {
        return `
visibility: hidden;
opacity: 0;
`;
    }
}}
`}
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;

// This is a Popover component
const Popover = (props) => {
    /* this is a props variables */
    const { open, children, onClose } = props;
    const anchorEl = open;
    const onopen = Boolean(open);
    const node = React__default.useRef(null);
    const rect = onopen && anchorEl && anchorEl.getBoundingClientRect();
    if (onopen) {
        document.body.style.overflow = 'hidden';
    }
    else {
        document.body.style.overflow = 'auto';
    }
    const handleOutsideClick = (e) => {
        if (onopen && node.current &&
            !node.current.contains(e.target)) {
            return onClose && onClose(e);
        }
    };
    React__default.useEffect(() => {
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [onClose]);
    return (React__default.createElement(PopoverEle$1, Object.assign({ ref: node }, props, { open: onopen ? onopen : false, transform: onopen && rect }), children));
};
// this is a default Props of the component
Popover.defaultProps = {
    children: "Popover",
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    horizontal: 'left',
    vertical: 'bottom',
};

const PopoverProps = {
  children: '',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  horizontal: ['left', 'right', 'center'],
  vertical: ['bottom', 'top'],
};

const Row$3 = styled.div `
    display: flex;
    align-items: center;
    ${(props) => props &&
    css `
      ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
const Checkbox$1 = styled.div `
    border: 1px solid #6F6F6F;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    border-radius: 3px;
    cursor: pointer;
    user-select: none;
    ${(props) => props &&
    css `
      ${(props) => {
        return `
            font-size:${props.checkboxTickSize}px;
            color:${props.checkboxTickColor};
            width: ${props.checkboxSize}px;
            height: ${props.checkboxSize}px;
            border-color:${props.activeCheckboxBorderColor};
            background-color:${props.activeCheckboxBackgroundColor}
          `;
    }}
    `}
`;
const Text$1 = styled.p `
    margin:0px 0px 0px 10px;
    ${(props) => props &&
    css `
      ${(props) => {
        if ((props === null || props === void 0 ? void 0 : props.fontSize) === "small") {
            return `
            font-size:16px;
          `;
        }
        else if ((props === null || props === void 0 ? void 0 : props.fontSize) === "medium") {
            return `
            font-size:20px;
          `;
        }
        else if ((props === null || props === void 0 ? void 0 : props.fontSize) === "large") {
            return `
            font-size:25px;
          `;
        }
    }}
      ${(props) => {
        if (props === null || props === void 0 ? void 0 : props.fontColor) {
            return `
            color:${props.fontColor};
          `;
        }
    }}
    `}
`;

const TermsAndConditions = (props) => {
    var _a;
    const [active, setActive] = React__default.useState((_a = props === null || props === void 0 ? void 0 : props.value) !== null && _a !== void 0 ? _a : false);
    const handleChange = () => {
        setActive(!active);
        (props === null || props === void 0 ? void 0 : props.onChange) && props.onChange(!active);
    };
    const giveMeBorderColor = () => {
        if (active) {
            return props.activeCheckboxBorderColor;
        }
    };
    React__default.useEffect(() => {
        var _a;
        setActive((_a = props === null || props === void 0 ? void 0 : props.value) !== null && _a !== void 0 ? _a : false);
    }, [props === null || props === void 0 ? void 0 : props.value]);
    return (React__default.createElement(Row$3, { id: props === null || props === void 0 ? void 0 : props.id, className: props === null || props === void 0 ? void 0 : props.className, name: props === null || props === void 0 ? void 0 : props.name, inLineStyles: props.inLineStyles },
        React__default.createElement(Checkbox$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_box_div', onClick: () => !(props === null || props === void 0 ? void 0 : props.disabled) && handleChange(), activeCheckboxBorderColor: giveMeBorderColor(), checkboxTickSize: props.checkboxTickSize, checkboxTickColor: props.checkboxTickColor, activeCheckboxBackgroundColor: props.activeCheckboxBackgroundColor, checkboxSize: props.checkboxSize, className: "termsConditionsCheckbox" }, active ? '✓' : ''),
        React__default.createElement(Text$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_p', className: "termsConditionsLabel", fontSize: props === null || props === void 0 ? void 0 : props.fontSize, fontColor: props === null || props === void 0 ? void 0 : props.fontColor }, props === null || props === void 0 ? void 0 : props.lable)));
};
TermsAndConditions.defaultProps = {
    activeCheckboxBorderColor: '#0071F2',
    checkboxTickSize: 12,
    checkboxTickColor: '#0071F2',
    checkboxSize: 20,
    lable: 'Label',
    value: false,
    fontSize: 'small',
    fontColor: "#000",
    disabled: false
};

const TermsAndConditionsProps = {
  activeCheckboxBorderColor: '#000',
  checkboxTickSize: 0,
  checkboxTickColor: '#000',
  checkboxSize: 0,
  lable: '',
  value: false,
  fontSize: ['small', 'medium', 'large'],
  fontColor: '#000',
};

styled.ul `margin-top: 4px;`;
const Wrapper$2 = styled.div `
position: relative;
`;
const SearchIcon = styled.div `
position: absolute;
top: 50%;
transform: translateY(-50%);
z-index: 1;
cursor: pointer;
right: 10px;
display: flex;
&svg{
    fill:#6F6F6F;
}
`;
const Input$3 = styled.input `
width: 100%;
padding: 10px;
border-radius: 4px;
border: 1px solid #E0E0E0;
&:focus{
    outline: none;
}
${(props) => props &&
    css `
    ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
styled.div `
position: relative;
& .nodata{
  display:flex;
  align-items:center;
  justify-content:justify-content;
}
`;
const DropDownWrapper = styled.div `
    position: absolute;
    background-color: #fff;
    width: 100%;
    z-index: 1;
    max-height: 250px;
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    margin-top: 10px;
    ${(props) => {
    if (props.elevation === '1') {
        return `
        box-shadow:3px 10px 16px #0000000f;
            `;
    }
    else if (props.elevation === '2') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.15), 
        0 2px 2px rgba(0,0,0,0.15), 
        0 4px 4px rgba(0,0,0,0.15), 
        0 8px 8px rgba(0,0,0,0.15);
        `;
    }
    else if (props.elevation === '3') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
              0 2px 2px rgba(0,0,0,0.12), 
              0 4px 4px rgba(0,0,0,0.12), 
              0 8px 8px rgba(0,0,0,0.12),
              0 16px 16px rgba(0,0,0,0.12);
        `;
    }
    else if (props.elevation === '4') {
        return `
        box-shadow: 0 1px 1px rgba(0,0,0,0.11), 
              0 2px 2px rgba(0,0,0,0.11), 
              0 4px 4px rgba(0,0,0,0.11), 
              0 8px 8px rgba(0,0,0,0.11), 
              0 16px 16px rgba(0,0,0,0.11), 
              0 32px 32px rgba(0,0,0,0.11);
        `;
    }
    else {
        return `
        box-shadow:none;
        `;
    }
}}
`;
const DropDownListWrapper = styled.div `
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px;
    user-select: none;
    &:hover{
        background-color: #e8e8e8;
    }
`;
const DropDownList = styled.p `
margin: 0px 0px 0px 10px;
color:#000;
${(props) => props &&
    css `
      ${(props) => {
        if (props.activeColor)
            return `
            color:${props.activeColor};
          `;
    }}
      ${(props) => {
        if (props.fontSize)
            return `
            font-size:${props.fontSize}px;
          `;
    }}
    `}
`;
const Button$1 = styled.button `
    margin: 10px;
    background: #0071F2;
    color: #fff;
    border: 1px solid #0071F2;
    min-width: 100px;
    padding: 7px;
    border-radius: 4px;
    cursor: pointer;
`;
const ButtonWrapper = styled.div `
width:100%;
display: flex;
justify-content: center;
`;
const Checkbox = styled.div `
    border: 1px solid #6F6F6F;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    border-radius: 3px;
    cursor: pointer;
    user-select: none;
    ${(props) => props &&
    css `
      ${(props) => {
        return `
            
            font-size:${props.checkboxTickSize}px;
            color:${props.activeColor};
            width: ${props.checkboxSize}px;
            height: ${props.checkboxSize}px;
            border-color:${props.activeColor};
          `;
    }}
    `}
`;
const Row$2 = styled.div `
display: flex;
align-items: center;
flex-wrap: wrap;
`;
const SelectionData = styled.div `
border: 1px solid;
/* color: #0071F2; */
margin: 10px 10px 0px 0px;
display: flex;
align-items: center;
padding: 1px 10px;
border-radius: 4px;
& svg{
    width: 20px;
    height: 20px;
    margin-left: 10px;
    /* fill: #0071F2; */
    cursor: pointer;
}

${(props) => props &&
    css `
      ${(props) => {
        return `
            border-color:${props.activeColor};
            color:${props.activeColor};
            & svg{
                fill:${props.activeColor}
            }
          `;
    }}

    ${(props) => {
        if (props.fontSize === "small") {
            return `
            font-size:16px;
          `;
        }
        else if (props.fontSize === "medium") {
            return `
            font-size:20px;
          `;
        }
        else if (props.fontSize === "large") {
            return `
            font-size:25px;
          `;
        }
    }}

    `}
`;

const MultipleSelect = (props) => {
    var _a, _b;
    const dropDownRef = React__default.useRef(null);
    const [value, setValue] = React__default.useState((_a = props === null || props === void 0 ? void 0 : props.value) !== null && _a !== void 0 ? _a : '');
    const [selectedData, setSelectedData] = React__default.useState([]);
    const [addData, setAddData] = React__default.useState([]);
    const [suggestionList, setSuggestionList] = React__default.useState((_b = props === null || props === void 0 ? void 0 : props.options) !== null && _b !== void 0 ? _b : []);
    const [open, setOpen] = React__default.useState(false);
    React__default.useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
    const handleClick = (e) => {
        var _a;
        if ((_a = dropDownRef === null || dropDownRef === void 0 ? void 0 : dropDownRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            // inside click
            return;
        }
        // outside click 
        setOpen(false);
    };
    React__default.useEffect(() => {
        if (open) {
            setSelectedData(addData);
        }
    }, [open]);
    const handleChange = (e) => {
        setValue(e.target.value);
        const filteredList = (props === null || props === void 0 ? void 0 : props.options) && (props === null || props === void 0 ? void 0 : props.options.filter((l) => l.label.toLowerCase().includes(e.target.value.toLowerCase())));
        setSuggestionList(filteredList);
        if (e.target.value.length >= 3) {
            setOpen(true);
        }
        else {
            setOpen(false);
        }
    };
    const handleCheck = (item) => {
        props.options && props.options.map((data) => {
            if (data.value === item.value) {
                if (selectedData.find((l) => l.value === item.value) === undefined) {
                    setSelectedData([...selectedData, Object.assign({}, data)]);
                }
                else {
                    const filteredData = selectedData.filter((l) => l.value != item.value);
                    setSelectedData(filteredData);
                }
            }
        });
    };
    const add = () => {
        setAddData(selectedData);
        setOpen(false);
        setValue('');
        props.onChange && props.onChange(selectedData);
    };
    const removeItems = (data) => {
        const filteredData = addData.filter((l) => l.value != data.value);
        setAddData(filteredData);
        props.onChange && props.onChange(filteredData);
    };
    // console.log(selectedData,'selected data')
    // console.log(addData,'add data')
    // console.log(suggestionList)
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Wrapper$2, { id: props === null || props === void 0 ? void 0 : props.id, name: props === null || props === void 0 ? void 0 : props.name, className: props === null || props === void 0 ? void 0 : props.className },
            React__default.createElement(Input$3, { value: value, onChange: (e) => handleChange(e), onFocus: () => value.length >= 3 && setOpen(true), inLineStyles: props.inLineStyles }),
            React__default.createElement(SearchIcon, null,
                React__default.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "search", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                    React__default.createElement("path", { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" }))),
            open &&
                React__default.createElement(DropDownWrapper, { ref: dropDownRef, elevation: props.elevation },
                    suggestionList && suggestionList.map((l) => {
                        return (React__default.createElement(DropDownListWrapper, { onClick: () => handleCheck(l) },
                            React__default.createElement(Checkbox, { activeColor: selectedData && selectedData.find((_) => _.value === l.value) != undefined && props.activeColor, 
                                // checkboxTickColor={props.checkboxTickColor}
                                checkboxTickSize: props.checkboxTickSize, checkboxSize: props.checkboxSize }, selectedData && selectedData.find((_) => _.value === l.value) != undefined ? "✓" : ""),
                            React__default.createElement(DropDownList, { key: l.value, activeColor: selectedData && selectedData.find((_) => _.value === l.value) != undefined ? props.activeColor : props.fontColor, fontSize: props.fontSize }, l.label)));
                    }),
                    React__default.createElement(ButtonWrapper, null,
                        React__default.createElement(Button$1, { onClick: add }, "Add")))),
        React__default.createElement(Row$2, null, addData && addData.map((_) => {
            return (React__default.createElement(SelectionData, { activeColor: props.activeColor, fontSize: props.fontSize },
                _.label,
                React__default.createElement("svg", { onClick: () => removeItems(_), className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                    React__default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }))));
        }))));
};
MultipleSelect.defaultProps = {
    options: [],
    activeColor: '#0071F2',
    checkboxTickSize: 12,
    checkboxSize: 20,
    elevation: "1",
    fontSize: 'small',
    fontColor: '#000',
};

const MultipleSelectProps = {
  options: [],
  activeColor: '#000',
  checkboxTickSize: 0,
  checkboxSize: 0,
  elevation: ['0', '1', '2', '3', '4'],
  fontSize: ['small', 'medium', 'large'],
  fontColor: '#000',
};

const OverlayCom = styled.div `
top: 0;
left: 0;
right: 0;
bottom: 0;
display: flex;
position: fixed;
z-index: 1201;
${(props) => props &&
    css `
${(props) => {
        if (props.open) {
            return ` 
visibility: visible;
`;
        }
        else {
            return `
visibility: hidden;
`;
        }
    }}
            ${(props) => {
        if (props.anchorOrigin.vertical === 'center' && props.anchorOrigin.horizontal === 'center') {
            return ` 
                    align-items: center;
                    justify-content: center;`;
        }
        else if (props.anchorOrigin.vertical === 'bottom' && props.anchorOrigin.horizontal === 'left') {
            return ` 
                    justify-content: left;
                    align-items: flex-end;`;
        }
        else if (props.anchorOrigin.vertical === 'bottom' && props.anchorOrigin.horizontal === 'right') {
            return ` 
                    justify-content: flex-end;
                    align-items: flex-end;`;
        }
        else if (props.anchorOrigin.vertical === 'bottom' && props.anchorOrigin.horizontal === 'center') {
            return ` 
                    justify-content: center;
                    align-items: flex-end;`;
        }
        else if (props.anchorOrigin.vertical === 'top' && props.anchorOrigin.horizontal === 'center') {
            return ` 
                    justify-content: center;
                    align-items: flex-start;`;
        }
        else if (props.anchorOrigin.vertical === 'top' && props.anchorOrigin.horizontal === 'left') {
            return ` 
                    justify-content: flex-start;
                    align-items: flex-start;`;
        }
        else if (props.anchorOrigin.vertical === 'top' && props.anchorOrigin.horizontal === 'right') {
            return ` 
                    justify-content: flex-end;
                    align-items: flex-start;`;
        }
    }}
            background:${props.backgroundColor};
            ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;

// This is a Overlay component
const Overlay = (props) => {
    /* this is a props variables */
    const { onClose, children } = props;
    return (React__default.createElement(OverlayCom, Object.assign({}, props, { onClick: (e) => onClose && onClose(e) }), children && children));
};
// this is a default Props of the component
Overlay.defaultProps = {
    children: "Overlay",
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    anchorOrigin: {
        vertical: 'center',
        horizontal: 'center',
    },
    horizontal: 'center',
    vertical: 'bottom',
};

const OverlayProps = {
  children: '',
  backgroundColor: '#000',
  anchorOrigin: {
    vertical: 'center',
    horizontal: 'center',
  },
  horizontal: ['left', 'right', 'center'],
  vertical: ['bottom', 'top', 'center'],
};

const Textarea = styled.textarea `
outline: none;
width: 100%;
font-size: 14px;
box-sizing: border-box;
cursor: revert;
${props => props && css `
${(props) => {
    if (props.elevation === '1') {
        return `
box-shadow: 0 3px 3px rgba(0,0,0,0.2);
`;
    }
    else if (props.elevation === '2') {
        return `
box-shadow: 0 1px 1px rgba(0,0,0,0.15), 
0 2px 2px rgba(0,0,0,0.15), 
0 4px 4px rgba(0,0,0,0.15), 
0 8px 8px rgba(0,0,0,0.15);
`;
    }
    else if (props.elevation === '3') {
        return `
box-shadow: 0 1px 1px rgba(0,0,0,0.12), 
  0 2px 2px rgba(0,0,0,0.12), 
  0 4px 4px rgba(0,0,0,0.12), 
  0 8px 8px rgba(0,0,0,0.12),
  0 16px 16px rgba(0,0,0,0.12);
`;
    }
    else if (props.elevation === '4') {
        return `
box-shadow: 0 1px 1px rgba(0,0,0,0.11), 
  0 2px 2px rgba(0,0,0,0.11), 
  0 4px 4px rgba(0,0,0,0.11), 
  0 8px 8px rgba(0,0,0,0.11), 
0 16px 16px rgba(0,0,0,0.11), 
0 32px 32px rgba(0,0,0,0.11);
`;
    }
    else {
        return `
box-shadow:none;
`;
    }
}}  
${(props) => {
    if (props.maxRows === '1') {
        return `
                    height:18px;
                `;
    }
    else if (props.maxRows === '2') {
        return `
                    height:32px;
                `;
    }
    else if (props.maxRows === '3') {
        return `
                    height:42px;
                `;
    }
    else if (props.maxRows === '4') {
        return `
                    height:55px;
                `;
    }
    else if (props.maxRows === '5') {
        return `
                    height:66px;
                `;
    }
    else {
        return `
                height:100px;
            `;
    }
}}
${(props) => {
    if (!props.disabled && !props.error && props.variant === 'outlined') {
        return `
border-radius: 4px;
background-color:transparent;
border: 1px solid ${props.borderColor};
&:hover{
    border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
}
&:focus{
    border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
}}
&::placeholder {
color: #9b9b9b;`;
    }
    else if (!props.disabled && props.error && props.variant === 'outlined') {
        return `
border-radius: 4px;
background-color:transparent;
border: 1px solid ${(props.helperTextType === "error" && 'red') ||
            (props.helperTextType === "warring" && 'yellow') ||
            (props.helperTextType === "success" && 'green')};
`;
    }
    else if (!props.disabled && !props.error && props.variant === 'standard') {
        return `
border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.borderColor};
border-right:unset;
border-radius: 0px; 
border-top: 0px;
border-left:unset;

&:hover{
    border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
border-right:unset;
border-radius: 0px;
border-top: 0px; 
border-left:unset;
}
&:focus{
    border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
border-right:unset;
border-radius: 0px;
border-top: 0px;
border-left:unset;
}

&::placeholder {
color: #9b9b9b;
}
`;
    }
    else if (!props.disabled && props.error && props.variant === 'standard') {
        return `
border-bottom: 1px solid red;
border-right:unset;
border-radius: 0px;
border-top: 0px;
border-left:unset;
border-bottom: 1px solid ${(props.helperTextType === "error" && 'red') ||
            (props.helperTextType === "warring" && 'yellow') ||
            (props.helperTextType === "success" && 'green')};
`;
    }
    else if (props.variant === "none") {
        return `
border:0;
&:focus{
border:0;
outline: none;
}
`;
    }
}}
 ${props.inLineStyles && { ...props.inLineStyles }}
`}
`;
const HelperText = styled.p `
margin: 0;
padding: 0px 4px;
font-size: 12px;
${props => props && css `
${(props) => {
    if (props.helperTextType === "error") {
        return `
color:red;
`;
    }
    else if (props.helperTextType === "warring") {
        return `
color:yellow;
`;
    }
    else if (props.helperTextType === "success") {
        return `
color:green;
`;
    }
}}
        ${props.helperTextStyle && { ...props.helperTextStyle }}
        `}
`;
const TextField = styled.div `
display: flex;
flex-flow: wrap;
cursor: revert;
position: relative;
width: 100%;
${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`;
const Label$2 = styled.p `
font-size:14px;
font-weight: 500;
margin:0;
${props => props && css `
${props => props.labelStyle ? { ...props.labelStyle } : ''}
`}
`;
const Star$1 = styled.span `
color:red;
margin-left: 5px;
`;

// This is a TextArea component
const TextArea = (props) => {
    /* this is a props variables */
    const { inLineStyles, value, className, id, label, isRequired, labelStyle, required } = props;
    const handleChange = (e) => {
        var _a, _b;
        if ((props === null || props === void 0 ? void 0 : props.maxLength) && ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) <= (props === null || props === void 0 ? void 0 : props.maxLength)) {
            (props === null || props === void 0 ? void 0 : props.onChange) && props.onChange(e);
        }
    };
    return (React.createElement(React.Fragment, null,
        label &&
            React.createElement(Label$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_title_p', labelStyle: labelStyle && labelStyle },
                label,
                (required || isRequired) &&
                    React.createElement(Star$1, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_span' }, "*")),
        React.createElement(TextField, { inLineStyles: inLineStyles, id: (props === null || props === void 0 ? void 0 : props.id) + '_div', className: className },
            React.createElement(Textarea, Object.assign({ id: (props === null || props === void 0 ? void 0 : props.id) + '_textarea', className: '', onChange: (e) => handleChange(e), required: required || isRequired }, props), value),
            "   ",
            (props.helperText && props.error) && (React.createElement(HelperText, { helperTextType: props.helperTextType, helperTextStyle: props.helperTextStyle, error: props === null || props === void 0 ? void 0 : props.error, hoverColor: props === null || props === void 0 ? void 0 : props.hoverColor }, props.helperText && props.helperText)))));
};
// this is a default Props of the component
TextArea.defaultProps = {
    variant: "outlined",
    borderColor: '#9b9b9b',
    elevation: "0",
    placeholder: "Text area",
    helperTextType: 'error',
    // rows: 4,
    maxRows: '2',
    label: '',
    isRequired: false,
    required: false,
    maxLength: 4
};

const TextAreaProps = {
  variant: ['standard', 'outlined', 'none'],
  borderColor: '#000',
  elevation: ['0', '1', '2', '3', '4'],
  placeholder: '',
  helperTextType: ['error', 'warring', 'success'],
  rows: 0,
  label: '',
  isRequired: false,
  maxRows: ['0' | '1' | '2' | '3' | '4' | '5'],
  maxLength: 0
};

const Input$2 = styled.input `
  width: 100%;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
  border: none;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${(props) => props &&
    css `
      margin-top: '20px';
      padding: ${props.size !== 'medium' ? '8px 8px' : '11.5px 14px'};
      ${(props) => {
        if (props.width === 'size') {
            return `
      `;
        }
    }}
      ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
const Row$1 = styled.div `
  display: flex;
  align-items: center;
  ${(props) => props &&
    css `
      border-radius: ${props.borderRadius}px;
      border: 1px solid ${props.borderColor};
    `}
  ${(props) => (props.inLineStyles ? { ...props.inLineStyles } : '')}
`;
const Divider$2 = styled.div `
  ${(props) => props &&
    css `
      border: 0.01px solid #cacaca;
      margin-left: 4px;
      height: 20px;
    `}
`;

const DropDownbtn = styled.div `
    padding:0;
    background-color: white;
    border: none;
    outline: none;
    cursor: pointer;
    ${props => props && css `
    
    `}
`;
const DropDown = styled.div `
    position: absolute;
    margin-top:10px;
    max-height: 180px;
    margin-left: -3px;
    overflow: visible;
    width: min-content;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
    z-index: 1;
    background-color: #fff;
`;
const DropDownlist = styled.ul `
    background-color: white;
    margin-top: 0px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    position: relative;
    list-style: none;
    margin-bottom: 0px;
    overflow: overlay;
    ${props => props && css `
    
    `}
`;
const ListDiv = styled.div `
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
        background-color: #e0e0e0;
    }
`;
const Name$2 = styled.p `
    margin:0;
    font-size:15px;
    display: flex;
    align-items: baseline;
`;
const Code = styled.p `
    margin:0;
    font-size:15px;
    color:#6b6b6b;
`;
styled.input `
font-size: 14px;
color: #000;
font-weight: 400 !important;
`;

const inputListen$1 = (e, addFun, masterSearch) => {
    e.target;
    // eslint-disable-next-line 
    // let splitvalue = value.split(' ');
    if ((e.keyCode === 51 && e.key === '#') || e.keyCode === 16 || e.target) {
        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
            e.preventDefault();
            listView$1(e, addFun, masterSearch);
        } else {
            cursorGet$1(e);
        }
    } else {
        if (masterSearch === undefined) {
            document.getElementsByClassName('listDiv')[0].setAttribute('style', `display : none`);
        }
    }
};
const classnameadd$1 = (index) => {
    // document.getElementById("search_check_filter").children[index].className += " start";
    document.getElementById("search_check_filter").getElementsByTagName('li')[index].className += ' qdm-select-options';
};
function listView$1(e, addFun, masterSearch) {
    let scrollHeight = 0;
    let listCount = 0;
    let setHeight = 0;
    let currentHeight = 0;
    // try{
    if (document.getElementsByClassName("listDiv") && document.getElementsByClassName("listDiv")[0]) {
        scrollHeight = document.getElementsByClassName("listDiv")[0].scrollHeight - document.getElementsByClassName("listDiv")[0].clientHeight;
        listCount = document.getElementsByClassName("listDiv")[0].children[0].childElementCount;
        setHeight = scrollHeight / listCount;
        currentHeight = document.getElementsByClassName("listDiv")[0].scrollTop;
    }
    // }catch(e){
    // }
    // eslint-disable-next-line 
    switch (e.keyCode) {
        case 38: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            if (start && start.previousElementSibling !== null) {
                if (start.previousElementSibling.tagName === 'LI') {
                    start.classList.remove('qdm-select-options');
                    start.classList.add('actives');
                    start.previousElementSibling.classList.remove('actives');
                    start.previousElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.previousElementSibling.previousElementSibling !== null) {
                        start.classList.remove('qdm-select-options');
                        start.classList.add('actives');
                        start.previousElementSibling.previousElementSibling.classList.remove('actives');
                        start.previousElementSibling.previousElementSibling.classList.add('qdm-select-options');
                    }
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow$1(ul, false);
            }
            let heightList = currentHeight - setHeight;
            document.getElementsByClassName("listDiv")[0].scrollTop = heightList <= 0 ? 0 : heightList;
            break;
        }
        case 40: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            var startList = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options');
            if (start && start.nextElementSibling !== null) {
                start.classList.remove('qdm-select-options');
                start.classList.add('actives');
                if (start.nextElementSibling.tagName === 'LI') {
                    start.nextElementSibling.classList.remove('actives');
                    start.nextElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.nextElementSibling.nextElementSibling !== null) {
                        start.nextElementSibling.nextElementSibling.classList.remove('actives');
                        start.nextElementSibling.nextElementSibling.classList.add('qdm-select-options');
                    }
                }
            } else {
                // if(startList.length > 0){
                //     startList[startList.length-1].classList.remove('qdm-select-options');
                // }
                if (startList.length === 0) {
                    classnameadd$1(0);
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow$1(ul, true);
            }
            document.getElementsByClassName("listDiv")[0].scrollTop = currentHeight + setHeight;
            break;
        }
        // case 13: {
        //     addFun(e);
        //     break;
        // }
    }
}
function cursorGet$1(e, isreturn) {
    const input = e.target;
    // eslint-disable-next-line 
    const { offsetHeight, offsetLeft, offsetTop, offsetWidth, scrollLeft, scrollTop, selectionStart, value } = input;
    const { paddingRight, lineHeight } = getComputedStyle(input);
    const { x, y } = getCursorXY$1(input, selectionStart);
    const newLeft = Math.min(
        x - scrollLeft,
        (offsetLeft + offsetWidth) - parseInt(paddingRight, 10)
    );
    let valuecheck = parseInt(lineHeight, 10);
    const newTop = Math.min(
        y - scrollTop,
        (offsetTop + offsetHeight) - (isNaN(valuecheck) !== true ? parseInt(lineHeight, 10) : 0)
    );
    if (isreturn) {
        return {
            left: newLeft - 5,
            top: newTop + 10
        }
    }
    document.getElementsByClassName('listDiv')[0].setAttribute('style', `left: ${newLeft}px; top: ${newTop + 10}px;`);
}
const getCursorXY$1 = (input, selectionPoint) => {
    const {
        offsetLeft: inputX,
        offsetTop: inputY,
    } = input;
    const div = document.createElement('div');
    const copyStyle = getComputedStyle(input);
    for (const prop of copyStyle) {
        div.style[prop] = copyStyle[prop];
    }
    const swap = '.';
    const inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
    const textContent = inputValue.substr(0, selectionPoint);
    div.textContent = textContent;
    if (input.tagName === 'TEXTAREA') div.style.height = 'auto';
    if (input.tagName === 'INPUT') div.style.width = 'auto';
    const span = document.createElement('span');
    span.textContent = inputValue.substr(selectionPoint) || '.';
    div.appendChild(span);
    document.body.appendChild(div);
    // eslint-disable-next-line 
    const { offsetLeft: spanX, offsetTop: spanY } = span;
    document.body.removeChild(div);
    return {
        // x: inputX + spanX,
        x: inputX,
        //   x: inputX + Math.abs(spanX - input.offsetWidth),
        // y: inputY + spanY,
        y: inputY + Math.abs(spanY - input.offsetHeight),
    }
};
const scrollOverFlow$1 = (ul, top) => {
    let start = document.getElementsByClassName('qdm-select-options')[0];
    if (!start) {
        return false;
    }
    let bounding = start.getBoundingClientRect();
    if (top) {
        if (ul.clientHeight < bounding.bottom) {
            ul.scrollTop = ul.scrollTop + start.clientHeight;
        }
    } else {
        let ulBounding = ul.getBoundingClientRect();
        if (ulBounding.top > (bounding.top - 30)) {
            ul.scrollTop = ul.scrollTop - start.clientHeight;
        }
    }
};

const Dropdown = (props) => {
    var _a;
    const { dropdown, placeholder = 'Select', onChange, dropdownData } = props;
    const node = useRef(null);
    const [open, setOpen] = useState(false);
    let dropdownval;
    if (((_a = Object.keys(dropdown)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        dropdownval = {
            callingCodes: dropdown.callingCodes,
            name: dropdown.name,
            altSpellings: dropdown.altSpellings,
            flag: dropdown.flag
        };
    }
    else {
        dropdownval = placeholder;
    }
    var Dataoptions = [
        {
            name: "None",
            altSpellings: "",
            callingCodes: "",
            flag: "",
        },
        {
            name: 'Afghanistan',
            altSpellings: 'AF',
            callingCodes: '93',
            flag: 'https://restcountries.eu/data/afg.svg',
        }
    ];
    const dm = {
        name: "None",
        altSpellings: "",
        callingCodes: "",
        flag: "",
    };
    let dropdownRenderData = dropdownData ? [Object.assign({}, dm), ...dropdownData] : Dataoptions;
    const handlePageChangeByClicking = (e) => {
        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
            onkeydown(e);
        }
    };
    function handleChange(selectedValue) {
        if (onChange && (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.name)) {
            if ((selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.name) === 'None') {
                dropdownval = placeholder;
            }
            setOpen(false);
            return onChange(selectedValue);
        }
    }
    const val = (getClass) => {
        var _a;
        let data = dropdownRenderData === null || dropdownRenderData === void 0 ? void 0 : dropdownRenderData.filter((val) => {
            var _a, _b, _c, _d, _e;
            return (((val === null || val === void 0 ? void 0 : val['name']) && (val === null || val === void 0 ? void 0 : val['name'].toLowerCase())) === ((_e = (_d = (_c = (_b = (_a = getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText) === null || _b === void 0 ? void 0 : _b.replace(/[\n\r]/g, '-')) === null || _c === void 0 ? void 0 : _c.split('-')) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.toLowerCase()));
        });
        if ((_a = getClass === null || getClass === void 0 ? void 0 : getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText) {
            return data === null || data === void 0 ? void 0 : data[0];
        }
    };
    const selectedOption = (e) => {
        var _a, _b;
        debugger;
        let getClass = document.getElementsByClassName('qdm-select-options');
        if ((getClass === null || getClass === void 0 ? void 0 : getClass.length) > 0) {
            if (e.keyCode === 13) {
                if (((_a = val(getClass)) === null || _a === void 0 ? void 0 : _a.name) === 'None') {
                    dropdownval = placeholder;
                    return handleChange(dm);
                }
                else if ((_b = val(getClass)) === null || _b === void 0 ? void 0 : _b.name) {
                    handleChange && handleChange(val(getClass));
                }
            }
        }
    };
    const onkeydown = (e) => {
        inputListen$1(e, selectedOption(e), 1);
    };
    React__default.useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
    function handleClick(e) {
        var _a;
        // debugger
        if ((_a = node === null || node === void 0 ? void 0 : node.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            // inside click
            return;
        }
        // outside click
        setOpen(false);
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { ref: node, id: (props === null || props === void 0 ? void 0 : props.id) + '_parent_div', className: "dropdown" },
            React__default.createElement(DropDownbtn
            // ref={inputRef}
            , { 
                // ref={inputRef}
                ref: node, id: (props === null || props === void 0 ? void 0 : props.id) + '_button', className: "dropdown-toggler", onClick: () => setOpen(!open) },
                React__default.createElement("input", { type: 'text', style: {
                        border: 'none',
                        background: 'transparent',
                        caretColor: 'transparent',
                        outline: 0, cursor: 'pointer',
                        position: 'absolute',
                        width: '63px'
                    }, onKeyDown: handlePageChangeByClicking, autoFocus: true, value: '' }),
                (typeof (dropdownval) == "object") && (dropdownval === null || dropdownval === void 0 ? void 0 : dropdownval.name) && ((dropdownval === null || dropdownval === void 0 ? void 0 : dropdownval.name) !== 'None') ?
                    (React__default.createElement("div", { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div', style: {
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: 14,
                        } },
                        dropdownval.flag && React__default.createElement("img", { id: (props === null || props === void 0 ? void 0 : props.id) + '_image', src: dropdownval.flag, alt: dropdownval.altSpellings, style: { width: 18, height: 12, marginRight: 6, marginLeft: 6 } }),
                        dropdownval.callingCodes && React__default.createElement(Name$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_p', className: "callingCodes" },
                            "+",
                            dropdownval.callingCodes),
                        React__default.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_svg', version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 255 255", style: { width: 24, height: 8 } },
                            React__default.createElement("g", null,
                                React__default.createElement("g", { id: "arrow-drop-down" },
                                    React__default.createElement("polygon", { points: "0,63.75 127.5,191.25 255,63.75" })))))) : (React__default.createElement(Name$2, { className: "callingCodes", style: {
                        marginLeft: 6,
                    } },
                    'Select',
                    React__default.createElement("svg", { version: "1.1", id: "Capa_2", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 255 255", style: { width: 20, height: 8 } },
                        React__default.createElement("g", null,
                            React__default.createElement("g", { id: "arrow-drop-down" },
                                React__default.createElement("polygon", { points: "0,63.75 127.5,191.25 255,63.75" }))))))),
            open && (React__default.createElement(DropDown, { className: 'listDiv' },
                React__default.createElement(DropDownlist, { className: "qdm-select-div1", id: 'search_check_filter' }, dropdownRenderData.map((opt, i) => {
                    return (
                    // dropdown-menu-item 
                    React__default.createElement("li", { key: i, className: "actives", onMouseDown: () => handleChange(opt) },
                        React__default.createElement(ListDiv, null,
                            opt.flag && React__default.createElement("img", { src: opt.flag, alt: opt.altSpellings, style: { width: 25, height: 20, marginRight: 16 } }),
                            React__default.createElement(Name$2, null, opt.name),
                            "\u00A0",
                            opt.callingCodes && React__default.createElement(Code, null,
                                "+",
                                opt.callingCodes))));
                })))))));
};
Dropdown.defaultProps = {
    type: "number",
    value: "",
    label: "Mobile Number",
    borderColor: "#a7a7a7",
    borderRadius: 6,
};

// import { MultiSelect } from './MultiSelect'
const MobileNumberWithCode = (props) => {
    var _a, _b;
    /* this is a props variables */
    const node = React.useRef(null);
    const { dropdownData, onChange, country, selectData } = props;
    const [getdata, setgetdata] = React.useState((_a = props === null || props === void 0 ? void 0 : props.dropdown) !== null && _a !== void 0 ? _a : {});
    const [mobileval, setmobileval] = React.useState((_b = props === null || props === void 0 ? void 0 : props.value) !== null && _b !== void 0 ? _b : '');
    // const [getdata, setgetdata] = React.useState(props?.dropdown ?? []);
    // React.useEffect(() => {
    //     debugger
    //     if (!props?.value) {
    //     }
    // }, [props?.value])
    React.useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        setgetdata({
            name: (_b = (_a = props === null || props === void 0 ? void 0 : props.dropdown) === null || _a === void 0 ? void 0 : _a.countryData) === null || _b === void 0 ? void 0 : _b.name,
            altSpellings: (_d = (_c = props === null || props === void 0 ? void 0 : props.dropdown) === null || _c === void 0 ? void 0 : _c.countryData) === null || _d === void 0 ? void 0 : _d.altSpellings,
            callingCodes: (_f = (_e = props === null || props === void 0 ? void 0 : props.dropdown) === null || _e === void 0 ? void 0 : _e.countryData) === null || _f === void 0 ? void 0 : _f.callingCodes,
            flag: (_h = (_g = props === null || props === void 0 ? void 0 : props.dropdown) === null || _g === void 0 ? void 0 : _g.countryData) === null || _h === void 0 ? void 0 : _h.flag,
        });
        // setgetdata(props?.dropdown ?? []);
    }, [props === null || props === void 0 ? void 0 : props.dropdown]);
    React.useEffect(() => {
        var _a;
        setmobileval((_a = props === null || props === void 0 ? void 0 : props.value) !== null && _a !== void 0 ? _a : '');
        // setValueFun(props?.dropdown ?? {});
    }, [props === null || props === void 0 ? void 0 : props.value]);
    React.useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
    function handleClick(e) {
        var _a;
        if ((_a = node === null || node === void 0 ? void 0 : node.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            // inside click
            return;
        }
    }
    const setValueFun = (data) => {
        setgetdata(data);
        onChange &&
            onChange({
                mobileNo: mobileval,
                countryData: data,
            });
    };
    const handleChange = (e) => {
        var _a, _b, _c, _d;
        e.stopPropagation();
        if ((props === null || props === void 0 ? void 0 : props.maxLength) && ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) <= (props === null || props === void 0 ? void 0 : props.maxLength) || (props === null || props === void 0 ? void 0 : props.minLength) && ((_d = (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) <= (props === null || props === void 0 ? void 0 : props.minLength)) {
            onChange &&
                onChange({
                    mobileNo: e.target.value,
                    countryData: getdata,
                });
            setmobileval(e.target.value);
        }
    };
    const values = (val) => {
        const name = selectData.filter((l) => l === val.name && val);
        return name[0];
    };
    const filterdata = () => {
        const dat = dropdownData === null || dropdownData === void 0 ? void 0 : dropdownData.filter((p) => {
            return values(p);
        });
        return dat;
    };
    return (React.createElement(Row$1, Object.assign({}, props),
        "\u00A0",
        React.createElement(Dropdown, Object.assign({}, props, { placeholder: "Select", dropdown: getdata, 
            // dropdownData={dropdownData}
            dropdownData: (selectData) ? filterdata() : dropdownData, 
            // dropdownData={dropdownData}
            onChange: (data) => setValueFun(data) })),
        React.createElement(Divider$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_divider_div', className: "mobileCountryDivider" }),
        React.createElement(Input$2, { id: (props === null || props === void 0 ? void 0 : props.id) + '_input', value: mobileval.replace(/[^0-9]/g, ''), width: props === null || props === void 0 ? void 0 : props.width, type: "number", placeholder: props === null || props === void 0 ? void 0 : props.label, onChange: (e) => {
                handleChange(e);
            }, 
            // onKeyDown={(evt) => allowNumbers(evt)}
            onKeyDown: (evt) => evt.key === 'e' && evt.preventDefault() }),
        "\u00A0\u00A0"));
};
// this is a default Props of the component
MobileNumberWithCode.defaultProps = {
    type: 'number',
    label: 'Mobile Number',
    borderColor: '#CACACA',
    borderRadius: 6,
    dropdown: {},
    // selectData:
    //   [
    //     'India',
    //   ],
    dropdownData: [
        {
            name: 'India',
            altSpellings: 'IN',
            callingCodes: '91',
            flag: 'https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg',
        },
        {
            name: 'Japan',
            altSpellings: 'JA',
            callingCodes: '83',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9e/Flag_of_Japan.svg',
        },
        {
            name: 'Australia',
            altSpellings: 'AS',
            callingCodes: '61',
            flag: 'https://upload.wikimedia.org/wikipedia/en/b/b9/Flag_of_Australia.svg',
        },
    ],
    disabled: false,
    size: 'small',
    maxLength: 10,
    country: []
};

const MobileNumberWithCodeProps = {
  type: '',
  label: '',
  borderColor: '#000',
  borderRadius: 0,
  dropdown: {},
  dropdownData: [],
  disabled: false,
  size: ['medium', 'small'],
  maxLength: 0,
  minLength: 0,
  country: ['India', 'Japan', 'Australia']

  // add: []
};

const FormElement = styled.form `
  ${props => props && css `
  ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
 `}
`;

const Form = (props) => {
    return React__default.createElement(FormElement, Object.assign({}, props), (props === null || props === void 0 ? void 0 : props.children) && (props === null || props === void 0 ? void 0 : props.children));
};
Form.defaultProps = {};

const FormProps = {};

const Input$1 = styled.input `
display: none;
`;
const StyledInput = styled.label `
    box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
    cursor: pointer;
    padding: 5px 15px;
    border-radius: 4px;
    width:max-content;
    display:flex;
    align-items:center;
    justify-content:center;
    ${props => props && css `

    ${(props) => {
    if (props.variant === "avatar") {
        return `
                    flex-direction:column;
                    width: 128px;
                    height: 128px;
                `;
    }
}}

    ${(props) => {
    if (props.iconColor) {
        return `
                    & svg{
                        fill:${props.iconColor};
                    }
                `;
    }
}}

    ${(props) => {
    if (props.iconSize) {
        return `
                    & svg,img{
                        width:${props.iconSize}px;
                        height:${props.iconSize}px;
                    }
                `;
    }
}}

        ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
const Label$1 = styled.p `
margin: 0;
${props => props && css `

${(props) => {
    if (props.labelColor) {
        return `
                color:${props.labelColor};
            `;
    }
}}
${(props) => {
    if (props.labelSize === "small") {
        return `
                font-size:16px;
            `;
    }
    else if (props.labelSize === "medium") {
        return `
                font-size:20px;
            `;
    }
    else if (props.labelSize === "large") {
        return `
                font-size:25px;
            `;
    }
}}

${props => props.labelStyle ? { ...props.labelStyle } : ''}
`}
`;
const Img$2 = styled.img `
width: 20px;
height: auto;
margin-right: 5px;
`;

const Upload = (props) => {
    const imageUploadOnChange = (e) => {
        // console.log(e)
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.onloadend = () => {
                // its return the data
                (props === null || props === void 0 ? void 0 : props.handleChange) && (props === null || props === void 0 ? void 0 : props.handleChange(reader.result, file));
            };
            reader.readAsDataURL(file);
        }
    };
    return (React__default.createElement(StyledInput, { id: (props === null || props === void 0 ? void 0 : props.id) + "_label", variant: props.variant, inLineStyles: props.inLineStyles, iconColor: props.iconColor, iconSize: props.iconSize, className: "uploadWrapper" },
        props.showIcon && ((props === null || props === void 0 ? void 0 : props.imgUrl) ? React__default.createElement(Img$2, { src: props === null || props === void 0 ? void 0 : props.imgUrl, alt: "upload" }) : React__default.createElement("svg", { style: { marginRight: props.variant === "classic" ? 5 : 0, marginTop: props.variant === "avatar" ? 5 : 0, }, viewBox: "64 64 896 896", focusable: "false", "data-icon": "upload", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true" },
            React__default.createElement("path", { d: "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" }))),
        React__default.createElement(Label$1, { id: (props === null || props === void 0 ? void 0 : props.id) + "_p", labelSize: props.labelSize, labelColor: props.labelColor, labelStyle: (props === null || props === void 0 ? void 0 : props.labelStyle) && (props === null || props === void 0 ? void 0 : props.labelStyle) }, props.label),
        React__default.createElement(Input$1, Object.assign({}, props, { type: "file", onChange: (e) => imageUploadOnChange(e) }))));
};
Upload.defaultProps = {
    label: 'Upload',
    variant: 'classic',
    showIcon: true,
    labelSize: 'small',
    labelColor: '#000',
    iconColor: '#000',
    iconSize: 16
};

const UploadProps = {
  label: '',
  variant: ['classic', 'avatar'],
  showIcon: true,
  labelSize: ['small', 'medium', 'large'],
  labelColor: '#000',
  iconColor: '#000',
  iconSize: 0,
};

const Strong = styled.strong `
font-weight: 600;
`;
const Option = styled.option `
  padding:10px;
  border: 1px solid #0000000d;
  &:focus {
    border: 1px solid #0000000d;
  }
  &:focus-visible {
    border: 1px solid #0000000d;
  }
`;
const Select$1 = styled.select `
border-radius: 4px;
box-shadow: 0px 0px 23px -17px #0000004d;
padding: 4px 10px;
outline: none;
&:focus {
  border: 1px solid #0000000d;
}
&:focus-visible {
  border: 1px solid #0000000d;
}
`;
const MonthCalendarEle = styled.div `
border-radius: 5px;
box-shadow: 0px 0px 23px -17px #0000004d;
border: 1px solid #0000000d;
 ${props => props && css `
        ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;
styled.div `
  border: 1px solid lightgrey;
  max-width: 400px;
`;
const Div$1 = styled.div `
font-size: 16px;`;
const Header = styled.div `
  font-size: 18px;
  padding:10px 10px 10px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #0000000d;
  align-items: center;
`;
const Button = styled.div `
  cursor: pointer;
  font-size:14px;
`;
const Body = styled.div `
  padding: 6px;
  display: flex;
  flex-wrap: wrap;
`;
const Day = styled.div `
  width: 14.2%;
  height: 14.2%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
& span{
  width: 40px;
  height: 40px;
  text-align: center;
  padding: 7px;
}
  ${props => props.isToday &&
    css `
& span{
    background: #1890ff;
    color: #fff;
    font-weight: 600;
}
    `}

  ${props => props.isSelected &&
    css `
& span{
      border:1px solid #3296c8;
      border-radius: 50%;
      font-weight: 600;
}
    `}
`;

// This is a MonthCalendar component
const MonthCalendar = (props) => {
    var _a;
    // dates
    const DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // weeks
    const DAYS_OF_THE_WEEK = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    // months
    const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    // state variables
    const [date, setDate] = useState(props.Date);
    const [day, setDay] = useState(date.getDate());
    const [month, setMonth] = useState(date.getMonth());
    const [year, setYear] = useState(date.getFullYear());
    const [startDay, setStartDay] = useState(getStartDayOfMonth(date));
    // end
    useEffect(() => {
        // useEffect date page render
        setDay(date.getDate());
        setMonth(date.getMonth());
        setYear(date.getFullYear());
        setStartDay(getStartDayOfMonth(date));
    }, [date]);
    const handlechooseMonth = (e) => {
        e.stopPropagation();
        const mothFilter = [{
                month: 'JAN',
                num: 1
            },
            { month: 'FEB', num: 2 },
            { month: 'MAR', num: 3 },
            { month: 'APR', num: 4 },
            { month: 'MAY', num: 5 },
            { month: 'JUN', num: 6 },
            { month: 'JUL', num: 7 },
            { month: 'AUG', num: 8 },
            { month: 'SEP', num: 9 },
            { month: 'OCT', num: 10 },
            { month: 'NOV', num: 11 },
            { month: 'DEC', num: 12 }
        ];
        const i = mothFilter.filter(v => {
            if ((v === null || v === void 0 ? void 0 : v.month) === e.target.value) {
                return v;
            }
        });
        setDate(new Date(year, i[0].num - 1, day));
        setDay(day);
        setMonth(i[0].num - 1);
        setYear(year);
        setStartDay(getStartDayOfMonth(new Date(year, i[0].num - 1, day)));
        props.onChange && props.onChange(new Date(year, i[0].num - 1, day));
    };
    const handlechooseYear = (evn) => {
        evn.stopPropagation();
        const e = evn.target.value;
        setDate(new Date(e, month, day));
        setDay(day);
        setMonth(month);
        setYear(e);
        setStartDay(getStartDayOfMonth(new Date(e, month, day)));
        props.onChange && props.onChange(new Date(e, month, day));
    };
    // getStartDayOfMonth
    function getStartDayOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    }
    // end
    // isLeapYear
    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }
    // end
    const days = isLeapYear(date.getFullYear()) ? DAYS_LEAP : DAYS;
    const datess = days[month] + (startDay - 1);
    const handleClick = (year, month, d) => {
        props.onChange && props.onChange(new Date(year, month, d));
        setDate(new Date(year, month, d));
    };
    let YEAR = Array.apply(null, Array((props === null || props === void 0 ? void 0 : props.uptoCurrentYear) ? year + 1 : year + 10)).map((val, idx) => { return val ? val : 0 + idx; });
    return (React.createElement(MonthCalendarEle, Object.assign({}, props),
        React.createElement(Header, null,
            React.createElement(Button, { onClick: () => setDate(new Date(year, month - 1, day)) }, "\u3008"),
            React.createElement(Div$1, { id: props === null || props === void 0 ? void 0 : props.id, className: "select-dropdown" },
                React.createElement(Select$1, { name: "month", id: "month", onChange: (e) => handlechooseMonth(e) }, MONTHS === null || MONTHS === void 0 ? void 0 : MONTHS.map((v) => {
                    return React.createElement(Option, { value: v, selected: MONTHS[month] === v ? true : false }, v);
                }))),
            React.createElement(Div$1, null),
            React.createElement(Div$1, { className: "select-dropdown" },
                React.createElement(Select$1, { name: "month", id: "month", onChange: (e) => handlechooseYear(e) }, (_a = YEAR === null || YEAR === void 0 ? void 0 : YEAR.splice(year - 50, YEAR === null || YEAR === void 0 ? void 0 : YEAR.length)) === null || _a === void 0 ? void 0 : _a.map((v) => {
                    return React.createElement(Option, { id: (props === null || props === void 0 ? void 0 : props.id) + '_option', value: v, selected: year === v ? true : false }, v);
                }))),
            React.createElement(Button, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', onClick: () => setDate(new Date(year, month + 1, day)) }, "\u3009")),
        React.createElement(Body, null,
            DAYS_OF_THE_WEEK.map(d => (React.createElement(Day, { id: props === null || props === void 0 ? void 0 : props.id, key: d },
                React.createElement(Strong, null, d)))),
            [...Array(datess)].map((_, index) => {
                const d = index - (startDay - 2);
                return (React.createElement(Day, { key: index, isToday: d === date.getDate(), isSelected: d === day, onClick: () => handleClick(year, month, d) },
                    React.createElement("span", null, d > 0 ? d : '')));
            }))));
};
// this is a default Props of the component
MonthCalendar.defaultProps = {
    Date: new Date(),
};

const MonthCalendarProps = {
  Date: '',
};

const QueueEle = styled.div `
padding:20px;
${(props) => props &&
    css `
      ${(props) => {
        return `
          background-color:${props.backgroundColor};
          `;
    }}

      ${props.inLineStyles && { ...props.inLineStyles }} 

      `}
`;
const Wrapper$1 = styled.div `
margin-bottom: 15px;
`;
const QueueHeader = styled.div `
display:flex;
align-items:center;
justify-content: space-between;
margin-bottom: 10px;
`;
const HeaderTitle = styled.h5 `
margin:0;
`;
const TokenNumber$1 = styled.div `
border-color: #6F6F6F;
border-radius: 4px;
padding:0px 10px;
color:#fff;
background-color: #6F6F6F;
`;
const Card = styled.div `
box-shadow: 0 1px 1px rgb(0 0 0 / 20%);
border: 1px solid #EDEDED;
transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
background-color: #fff;
border-radius: 6px;
`;
const PreviousNextBody = styled.div `
    display: flex;
    align-items: center;
    margin:12px;
`;
const PreviousNextBodyAvatar = styled.div `
width: 55px;
height: 55px;
border-radius: 6px;
overflow: hidden;
margin-right: 12px;
`;
const Img$1 = styled.img `
max-width: 100%;
height: auto;
`;
const PreviousNextBodyTitleWrapper = styled.div ``;
const PreviousNextBodyName = styled.h5 `
margin: 0px;
margin-bottom: 3px;
`;
const PreviousNextBodyRole = styled.span `
font-size: 13px;
color: #9b9595;
font-weight: 500;
`;
const AttendBody = styled.div `
display: flex;
flex-direction: column;
margin:12px;
align-items: center;
`;
const AttendBodyAvatar = styled.div `
width: 85px;
height: 85px;
border-radius: 6px;
overflow: hidden;
margin-bottom: 10px;
`;
styled.button `
    background-color: #0071F2;
    border-radius: 6px;
    color:'#fff';
`;
const Divider$1 = styled.hr `
width: 100%;
background-color: #F1F1F1;
margin-bottom: 0px;
border: 1px solid #F1F1F1;
`;
const SecondaryButton = styled.div `
   margin: 3px;
   text-align: center;
   & i,img,svg{
       margin-right: 5px;
   }
`;

const Queue = (props) => {
    var _a, _b, _c, _d, _e;
    const { previous, attend, next } = props;
    return (React__default.createElement(QueueEle, { backgroundColor: props === null || props === void 0 ? void 0 : props.backgroundColor, inLineStyles: props === null || props === void 0 ? void 0 : props.inLineStyles },
        previous && Object.keys(previous).length > 0 &&
            React__default.createElement(Wrapper$1, null,
                React__default.createElement(QueueHeader, null,
                    (previous === null || previous === void 0 ? void 0 : previous.title) && React__default.createElement(HeaderTitle, { id: (props === null || props === void 0 ? void 0 : props.id) + (previous === null || previous === void 0 ? void 0 : previous.title) + 'h5' }, previous === null || previous === void 0 ? void 0 : previous.title),
                    (previous === null || previous === void 0 ? void 0 : previous.token) && React__default.createElement(TokenNumber$1, { id: (props === null || props === void 0 ? void 0 : props.id) + (previous === null || previous === void 0 ? void 0 : previous.token) + 'span' }, previous === null || previous === void 0 ? void 0 : previous.token)),
                React__default.createElement(Card, null,
                    React__default.createElement(PreviousNextBody, null,
                        (previous === null || previous === void 0 ? void 0 : previous.profile_pic) &&
                            React__default.createElement(PreviousNextBodyAvatar, { id: (props === null || props === void 0 ? void 0 : props.id) + '_img_div' },
                                React__default.createElement(Img$1, { src: previous === null || previous === void 0 ? void 0 : previous.profile_pic, alt: (_a = previous === null || previous === void 0 ? void 0 : previous.name) !== null && _a !== void 0 ? _a : 'profilePic' })),
                        React__default.createElement(PreviousNextBodyTitleWrapper, null,
                            (previous === null || previous === void 0 ? void 0 : previous.name) && React__default.createElement(PreviousNextBodyName, null, previous === null || previous === void 0 ? void 0 : previous.name),
                            (previous === null || previous === void 0 ? void 0 : previous.role) && React__default.createElement(PreviousNextBodyRole, null, previous === null || previous === void 0 ? void 0 : previous.role))))),
        attend && Object.keys(attend).length > 0 &&
            React__default.createElement(Wrapper$1, null,
                React__default.createElement(QueueHeader, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div' },
                    (attend === null || attend === void 0 ? void 0 : attend.title) && React__default.createElement(HeaderTitle, null, attend === null || attend === void 0 ? void 0 : attend.title),
                    (attend === null || attend === void 0 ? void 0 : attend.token) && React__default.createElement(TokenNumber$1, null, attend === null || attend === void 0 ? void 0 : attend.token)),
                React__default.createElement(Card, null,
                    React__default.createElement(AttendBody, null,
                        (attend === null || attend === void 0 ? void 0 : attend.profile_pic) &&
                            React__default.createElement(AttendBodyAvatar, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div' },
                                React__default.createElement(Img$1, { src: attend === null || attend === void 0 ? void 0 : attend.profile_pic, alt: (_b = attend === null || attend === void 0 ? void 0 : attend.name) !== null && _b !== void 0 ? _b : 'profilePic' })),
                        (attend === null || attend === void 0 ? void 0 : attend.name) && React__default.createElement(PreviousNextBodyName, null, attend === null || attend === void 0 ? void 0 : attend.name),
                        (attend === null || attend === void 0 ? void 0 : attend.role) && React__default.createElement(PreviousNextBodyRole, null, attend === null || attend === void 0 ? void 0 :
                            attend.role,
                            (attend === null || attend === void 0 ? void 0 : attend.isRegister) && ` • ${attend === null || attend === void 0 ? void 0 : attend.isRegister}`),
                        (attend === null || attend === void 0 ? void 0 : attend.primaryButtonName) &&
                            React__default.createElement(Button$4, { type: "button", name: attend === null || attend === void 0 ? void 0 : attend.primaryButtonName, variant: "outlined", size: 14, backgroundColor: "#0071F2", onClick: (_c = attend === null || attend === void 0 ? void 0 : attend.primaryButtonAction) !== null && _c !== void 0 ? _c : null, inLineStyles: {
                                    color: '#e4f0ff',
                                    marginTop: '10px',
                                    width: '100%'
                                } })),
                    React__default.createElement(Divider$1, null),
                    React__default.createElement(SecondaryButton, null, (attend === null || attend === void 0 ? void 0 : attend.secondaryButtonName) &&
                        React__default.createElement(Button$4, { type: "button", name: '', variant: "text", size: 12, onClick: (_d = attend === null || attend === void 0 ? void 0 : attend.secondaryButtonAction) !== null && _d !== void 0 ? _d : null, inLineStyles: {
                                color: '#FAC783',
                                fontWeight: '600'
                            } },
                            (attend === null || attend === void 0 ? void 0 : attend.secondaryButtonIcon) && (attend === null || attend === void 0 ? void 0 : attend.secondaryButtonIcon), attend === null || attend === void 0 ? void 0 :
                            attend.secondaryButtonName)))),
        next && Object.keys(next).length > 0 &&
            React__default.createElement(Wrapper$1, null,
                React__default.createElement(QueueHeader, null,
                    next.title && React__default.createElement(HeaderTitle, null, next === null || next === void 0 ? void 0 : next.title),
                    (next === null || next === void 0 ? void 0 : next.token) && React__default.createElement(TokenNumber$1, null, next === null || next === void 0 ? void 0 : next.token)),
                React__default.createElement(Card, null,
                    React__default.createElement(PreviousNextBody, null,
                        (next === null || next === void 0 ? void 0 : next.profile_pic) &&
                            React__default.createElement(PreviousNextBodyAvatar, null,
                                React__default.createElement(Img$1, { src: next === null || next === void 0 ? void 0 : next.profile_pic, alt: (_e = next === null || next === void 0 ? void 0 : next.name) !== null && _e !== void 0 ? _e : 'profilePic' })),
                        React__default.createElement(PreviousNextBodyTitleWrapper, null,
                            (next === null || next === void 0 ? void 0 : next.name) && React__default.createElement(PreviousNextBodyName, null, next === null || next === void 0 ? void 0 : next.name),
                            (next === null || next === void 0 ? void 0 : next.role) && React__default.createElement(PreviousNextBodyRole, null, next === null || next === void 0 ? void 0 : next.role)))))));
};
Queue.defaultProps = {
    backgroundColor: 'transparent',
    previous: {},
    attend: {},
    next: {}
};

const QueueProps = {
  backgroundColor: '#000',
  previous: {},
  attend: {},
  next: {},
};

const QueueCardEle = styled.div `
padding:10px;
`;
const Row = styled.div `
    display: flex;
    align-items: center;
`;
const Avatar = styled.div `
width: 55px;
height: 55px;
border-radius: 6px;
overflow: hidden;
margin-right: 12px;
`;
const Img = styled.img `
max-width: 100%;
height: auto;
`;
const Wrapper = styled.div ``;
const Name$1 = styled.h5 `
margin: 0px;
margin-bottom: 3px;
`;
const Role = styled.span `
font-size: 13px;
color: #9b9595;
font-weight: 500;
`;
const TokenNumber = styled.div `
border-color: #6F6F6F;
border-radius: 4px;
padding:0px 10px;
color:#fff;
background-color: #6F6F6F;
`;
const Divider = styled.hr `
width: 100%;
background-color: #F1F1F1;
margin-bottom: 0px;
border: 1px solid #F1F1F1;
`;

const QueueCard = (props) => {
    const { name, token, role, profile_pic } = props;
    return (React__default.createElement(QueueCardEle, null,
        React__default.createElement(Row, null,
            React__default.createElement(Row, { style: { flex: 1 } },
                profile_pic && (React__default.createElement(Avatar, { id: (props === null || props === void 0 ? void 0 : props.id) + '_avatar' },
                    React__default.createElement(Img, { id: (props === null || props === void 0 ? void 0 : props.id) + '_img', src: profile_pic, alt: name !== null && name !== void 0 ? name : 'profilePic' }))),
                React__default.createElement(Wrapper, null,
                    name && React__default.createElement(Name$1, { id: (props === null || props === void 0 ? void 0 : props.id) + name + '_h6' }, name),
                    role && React__default.createElement(Role, { id: (props === null || props === void 0 ? void 0 : props.id) + role + '_span' }, role))),
            token && React__default.createElement(TokenNumber, { id: (props === null || props === void 0 ? void 0 : props.id) + token + '_div' }, token)),
        React__default.createElement(Divider, null)));
};

const QueueCardProps = {};

const ComponentsLists = [
  {
    catagerie: "layouts",
    list: [
      { name: "Container" },
      { name: "Col" },
      { name: "Row", },
      { name: "Hidden", },
      { name: "Divider", },
      { name: "Paper" },
      { name: "Card", },
      { name: "ButtonGroup" },
      { name: "CardActions" },
      { name: "CardContent" },
      { name: "CardHeader" },
      { name: "CardMedia" },
      { name: "List" },
      { name: "ListItem" },
      { name: "Image" },
      { name: "Dropdown" },
      { name: "Collapse" },
      { name: "Tab" },
      { name: "Tabpanel" },
    ],
  },
  {
    catagerie: "inputs",
    list: [
      { name: "Button", },
      { name: "Select", },
      { name: "Link", },
      { name: "TextInput", },
      { name: "Switch" },
      { name: "Radio" },
      { name: "Checkbox", },
      { name: "DateTimepicker" },
      { name: "MultiSelect" },
      { name: "RangePicker" },
      { name: "Upload" },
      { name: "NewSelect" },
    ]
  },
  {
    catagerie: "Data display",
    list: [
      { name: "Text", },
      { name: "H1", },
      { name: "H2", },
      { name: "H6", },
      { name: "Badge", },
      { name: "Avatar" },
      { name: "Chip" },
    ]
  },
  {
    catagerie: "Feedbacks",
    list: [
      { name: "Alert", },
      { name: "CircularProgress" },
      { name: "Drawer" },
      { name: "Modal" },
      { name: "DialogTitle" },
      { name: "DialogActions" },
      { name: "DialogContent" },
      { name: "TopHeader" },
      { name: "Snackbar" },
      { name: "SideMenu" },
      { name: "Carousel" },
      { name: "BorderLinearProgress" },
      { name: "Table" },
    ]
  },
  {
    catagerie: "New Component's",
    list: [
      { name: "TapSelect" },
      { name: "LocationSearch" },
      { name: "AutoSuggestion" },
      { name: "BackgroundImage" },
      { name: "OtpInput" },
      { name: "WeekCalendar" },
      { name: "Icons" },
      { name: "Div" },
      { name: "MobileNumberWithCode" },
      { name: "Form" },
      { name: "DecisionBox" },
    ]
  }
];

const DecisionBoxComponent = styled.div `
    position:relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: solid 2px;
    transform:rotate(45deg);
    ${(props) => props &&
    css `
      ${(props) => {
        if (props.borderColor) {
            return `
           border-color:${props.borderColor};
           `;
        }
    }}

${props.inLineStyles && { ...props.inLineStyles }}

      `}
`;
const Name = styled.p `
margin:0;
transform: rotate(-45deg);
`;

// This is a Row component
const DecisionBox = (props) => {
    /* this is a props variables */
    return React__default.createElement(DecisionBoxComponent, Object.assign({}, props),
        React__default.createElement(Name, { id: (props === null || props === void 0 ? void 0 : props.id) + 'p' }, props === null || props === void 0 ? void 0 : props.name));
};
// this is a default Props of the component
DecisionBox.defaultProps = {
    borderColor: "#2F44FF",
    name: ''
};

const DecisionBoxProps = {
  borderColor: '#000',
  name: '',
};

const Label = styled.label ``;
const Add = styled.span `
padding:4px 16px;
border-radius:3px;
cursor:pointer;
border:1px solid #2bb9bd;
font-size:14px;
color:#fff;
background-color:#2bb9bd;
margin:0 1em;
display:flex;
margin:auto;
z-index: 100000;
width:max-content;
`;
const SelectEle = styled.ul ``;
const MainDiv = styled.div `
position:relative;
${props => props && css `
:hover{
  .onhovercloseIocn{
display: flex;
  }
}
${(props) => {
    return `
width:${props.width ? props.width + "px" : "100%"};`;
}}
`}
`;
const Lableone = styled.p `
font-size:14px;
font-weight: 500;
margin:0;
${props => props && css `
${props => props.labelStyle ? { ...props.labelStyle } : ''}
`}
`;
styled.span `
position: absolute;
margin-top: -20px;
background: #fff;
padding: 0px 4px;
letter-spacing: 0.4px;
color:#000;
font-size:14px;
${props => props && css `
${(props) => {
    return `
width:${props.labelWidth ? props.labelWidth + "px" : "max-content"};`;
}}
`}
`;
const SelectE = styled.div `
width: 100%;
background-color: #fff;
border-radius: 4px;
padding: 1px;
overflow: hidden;
display: flex;
flex-wrap: wrap;
position: relative;

& input {
font-size: 14px;
box-sizing: border-box;
width: 0;
min-width: 30px;
flex-grow: 1;
border: 0;
margin: 0;
outline: 0;
font-weight: unset;
padding:9.5px 14px;
}
${props => props && css `
${(props) => {
    if (props.size === "small") {
        return `
height: 32px; & input {
padding: 0px 8px 0px 8px;
}
 `;
    }
    else {
        return `
height:40px;
& input {
padding:10.5px 14px;
}
`;
    }
}} 
${(props) => {
    if (!props.disabled && props.error) {
        if (props.variant === "outlined") {
            return `
        border: 1px solid red;
          
       `;
        }
        else if (props.variant === "standard") {
            return `
          border-bottom: 1px solid red;
            border-right:unset;
            border-radius: 0px;
            border-top: 0px;
            border-left:unset;
         `;
        }
        else if (props.variant === "none") {
            return `
            border:0;
            &:focus{
              border:0;
              outline: none;
            }
          `;
        }
    }
}}
    ${(props) => {
    if (!props.disabled && !props.error) {
        if (props.variant === "standard") {
            return `
        border-bottom: 1px solid #9b9b9b;
        border-radius: 0px;
        &:hover {
          border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
                 border-right:unset;
                 border-radius: 0px;
                 border-top: 0px; 
                 border-left:unset;
          }
          
          &.focus {
            border-bottom: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor};
            border-right:unset;
            border-radius: 0px;
            border-top: 0px; 
            border-left:unset;
          }
          
             `;
        }
        else if (props.variant === "outlined") {
            return `
        border:1px solid #9b9b9b;
        &:hover {
          border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor} !important;
          }
          
          &.focus {
            border: 1px solid ${props === null || props === void 0 ? void 0 : props.hoverColor};
          }
          
             `;
        }
    }
}}
  ${props => props.inLineStyles ? { ...props.inLineStyles } : ''}
`}
`;
const Input = styled.input `
font-size: 14px;
color: #000;
font-weight: 400 !important;
`;
const HelperTextCom = styled.p `
margin: 0;
padding: 0px 4px;
font-size: 12px;
${props => props && css `
${props.helperTextStyle && { ...props.helperTextStyle }}
${(props) => {
    if (props.helperTextType === "error") {
        return `
color:red;
`;
    }
    else if (props.helperTextType === "warning") {
        return `
color:#FFCC00;
`;
    }
    else if (props.helperTextType === "success") {
        return `
color:green;
`;
    }
    else {
        return `
color:gray;
`;
    }
}}
`}
`;
const SelectLoader = styled.div `
display: flex;
align-items: center;
flex-direction: column;
overflow: hidden;
z-index: 10000;
margin-left: 33px;
border-top: 3px solid #3498db;

`;
const Div = styled.div `
& .nodata{
  display:flex;
  padding:10px 5px;
  font-size: 14px;
  align-items:center;
  justify-content:justify-content;
  position:absolute;
}`;
const Text = styled.div `
display:flex;
align-items:center;
`;
const Span = styled.span `
padding: 0 12px;
letter-spacing: 0.5px;
line-height: 28px;
& svg {
width:30px;
height:30px;
object-fit:cover;
}
& .nodata{
  display:flex;
  align-items:center;
  justify-content:justify-content;
}
`;
const Close = styled.div `
${props => props && css `
display:none;
${(props) => {
    if (props.size === "medium") {
        return `
margin-top: -28px;
`;
    }
    else {
        return `
margin-top: -24px;
`;
    }
}}
`}
align-items: center;
flex-direction: column;
overflow: hidden;
color: black;
position: relative;
font-weight: 500;
cursor: pointer;
float:right;
margin-right: 12px;
right: 24px;
width: 16px;
height: 16px;
& img {
height: 100%;
width: 100%;
object-fit:cover; 
}
`;
const SelectComponent = styled.div `
font-size: 14px;
width:100%;
white-space: nowrap;
overflow: hidden;
font-weight: 400;
text-overflow: ellipsis;
${props => props && css `
${(props) => {
    if (props.size === "small") {
        return `
padding: 4px 8px;
 `;
    }
    else {
        return `
padding: 7.5px 14px;
`;
    }
}}
${(props) => {
    if (props.value) {
        return `
color: rgba(0,0,0,0.87);
`;
    }
    else {
        return `
color: #aba9a9;
`;
    }
}}
${(props) => {
    if (props.disabled) {
        return `
background:#fafafa;
`;
    }
}}
`}
 `;
const SearchCom = styled.div `
${props => props && css `
${(props) => {
    if (props.size !== "small") {
        return `
top: 52%;
`;
    }
    else {
        return `
top: 52%;
`;
    }
}}
`}
margin-right: 12px;
position: absolute;
display: block;
right: 0px;
width: 16px;
height: 16px;
cursor: pointer;
& img {
height: 100%;
width: 100%;
object-fit: cover;
}
`;
const DownArrow = styled.div `
width:23px;
height:23px;
position: absolute;
right:5px;
top: 50%;
transform: translateY(-50%);
cursor: pointer;
& svg{
  fill:rgb(136 132 132 / 74%);
}
`;
const Star = styled.span `
color:red;
margin-left: 5px;
`;
const Li$1 = styled.li `
list-style-type:none;
&:hover {
background:#eee;
}
& svg{
right:0;
float:right;
margin-top: 10px;
fill:#1890ff;
}
${props => props && css `
 ${props => props.dropdownStyle ? { ...props.dropdownStyle } : ''}
 background:${props => props.active ? '#eee !important' : ''};
 font-weight:${props => props.active ? '500' : ''};
 `}
 `;

const inputListen = (e, addFun, masterSearch) => {
    e.target;
    // eslint-disable-next-line 
    // let splitvalue = value.split(' ');
    if ((e.keyCode === 51 && e.key === '#') || e.keyCode === 16 || e.target) {
        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
            e.preventDefault();
            listView(e, addFun, masterSearch);
        } else {
            cursorGet(e);
        }
    } else {
        if (masterSearch === undefined) {
            document.getElementsByClassName('listDiv')[0].setAttribute('style', `display : none`);
        }
    }
};
const classnameadd = (index) => {
    // document.getElementById("search_check_filter").children[index].className += " start";
    document.getElementById("search_check_filter").getElementsByTagName('li')[index].className += ' qdm-select-options';
};
function listView(e, addFun, masterSearch) {
    let scrollHeight = 0;
    let listCount = 0;
    let setHeight = 0;
    let currentHeight = 0;
    // try{
        if (document.getElementsByClassName("listDiv") && document.getElementsByClassName("listDiv")[0]) {
            scrollHeight = document.getElementsByClassName("listDiv")[0].scrollHeight - document.getElementsByClassName("listDiv")[0].clientHeight;
            listCount = document.getElementsByClassName("listDiv")[0].children[0].childElementCount;
            setHeight = scrollHeight / listCount;
            currentHeight = document.getElementsByClassName("listDiv")[0].scrollTop;
        }
    // }catch(e){
    // }
    // eslint-disable-next-line 
    switch (e.keyCode) {
        case 38: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            if (start && start.previousElementSibling !== null) {
                if (start.previousElementSibling.tagName === 'LI') {
                    start.classList.remove('qdm-select-options');
                    start.classList.add('actives');
                    start.previousElementSibling.classList.remove('actives');
                    start.previousElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.previousElementSibling.previousElementSibling !== null) {
                        start.classList.remove('qdm-select-options');
                        start.classList.add('actives');
                        start.previousElementSibling.previousElementSibling.classList.remove('actives');
                        start.previousElementSibling.previousElementSibling.classList.add('qdm-select-options');
                    }
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow(ul, false);
            }
            let heightList = currentHeight - setHeight;
            document.getElementsByClassName("listDiv")[0].scrollTop = heightList <= 0 ? 0 : heightList;
            break;
        }
        case 40: {
            var start = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options')[0];
            var startList = document.getElementById("search_check_filter").getElementsByClassName('qdm-select-options');
            if (start && start.nextElementSibling !== null) {
                start.classList.remove('qdm-select-options');
                start.classList.add('actives');
                if (start.nextElementSibling.tagName === 'LI') {
                    start.nextElementSibling.classList.remove('actives');
                    start.nextElementSibling.classList.add('qdm-select-options');
                } else {
                    if (start.nextElementSibling.nextElementSibling !== null) {
                        start.nextElementSibling.nextElementSibling.classList.remove('actives');
                        start.nextElementSibling.nextElementSibling.classList.add('qdm-select-options');
                    }
                }
            } else {
                // if(startList.length > 0){
                //     startList[startList.length-1].classList.remove('qdm-select-options');
                // }
                if (startList.length === 0) {
                    classnameadd(0);
                }
            }
            if (masterSearch) {
                let ul = document.getElementById('search_check_filter');
                scrollOverFlow(ul, true);
            }
            document.getElementsByClassName("listDiv")[0].scrollTop = currentHeight + setHeight;
            break;
        }
        // case 13: {
        //     addFun(e);
        //     break;
        // }
    }
}
function cursorGet(e, isreturn) {
    const input = e.target;
    // eslint-disable-next-line 
    const { offsetHeight, offsetLeft, offsetTop, offsetWidth, scrollLeft, scrollTop, selectionStart, value } = input;
    const { paddingRight, lineHeight } = getComputedStyle(input);
    const { x, y } = getCursorXY(input, selectionStart);
    const newLeft = Math.min(
        x - scrollLeft,
        (offsetLeft + offsetWidth) - parseInt(paddingRight, 10)
    );
    let valuecheck = parseInt(lineHeight, 10);
    const newTop = Math.min(
        y - scrollTop,
        (offsetTop + offsetHeight) - (isNaN(valuecheck) !== true ? parseInt(lineHeight, 10) : 0)
    );
    if (isreturn) {
        return {
            left: newLeft - 5,
            top: newTop + 10
        }
    }
    document.getElementsByClassName('listDiv')[0].setAttribute('style', `left: ${newLeft}px; top: ${newTop + 10}px;`);
}
const getCursorXY = (input, selectionPoint) => {
    const {
        offsetLeft: inputX,
        offsetTop: inputY,
    } = input;
    const div = document.createElement('div');
    const copyStyle = getComputedStyle(input);
    for (const prop of copyStyle) {
        div.style[prop] = copyStyle[prop];
    }
    const swap = '.';
    const inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
    const textContent = inputValue.substr(0, selectionPoint);
    div.textContent = textContent;
    if (input.tagName === 'TEXTAREA') div.style.height = 'auto';
    if (input.tagName === 'INPUT') div.style.width = 'auto';
    const span = document.createElement('span');
    span.textContent = inputValue.substr(selectionPoint) || '.';
    div.appendChild(span);
    document.body.appendChild(div);
    // eslint-disable-next-line 
    const { offsetLeft: spanX, offsetTop: spanY } = span;
    document.body.removeChild(div);
    return {
        // x: inputX + spanX,
        x: inputX,
        //   x: inputX + Math.abs(spanX - input.offsetWidth),
        // y: inputY + spanY,
        y: inputY + Math.abs(spanY - input.offsetHeight),
    }
};
const scrollOverFlow = (ul, top) => {
    let start = document.getElementsByClassName('qdm-select-options')[0];
    if (!start) {
        return false;
    }
    let bounding = start.getBoundingClientRect();
    if (top) {
        if (ul.clientHeight < bounding.bottom) {
            ul.scrollTop = ul.scrollTop + start.clientHeight;
        }
    } else {
        let ulBounding = ul.getBoundingClientRect();
        if (ulBounding.top > (bounding.top - 30)) {
            ul.scrollTop = ul.scrollTop - start.clientHeight;
        }
    }
};

// This is a Select component
const Select = (props) => {
    /* this is a props variables */
    const { className, id, options, value, error, inLineStyles, variant, onChange, onChangeValue, onChangeClaer, label, disabled, allowClear = true, width, labelWidth, helperText, size, search, defaultValue, placeholder, isloader, Icon, isloaderIcon, added, onAdd, showArrow, isRequired, labelStyle, hoverColor, getOptionLabel } = props;
    //  end
    // this is a state of handling variables
    const [isactive, setisactive] = React.useState(false);
    const [isfocus, setFocus] = React.useState(false);
    const [inputfocus, setinputfocus] = React.useState(false);
    const [values, setvalues] = React.useState('');
    const [position, setposition] = React.useState({});
    const [getValue, setValue] = React.useState(value);
    const [clientY, setclientY] = React.useState(0);
    //  end
    //  handle clear Value field funcy
    const clearValue = () => {
        onChangeClaer && onChangeClaer('');
        onChangeValue && onChangeValue({});
    };
    // end
    //  handle onFocus field funcy
    const onFocus = (e) => {
        setFocus(true);
        let pos = cursorGet(e, true);
        setposition(Object.assign({}, pos));
    };
    // end
    //  handle onchage field funcy
    const onchageFun = (e) => {
        setvalues(e.target.value);
        setValue(e.target.value);
        onChange && onChange(e);
    };
    // end
    //  handle onBlur field funcy
    const onBlur = () => {
        setFocus(false);
        setinputfocus(false);
        // setclientY(0)
    };
    // end
    // the filter of the data 
    const dataoptions = () => {
        let data = options.filter((val) => ((val === null || val === void 0 ? void 0 : val[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value']) && (val === null || val === void 0 ? void 0 : val[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value'].toLowerCase().includes(values.toLowerCase()))));
        return data;
    };
    // end
    // option data declare
    const optionsData = values && values ? dataoptions() && dataoptions() : options;
    // end
    //  handle added new data funcy
    const onAdded = (v) => {
        onAdd && onAdd(v);
        setisactive(!isactive);
        setvalues("");
    };
    // end
    const val = (getClass) => {
        var _a;
        let data = options.filter((val) => { var _a; return ((val === null || val === void 0 ? void 0 : val[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value']) && (val === null || val === void 0 ? void 0 : val[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value'].toLowerCase()) === ((_a = getClass === null || getClass === void 0 ? void 0 : getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText.toLowerCase())); });
        if ((_a = getClass === null || getClass === void 0 ? void 0 : getClass[0]) === null || _a === void 0 ? void 0 : _a.innerText) {
            return data === null || data === void 0 ? void 0 : data[0];
        }
    };
    const selectedOption = (e) => {
        var _a;
        let getClass = document.getElementsByClassName('qdm-select-options');
        if (getClass.length > 0) {
            // if (document.getElementsByTagName('input')) {
            //   document.getElementsByTagName('input')[0].blur()
            // }
            if (e.keyCode === 13) {
                // if (val(getClass) && getClass) {
                onChangeValue && onChangeValue(val(getClass));
                // } else {
                //   onChangeValue && onChangeValue({});
                // }
                setisactive(false);
                setinputfocus(false);
                setValue((_a = val(getClass)) === null || _a === void 0 ? void 0 : _a[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value']);
                setvalues("");
            }
            else {
                onChangeValue && onChangeValue({});
            }
            // setoptionValue(value)
            // setValue('');
            // document.getElementsByClassName('inputSearchField')[0].blur();
        }
        else {
            onChangeValue && onChangeValue({});
        }
    };
    const onkeydown = (e) => {
        inputListen(e, selectedOption(e), 1);
    };
    return React.createElement(MainDiv, { id: id, className: className, width: width && width },
        label &&
            React.createElement(Lableone, { id: (props === null || props === void 0 ? void 0 : props.id) + '_p', autoFocus: inputfocus ? inputfocus : props.autoFocus ? props.autoFocus : false, labelWidth: labelWidth && labelWidth, size: size, labelStyle: labelStyle && labelStyle },
                label,
                isRequired && React.createElement(Star, null, "*")),
        React.createElement(SelectE, { id: (props === null || props === void 0 ? void 0 : props.id) + '_sub_div', size: size, disabled: disabled, variant: variant, hoverColor: hoverColor, error: error, inLineStyles: inLineStyles, style: {
                borderColor: inputfocus ? hoverColor : ''
            } },
            " ",
            !inputfocus && React.createElement(React.Fragment, null,
                React.createElement(SelectComponent, { id: (props === null || props === void 0 ? void 0 : props.id) + '_div', helperTextType: props.helperTextType && props.helperTextType, value: props.value && props.value, disabled: props.disabled && props.disabled, size: size && size, onClick: (e) => {
                        !disabled && setinputfocus(true);
                        !disabled && setisactive(true);
                        setclientY(e.clientY);
                    } }, (!inputfocus) && (value ? value : defaultValue ? defaultValue : placeholder))),
            inputfocus && React.createElement(Input, Object.assign({}, props, { onChange: e => onchageFun(e), autoFocus: true, onFocus: (e) => onFocus(e), onBlur: onBlur, value: defaultValue ? defaultValue : getValue, id: (props === null || props === void 0 ? void 0 : props.id) + '_input', className: "", onKeyDown: e => onkeydown(e), autoComplete: "off" })),
            showArrow &&
                React.createElement(DownArrow, { id: (props === null || props === void 0 ? void 0 : props.id) + '_arrow_div', onClick: (e) => {
                        !disabled && setinputfocus(true);
                        !disabled && setisactive(true);
                        setclientY(e.clientY);
                    } },
                    React.createElement("svg", { id: (props === null || props === void 0 ? void 0 : props.id) + '_arrow_svg', className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" },
                        React.createElement("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" })))),
        React.createElement(Label, { id: (props === null || props === void 0 ? void 0 : props.id) + '_label' },
            search && React.createElement(SearchCom, { helperTextType: props.helperTextType && props.helperTextType, size: props.size && props.size },
                "     ",
                React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "search", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                    React.createElement("path", { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" }))),
            ((allowClear) && (value)) && React.createElement(Close, { size: size && size, helperTextType: props.helperTextType && props.helperTextType, onClick: () => clearValue(), className: "qdm-select-loader onhovercloseIocn" }, Icon ? Icon : React.createElement("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "close-circle", width: "1em", height: "1em", fill: "#b5b5b5bd", "aria-hidden": "true" },
                React.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" }))),
            ((helperText) && (props === null || props === void 0 ? void 0 : props.error)) && (React.createElement(HelperTextCom, { error: props.error && props.error, size: props.size && props.size, helperTextStyle: props.helperTextStyle && props.helperTextStyle, helperTextType: props.helperTextType && props.helperTextType }, helperText && helperText))),
        !isloader && !(optionsData === null || optionsData === void 0 ? void 0 : optionsData.length) ? isactive && React.createElement(React.Fragment, null, (inputfocus) ? React.createElement(Div, { className: "qdm-select-div nodata" },
            " ",
            added && React.createElement(Add, { onMouseDown: () => onAdded(values) }, "Add"),
            " ",
            React.createElement(Span, null,
                React.createElement("svg", { width: "184", height: "152", viewBox: "0 0 184 152", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
                        React.createElement("g", { transform: "translate(24 31.67)" },
                            React.createElement("ellipse", { "fill-opacity": ".8", fill: "#F5F5F7", cx: "67.797", cy: "106.89", rx: "67.797", ry: "12.668" }),
                            React.createElement("path", { d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z", fill: "#AEB8C2" }),
                            React.createElement("path", { d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z", fill: "url(#linearGradient-1)", transform: "translate(13.56)" }),
                            React.createElement("path", { d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#F5F5F7" }),
                            React.createElement("path", { d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z", fill: "#DCE0E6" })),
                        React.createElement("path", { d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z", fill: "#DCE0E6" }),
                        React.createElement("g", { transform: "translate(149.65 15.383)", fill: "#FFF" },
                            React.createElement("ellipse", { cx: "20.654", cy: "3.167", rx: "2.849", ry: "2.815" }),
                            React.createElement("path", { d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" })))),
                " No data found ")) : "") : React.createElement(Div, { id: (props === null || props === void 0 ? void 0 : props.id) + '_label_div' },
            React.createElement(Div, { className: 'listDiv', style: {
                    transform: ((window.innerHeight - clientY) < 230) ? 'rotateX( -180deg)' : '',
                    transformOrigin: ((window.innerHeight - clientY) < 230) ? '-20px -20px' : '',
                    zIndex: 99999
                } }, (isfocus && isactive) && React.createElement(SelectEle, { className: "qdm-select-div", id: 'search_check_filter' }, isloader ? React.createElement(Text, null,
                React.createElement(SelectLoader, { className: isloaderIcon ? "" : "qdm-select-loader" }),
                React.createElement(Span, null,
                    React.createElement(Span, { className: isloaderIcon ? "own-qdm-select-loader" : "" },
                        isloaderIcon,
                        "Loading..."))) : React.createElement(React.Fragment, null,
                optionsData.map((opt_) => {
                    return (opt_ && (opt_ === null || opt_ === void 0 ? void 0 : opt_[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value'])) &&
                        React.createElement(Li$1, { style: {
                                transform: ((window.innerHeight - clientY) < 230) ? 'rotateX( -180deg)' : '',
                                transformOrigin: ((window.innerHeight - clientY) < 230) ? '0em 16px' : ''
                            }, key: opt_ === null || opt_ === void 0 ? void 0 : opt_[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value'], active: value === (opt_ === null || opt_ === void 0 ? void 0 : opt_[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value']) ? true : false, dropdownStyle: props.dropdownStyle && props.dropdownStyle, className: "actives", onMouseDown: () => {
                                onChangeValue && onChangeValue(opt_);
                                setisactive(!isactive);
                                setValue(opt_ === null || opt_ === void 0 ? void 0 : opt_[getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : 'value']);
                                setvalues("");
                            } }, getOptionLabel ? opt_[getOptionLabel] : opt_.value);
                    /* end */
                }),
                ((optionsData.length === 0) && (inputfocus)) ? React.createElement(Span, { className: "nodata" },
                    " ",
                    added && React.createElement(Add, { onMouseDown: () => onAdded(values) }, "Add"),
                    " ",
                    React.createElement("svg", { width: "184", height: "152", viewBox: "0 0 184 152", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
                            React.createElement("g", { transform: "translate(24 31.67)" },
                                React.createElement("ellipse", { "fill-opacity": ".8", fill: "#F5F5F7", cx: "67.797", cy: "106.89", rx: "67.797", ry: "12.668" }),
                                React.createElement("path", { d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z", fill: "#AEB8C2" }),
                                React.createElement("path", { d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z", fill: "url(#linearGradient-1)", transform: "translate(13.56)" }),
                                React.createElement("path", { d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#F5F5F7" }),
                                React.createElement("path", { d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z", fill: "#DCE0E6" })),
                            React.createElement("path", { d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z", fill: "#DCE0E6" }),
                            React.createElement("g", { transform: "translate(149.65 15.383)", fill: "#FFF" },
                                React.createElement("ellipse", { cx: "20.654", cy: "3.167", rx: "2.849", ry: "2.815" }),
                                React.createElement("path", { d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" })))),
                    " No data found ") : "")))));
};
// this is a default Props of the component
Select.defaultProps = {
    disabled: false,
    size: "medium",
    helperTextType: "error",
    label: "",
    variant: "outlined",
    placeholder: 'select field',
    isRequired: false,
    showArrow: false,
    hoverColor: '#000',
};

const PopoverEle = styled.div `
  position: relative;
  background: white;
 width:fit-content;
 padding:${(props) => (props.oversize)};
  text-align: left;
  border-radius: 4px;
  font-size:12px;
  box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%),
    0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
    ${(props) => {
    if (props.variant === "outlined") {
        return `
  &:focus {
  color:  #262626;
  }
  `;
    }
    else if (props.variant === "text") {
        return `
  background: transparent;
  background-color: transparent;
  color: #000;
  border: 1px solid transparent !important;
  &:focus {
  color: #000;
  box-shadow: none;
  }
  &:hover {
  background-color: #9b9b9b21;
  }
  `;
    }
    else if (props.variant === "none") {
        return `
border:0;
&:focus{
border:0;
outline: none;
}
`;
    }
    else if (props.variant === 'Contained') {
        return `
      background: blue!important;
      `;
    }
}}
    ${(props) => {
    if (props.anchorOrigin.vertical === "bottom" &&
        props.anchorOrigin.horizontal === "center") {
        return ` 
transform: translate(${props.transform.left - props.transform.width / 2}px, ${0}px);
`;
    }
    else if (props.anchorOrigin.vertical === "top" &&
        props.anchorOrigin.horizontal === "center") {
        return `
transform: translate(${props.transform.left - props.transform.width / 2}px, ${-(props.transform.height +
            props.transform.height +
            10)}px);
`;
    }
    else if (props.anchorOrigin.vertical === "bottom" &&
        props.anchorOrigin.horizontal === "left") {
        return ` 
transform: translate(${props.transform.left - props.transform.width - props.transform.height}px, ${0}px);
`;
    }
    else if (props.anchorOrigin.vertical === "top" &&
        props.anchorOrigin.horizontal === "left") {
        return ` 
transform: translate(${props.transform.left - props.transform.width - props.transform.height}px, ${-(props.transform.height + props.transform.height + 10)}px);
`;
    }
    else if (props.anchorOrigin.vertical === "top" &&
        props.anchorOrigin.horizontal === "right") {
        return `
transform: translate(${props.transform.left - props.transform.height}px, ${-(props.transform.height +
            props.transform.height +
            10)}px);
`;
    }
    else if (props.anchorOrigin.vertical === "bottom" &&
        props.anchorOrigin.horizontal === "right") {
        return `
transform: translate(${props.transform.left - props.transform.height}px, ${0}px);
`;
    }
}}
  
 ${(props) => {
    if (props.backgroundColor) {
        return `
        background-color: ${props === null || props === void 0 ? void 0 : props.backgroundColor};
        border: 1px solid ${props === null || props === void 0 ? void 0 : props.backgroundColor};
          `;
    }
    else {
        return `
        background-color: white;
        border: 1px solid rgb(0, 127, 255);
        `;
    }
}}

  ${(props) => (props.inLineStyles ? { ...props.inLineStyles } : "")}
`;
const Li = styled.li `
  list-style-type: none;
  padding: 4px;
  &:hover {
    background: #eee;
  }
  & svg {
    right: 0;
    float: right;
    margin-top: 10px;
    fill: #1890ff;
  }
  
  ${(props) => props &&
    css `
 ${(props) => (props.listStyle ? { ...props.listStyle } : "")}
 background:${(props) => (props.active ? "#eee !important" : "")};
 font-weight:${(props) => (props.active ? "500" : "")};
 `}
`;
const DivEle = styled.ul `
  cursor: pointer;
  padding: 7px;
  position: absolute;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 10000000 !important;
  background: #fff;
  box-shadow: 0px 1px 3px 2px #21252933;
  margin-top: 5px;
  max-height: 90px;
  font-size: 14px;

  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  ${(props) => {
    if (props.anchorOrigin.vertical === "bottom" &&
        props.anchorOrigin.horizontal === "center") {
        return ` 
transform: translate(${-14}px, ${0}px);
`;
    }
}}
  
`;

// This is a Popover component
const Translate = (props) => {
    /* this is a props variables */
    const { open, children, onClose, options, Icon, onClick } = props;
    const anchorEl = open;
    const onopen = Boolean(open);
    const node = React__default.useRef(null);
    const rect = onopen && anchorEl;
    const [dropdown, setDropDown] = React__default.useState(false);
    const [active, setActive] = React__default.useState({
        label: '', value: ''
    });
    if (onopen) {
        document.body.style.overflow = "hidden";
    }
    else {
        document.body.style.overflow = "auto";
    }
    function handleClick(e) {
        var _a;
        if ((_a = node === null || node === void 0 ? void 0 : node.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            // inside click
            return;
        }
        // outside click
        setDropDown(false);
    }
    const handleChange = (e) => {
        // setDropDown(!dropdown);
        setDropDown(false);
        // props.handleChange(opt_);
        onClick && onClick(e);
    };
    React__default.useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);
    return (React__default.createElement(PopoverEle, Object.assign({ ref: node }, props, { open: true, transform: onopen && rect, onClick: (e) => {
            setDropDown(!dropdown);
            onClick && onClick(e);
            // handleChange() && handleChange(e)
        } }),
        React__default.createElement("div", { style: {
                //  width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } }, props.variant === 'Contained' ? React__default.createElement("img", { width: "18", height: "18", src: "https://img.icons8.com/metro/26/ffffff/google-translate.png" }) : Icon ? Icon : React__default.createElement("svg", { focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", "data-testid": "TranslateIcon", width: "12", height: "12", fill: "rgb(0, 127, 255)" },
            React__default.createElement("path", { d: "m12.87 15.07-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7 1.62-4.33L19.12 17h-3.24z" }))),
        dropdown && (React__default.createElement(DivEle, { anchorOrigin: props === null || props === void 0 ? void 0 : props.anchorOrigin }, options &&
            options.map((opt_) => {
                return (React__default.createElement(Li, Object.assign({}, props.listStyle, { active: props.value === (opt_ === null || opt_ === void 0 ? void 0 : opt_["value"]) || (active === null || active === void 0 ? void 0 : active.value) === (opt_ === null || opt_ === void 0 ? void 0 : opt_["value"]) ? true : false, onClick: (e) => {
                        setActive(opt_);
                        // setDropDown(false);
                        // props.handleChange(opt_);
                        // onClick && onClick(e);
                        handleChange && handleChange(e);
                    } }), opt_ === null || opt_ === void 0 ? void 0 : opt_.label));
            })))));
};
// this is a default Props of the component
Translate.defaultProps = {
    children: "Popover",
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    horizontal: "left",
    vertical: "bottom",
    variant: "outlined",
    oversize: '6px 12px'
};

const TranslateProps = {
  children: '',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  horizontal: ['left', 'right', 'center'],
  vertical: ['bottom', 'top'],
  variant: ['text', 'outlined', 'none', 'Contained'],
  Icon: '',
  oversize: ''
};

const StyledImage = styled.img `

${(props) => {
    if (props.size === "small") {
        return `
            width:50%;
            height:50%;
`;
    }
    else if (props.size === "medium") {
        return `
            width:75%;
            height:75%;
`;
    }
    else if (props.size === "large") {
        return `
            width:100%;
            height:100%;
`;
    }
    else if (typeof props.size === "number") {
        return `
&::before{
font-size:${props === null || props === void 0 ? void 0 : props.size}px !important;
}
`;
    }
}} 
${props => props && css `

${props.inLineStyles && { ...props.inLineStyles }}
`}

`;

// This a Image component
const QRscan = (props) => {
    /* this is a props variables */
    const { payload, alt } = props;
    return React.createElement(StyledImage, Object.assign({ id: props === null || props === void 0 ? void 0 : props.id }, props, { src: `https://api.qrserver.com/v1/create-qr-code/?size=170x170&data=${payload}` }));
};
// this is a default Props of the component
QRscan.defaultProps = {
    alt: "QRimage",
    payload: "https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg",
    size: 'large'
};

const QRscanProps = {
  alt: '',
  disabled: false,
  payload: '',
  size: ['small', 'medium', 'large'],
};

const LinkEle = styled.a `
color: #3f51b5;
margin: 0 0.5em;
cursor:pointer;
&:hover{
text-decoration: underline;
}`;

// This is a Link component
const RouteLink = (props) => {
    const { children, name } = props;
    return (React__default.createElement(LinkEle, Object.assign({}, props), children ? children : name));
};
// this is a default Props of the component
RouteLink.defaultProps = {
    to: ''
};

const RouteLinkProps = {
    to: ''
};

const IFRAME = styled.iframe `
${(props) => {
    if (props.width) {
        return `
      width:${props.width}`;
    }
    else if (props.height) {
        return `
            height:${props.height}`;
    }
}}
    ${props => props && css `
    ${props.inLineStyles && { ...props.inLineStyles }}
    `}
`;

// This is a Iframe component
const Iframe = (props) => {
    /* this is a props variables */
    const { src } = props;
    return (React__default.createElement(IFRAME, Object.assign({}, props, { src: src })));
};
// this is a default Props of the component
Iframe.defaultProps = {
    width: '100%',
    height: '100%',
    src: "https://www.youtube.com/embed/tgbNymZ7vqY"
};

const IframeProps = {
  src: ''
};

const AinqaFlex = (props) => {
    var _a, _b, _c;
    const pivot = React__default.useRef([]);
    const [dataload, setDataload] = React__default.useState(false);
    const [loaded, setLoaded] = React__default.useState([]);
    const [foottrim, setFoottrim] = React__default.useState("");
    const [reporttype, setReporttype] = React__default.useState("");
    const [jrxmlread, setJrxmlread] = React__default.useState("");
    const [errorhandle, setErrorhandle] = React__default.useState(true);
    console.log("ainqaflex props", props);
    const onReportComplete = () => {
        // console.log(">>>>", pivot.current.flexmonster.getReport());
    };
    // console.log("props",JSON.parse(props.inputparams));
    React__default.useEffect(() => {
        var _a, _b, _c;
        var temp = props.inputparams
            .split("[")
            .join("")
            .split("{")
            .join("")
            .split("}")
            .join("")
            .split("]")
            .join("")
            .split(":")
            .join(",")
            .split(",");
        var tempobj = [];
        // console.log(temp);
        temp.map((e, index) => {
            // console.log(index % 2 === 0);
            return (index % 2 === 0) &&
                (tempobj.push({
                    [e]: temp[index + 1] === "true"
                        ? true
                        : temp[index + 1] === "false"
                            ? false
                            : temp[index + 1],
                }));
        });
        console.log(tempobj);
        if (((_a = props === null || props === void 0 ? void 0 : props.reportid) === null || _a === void 0 ? void 0 : _a.length) !== 0 && ((_b = props.apiurl) === null || _b === void 0 ? void 0 : _b.length) !== 0) {
            if (((_c = props === null || props === void 0 ? void 0 : props.reportid) === null || _c === void 0 ? void 0 : _c.length) !== 0) {
                setDataload(true);
            }
            var temp1 = {
                db_name: "QDM_Platform",
                entity: "QDMReports",
                filter: `QDMReports.reportid=='${props === null || props === void 0 ? void 0 : props.reportid}'`,
                return_fields: "QDMReports",
            };
            axios({
                method: "post",
                url: `${props === null || props === void 0 ? void 0 : props.apiurl}/read_documents`,
                headers: { "Content-Type": "application/json" },
                data: temp1,
            })
                .then((res) => {
                var _a, _b;
                setReporttype(res.data.result[0].reporttype);
                setJrxmlread(res.data.result[0].jrxmltemplate);
                res.data.result[0] && setLoaded(res.data.result);
                var footertrim = [];
                var assigned = res.data.result[0].fmheadfoot;
                // console.log( Object.keys(assigned).length!==0)
                if (((_a = Object.keys(assigned)) === null || _a === void 0 ? void 0 : _a.length) !== 0) {
                    footertrim = res.data.result[0].fmheadfoot.footer.split("<d");
                    setFoottrim(footertrim);
                }
                var norfilter;
                if (((_b = props === null || props === void 0 ? void 0 : props.reportid) === null || _b === void 0 ? void 0 : _b.length) !== 0) {
                    var filtertest = JSON.parse(res.data.result[0].readquery);
                    var splitq = filtertest.filter;
                    if (filtertest.filter !== undefined) {
                        Object.keys(filtertest.filter).map((e) => {
                            //getting filter key values
                            // var newsplits=query.split("@").join(" ").split(" ");
                            return (norfilter = (splitq[e].indexOf("@")));
                        });
                    }
                    if (filtertest.filter !== undefined && props.inputparams.length !== 0 && norfilter !== -1) {
                        // var jsonparse = JSON.parse(res.data.result[0].readquery);
                        // var splitquery = jsonparse.filter.split("@");
                        // var newsplit = splitquery.join(" ");
                        // var finalsplit = newsplit.split(" ");
                        // let inputparams: { [x: string]: any; };
                        // inputparams=JSON.parse(props.inputparams);
                        // console.log(inputparams);
                        // finalsplit.map((e: string | number,index: string | number) => {
                        //   return (
                        //     inputparams[e] !== undefined &&
                        //     (finalsplit[index] = inputparams[e])
                        //   );
                        // });
                        // var finalreadquery = finalsplit.join(" ");
                        // var filteradd = {
                        //   filter: finalreadquery,
                        // };
                        // Object.assign(jsonparse, filteradd);
                        /////////////////////////////////////////////////////////////////
                        // var jsonparse = JSON.parse(res.data.result[0].readquery);
                        // var splitquery=jsonparse.filter;
                        // var splitquerykey=Object.keys(splitquery)
                        // var final=[] as any;
                        // splitquerykey.map((e:any)=>{
                        //   // console.log(e);//e for query 
                        //   var querys=splitquery[e];//getting filter key values
                        //   // console.log(querys);
                        //   var newsplit=querys.split("@").join(" ").split(" ");
                        //   // console.log(newsplit);
                        //   newsplit.map((x: string,index: string | number)=>{
                        //    var inputsplit=JSON.parse(props.inputparams)
                        //     return(inputsplit.map((v: { [x: string]: any; })=>{
                        //       var inputkeys=Object.keys(v);
                        //       return(inputkeys.map((b)=>{  
                        //        //  console.log(newsplit[bindex]===b,b,newsplit[bindex],inputsplit[eindex][b])
                        //       //  console.log("newsplit",x===b,v[b],x=v[b])
                        //         // console.log(newsplit[index]=v[b]);
                        //      return(x===b && (newsplit[index]=v[b]))
                        //     }))
                        //   }))
                        //     })
                        //   return final.push(newsplit.join(""))
                        // })
                        // var filter={
                        // }
                        // final.map((e: { [x: string]: any; },eindex: string | number)=>{
                        //   return(
                        //   splitquerykey.map((v,vindex: string | number)=>{
                        //    return(eindex===vindex && Object.assign(filter,{[v]:e}))
                        //     }))
                        //   })
                        //   delete jsonparse.filter
                        //   Object.assign(jsonparse,filter);
                        //   console.log(filter,jsonparse)
                        /////////////////////////////////////////////////////////////////////////////////////////
                        var jsonparse = JSON.parse(res.data.result[0].readquery);
                        var splitquery = jsonparse.filter;
                        var final = [];
                        var splitquerykey = Object.keys(splitquery);
                        splitquerykey.map((e) => {
                            var querys = splitquery[e]; //getting filter key values
                            console.log(querys);
                            var newsplit = querys.split("@").join(" ").split(" ");
                            console.log(newsplit);
                            tempobj.map((i) => {
                                return (newsplit.map((v, vindex) => {
                                    return (i[v] !== undefined && (newsplit[vindex] = i[v]));
                                }));
                                // console.log("final",newsplit);
                            });
                            return final.push(newsplit);
                        });
                        var filter = {};
                        final.map((e, index) => {
                            return final[index] = e.join(" ");
                        });
                        console.log(final);
                        splitquerykey.map((e, index) => {
                            console.log(e);
                            return Object.assign(filter, { [e]: final[index] });
                        });
                        Object.assign(jsonparse.filter, filter);
                        console.log("final filter", jsonparse);
                    }
                    else {
                        jsonparse = JSON.parse(res.data.result[0].readquery);
                    }
                    delete res.data.result[0].template.dataSource;
                    axios({
                        method: "post",
                        url: `${props.apiurl}/read_documents`,
                        headers: { "Content-Type": "application/json" },
                        data: jsonparse,
                    })
                        .then((response) => {
                        var _a;
                        var data = [];
                        var newdata = [];
                        var nomap = [];
                        var template = res.data.result[0].template;
                        var dataSource = {
                            dataSource: { data: response.data.result, type: "json" },
                        };
                        var fmrenderlen = res.data.result[0].fmrender;
                        if (((_a = Object.keys(fmrenderlen)) === null || _a === void 0 ? void 0 : _a.length) !== 0)
                            res.data.result[0].fmrender.map((e) => {
                                data = e.columnvalue.split("/{");
                                data.map((e) => {
                                    var len = e === null || e === void 0 ? void 0 : e.length;
                                    return e[len - 1] === "}"
                                        ? newdata.push(e.slice(0, len - 1))
                                        : nomap.push(e);
                                });
                                data = [];
                                newdata.map((e) => data.push(e.replace(/{/g, "")));
                                // console.log("final data", newdata);
                                var columnName = e.columnName;
                                var columnType = "string";
                                var currentData = dataSource.dataSource.data;
                                currentData[0][columnName] = { type: columnType };
                                return currentData.map((v) => {
                                    // console.log(data.length, "length of data");
                                    var sampltemp = [];
                                    var valuemap = [];
                                    valuemap = data ? data : newdata;
                                    return valuemap.map((g) => {
                                        // console.log("data as e", v[e]);
                                        var teemp = v[g];
                                        sampltemp.push(teemp);
                                        // console.log("concat", sampltemp.join());
                                        // console.log("nomap value", nomap.join("/"));
                                        var display;
                                        // console.log(nomap.length);
                                        if ((nomap === null || nomap === void 0 ? void 0 : nomap.length) === 1) {
                                            display = nomap + "/" + sampltemp.join("/");
                                        }
                                        else {
                                            display = nomap.join("/") + sampltemp.join("/");
                                        }
                                        var store = {
                                            [columnName]: display,
                                        };
                                        return Object.assign(v, store);
                                        // console.log("urlssss", v);
                                    });
                                });
                            });
                        // console.log("render-values", render);
                        var result = {};
                        result = Object.assign(template, dataSource);
                        // console.log("final result", result, result);
                        setDataload(false);
                        pivot.current.flexmonster.setReport(result);
                    })
                        .catch((err) => {
                        console.error(err);
                    });
                }
            })
                .catch((err) => {
                console.error(err);
            });
            setErrorhandle(false);
        }
        else {
            setErrorhandle(true);
        }
    }, [props.reportid, props.apiurl, props.inputparams]);
    /////function for flexmonster toolbar icons/////
    function customizeToolbar(toolbar) {
        let tabs = toolbar.getTabs();
        toolbar.getTabs = function () {
            tabs = tabs.filter((tab) => tab.id !== "fm-tab-connect" &&
                tab.id !== "fm-tab-save" &&
                tab.id !== "fm-tab-open");
            // console.log("data is loaded", loaded);
            // menu: [
            //   {
            //     id: "fm-tab-add-column",
            //     title: "Add Column",
            //     icon: "<img src='https://img.icons8.com/small/30/000000/add.png' style='place-self:center;margin:3.5px 0' alt='Add' />",
            //   },
            // ],
            let exportTab = tabs.find((tab) => tab.id === "fm-tab-export");
            if (!exportTab)
                return tabs;
            let exportToPdfTab = exportTab.menu.find((tab) => tab.id === "fm-tab-export-pdf");
            if ((loaded === null || loaded === void 0 ? void 0 : loaded.length) !== 0)
                exportToPdfTab.handler = () => {
                    // setDiaforpdf(true);
                    pivot.current.flexmonster.exportTo("pdf", {
                        header: loaded[0].fmheadfoot.header,
                        footer: loaded[0].fmheadfoot.footer,
                        pageOrientation: loaded[0].fmheadfoot.pageOrientation,
                    });
                };
            return tabs;
        };
    }
    // const customizeCellFunction = () => {
    //   console.log("called");
    //   pivot.current.flexmonster.customizeCell((cell, data) => {
    //     if (
    //       !(
    //         (data.hierarchy && data.hierarchy.uniqueName === "url") ||
    //         data.hierarchy.uniqueName === "image" ||
    //         data.hierarchy.uniqueName === "activestatus" ||
    //         data.hierarchy.uniqueName === "updatedby"
    //       )
    //     )
    //       return;
    //     else if (data.hierarchy && data.hierarchy.uniqueName === "url") {
    //       let newText = `<a href=${data.label} class="link" target='_blank'>${data.escapedLabel}</a>`;
    //       if (data.type === "value") {
    //         cell.style["z-index"] = 1;
    //         cell.text = newText;
    //       }
    //     } else if (
    //       data.hierarchy &&
    //       data.hierarchy.uniqueName === "activestatus"
    //     ) {
    //       if (data.label === "false") {
    //         //event function definition is declared in index.html file
    //         let newText = `${data.label} <button onclick="buttonclick(event)" class="buttonstyle" value=${data.label} >change</button>`;
    //         // `<button onchange="buttonclick(event)">change</button>`;
    //         if (data.type === "value") {
    //           cell.style["z-index"] = 3;
    //           cell.text = newText;
    //         }
    //       }
    //     } else if (data.hierarchy && data.hierarchy.uniqueName === "updatedby") {
    //       let newText = `<input type="checkbox" name="checkbox" onchange="onCheck(event)">Value</input>`;
    //       if (data.type === "value") {
    //         cell.style["z-index"] = 1;
    //         cell.text = newText;
    //       }
    //     } else {
    //       //event function definition is declared in index.html file
    //       let newText = `<a href=${data.label} class="image" target="_blank"}><img src=${data.label} width="60px" height="50px" alt="this is image"></img></a>
    //       <input type="checkbox" name="checkbox" onchange="onCheck(event)">Value</input>`;
    //       if (data.type === "value") {
    //         cell.style["z-index"] = 1;
    //         cell.text = newText;
    //       }
    //     }
    //   });
    // };
    // function save() {
    //   var temp = {};
    //   temp = pivot.current.flexmonster.getReport({
    //     withGlobals: true,
    //   });
    //   delete temp.dataSource;
    //   var dataSource = { dataSource: { data: [], type: "json" } };
    //   var result = {};
    //   result = Object.assign(temp, dataSource);
    //   console.log("function called", result);
    //   var datas = [
    //     {
    //       db_name: "Vectras01",
    //       entity: "reports",
    //       is_metadata: false,
    //       doc: {
    //         result,
    //       },
    //     },
    //   ];
    //   var config = {
    //     method: "post",
    //     url: "http://164.52.210.54:8080/api/upsert_document",
    //     header: { "Content-Type": "application/json" },
    //     data: datas,
    //   };
    //   axios(config)
    //     .then((res) => {
    //       console.log(res.status);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // }
    // const update = () => {
    //   console.log("called update", jsondata[0]);
    //   pivot.current.flexmonster.updateData({ data: jsondata });
    // };
    // console.log("dataload", foottrim);
    try {
        return (
        // errorhandle ? <div><p>Your seeing this error because of reportid, apiurl fields was not defined or the fields was not filled</p> </div>:
        React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", null,
                errorhandle && React__default.createElement("p", null, "Enter the Reportid and apiurl to view report"),
                reporttype === "jasper" ? (React__default.createElement("div", null,
                    React__default.createElement("textarea", { value: jrxmlread, rows: 35, cols: 165 }))) : (React__default.createElement("div", null,
                    dataload && (React__default.createElement("p", { style: { display: "flex", justifyContent: "center" } }, "Please wait while the data is loading")),
                    !dataload && ((_a = props.reportid) === null || _a === void 0 ? void 0 : _a.length) !== 0 && (React__default.createElement("div", null,
                        (loaded === null || loaded === void 0 ? void 0 : loaded.length) !== 0 && ((_b = Object.keys(loaded[0].fmheadfoot)) === null || _b === void 0 ? void 0 : _b.length) !== 0 && (React__default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: `${loaded[0].fmheadfoot.header}`,
                            } })),
                        React__default.createElement(FlexmonsterReact.Pivot, { ref: pivot, toolbar: true, width: "100%", height: 600, reportcomplete: onReportComplete, beforetoolbarcreated: customizeToolbar }),
                        (loaded === null || loaded === void 0 ? void 0 : loaded.length) !== 0 && ((_c = Object.keys(loaded[0].fmheadfoot)) === null || _c === void 0 ? void 0 : _c.length) !== 0 && (React__default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: `${foottrim[0]}`,
                            } })))))))));
    }
    catch (error) {
        console.log(error);
        return (React__default.createElement("div", { style: {
                position: "absolute",
                transform: "translate(-50%, -50%)",
                left: "50%",
                top: "50%",
            } },
            React__default.createElement("h1", { style: { color: "red" } }, "There is error displaying details in this page")));
    }
};
AinqaFlex.defaultProps = {
    reportid: "",
    apiurl: "",
    inputparams: ""
};

const AinqaFlexProps = {
  reportid: '',
  apiurl: '',
  inputparams: '',
};

export { AinqaFlex, AinqaFlexProps, Alert, AlertProps, AutoSuggestion, AutoSuggestionProps, Avatar$2 as Avatar, AvatarProps, BackgroundImage, BackgroundImageProps, Badge, BadgeProps, BorderLinearProgress, BorderLinearProgressProps, Breadcrumb, BreadcrumbItem, BreadcrumbItemsProps, BreadcrumbProps, Button$4 as Button, ButtonGroup, ButtonGroupProps, ButtonProps, Card$1 as Card, CardActions, CardActionsProps, CardContent, CardContentProps, CardHeader, CardHeaderProps, CardMedia, CardMediaProps, CardProps, Carousel, CarouselProps, Checkbox$2 as Checkbox, CheckboxProps, Chip, ChipProps, CircularProgress, CircularProgressProps, Col, ColProps, Collapse, CollapseProps, ComponentsLists, Container$1 as Container, ContainerProps, DataTable, DataTableProps, DateTimepicker, DateTimepickerProps, DecisionBox, DecisionBoxProps, DialogActions, DialogActionsProps, DialogContent, DialogContentProps, DialogTitle, DialogTitleProps, Div$c as Div, DivProps, Divider$3 as Divider, DividerProps, Drawer, DrawerProps, Dropdown$1 as Dropdown, DropdownProps, Floating, FloatingProps, Form, FormProps, H1, H1Props, H2, H2Props, H6, H6Props, Hidden, HiddenProps, Icons, IconsProps, Iframe, IframeProps, Image, ImageProps, Link, LinkProps, List$1 as List, ListItem, ListItemProps, ListProps, LocationSearch, LocationSearchProps, MobileNumberWithCode, MobileNumberWithCodeProps, Modal, ModalProps, MonthCalendar, MonthCalendarProps, MultiSelect, MultiSelectProps, MultipleSelect, MultipleSelectProps, OldSelect, OtpInput, OtpInputProps, Overlay, OverlayProps, Paper, PaperProps, Popconfirm, PopconfirmProps, Popover, PopoverProps, QRscan, QRscanProps, Queue, QueueCard, QueueCardProps, QueueProps, Radio, RadioProps, RangePicker, RangePickerProps, Rating, RatingProps, RouteLink, RouteLinkProps, Row$4 as Row, RowProps, Select, SelectProps, SideMenu, SidebarProps, Snackbar, SnackbarProps, Stepper, StepperProps, Switch, SwitchProps, Tab, TabProps, Table, TableProps, Tabpanel, TabpanelProps, TapSelect, TapSelectProps, TermsAndConditions, TermsAndConditionsProps, Text$6 as Text, TextArea, TextAreaProps, TextInput, TextInputProps, TextProps, Theme, Tooltip, TooltipProps, TopHeader$1 as TopHeader, TopHeaderProps, TopSelect, TopSelectProps, Translate, TranslateProps, Upload, UploadProps, WeekCalendar, WeekCalendarProps };
